import * as i2 from '@azavista/components/shared';
import { CriteriaRelationOperator, sortAlphabetically, pick, TimeType, AzavistaSharedModule } from '@azavista/components/shared';
import * as i0 from '@angular/core';
import { Injectable, Inject, Component, ChangeDetectionStrategy, EventEmitter, Output, Input, ViewChild, ViewChildren, NgModule } from '@angular/core';
import { firstValueFrom, Subject, asapScheduler } from 'rxjs';
import * as i12$1 from '@angular/cdk/drag-drop';
import { moveItemInArray, transferArrayItem, CdkDropList, DragDropModule } from '@angular/cdk/drag-drop';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import bsonObjectId from 'bson-objectid';
import * as i4 from '@angular/common';
import * as i6 from '@ngx-translate/core';
import * as i4$1 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import * as i6$1 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import { takeUntil } from 'rxjs/operators';
import { fieldType } from '@azavista/advanced-search';
import * as i2$1 from '@azavista/components/filter-criteria-tree';
import { flatSearchParamsToFilterTree, filterTreeToFlatSearchParams, AzavistaFilterCriteriaTreeModule } from '@azavista/components/filter-criteria-tree';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i7 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i7$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i5$1 from '@angular/forms';
import * as i9 from '@angular/material/checkbox';
import * as i10 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i11 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i12 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i15 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i16 from '@azavista/components/duration';
import { AzavistaDurationModule } from '@azavista/components/duration';
import * as i10$1 from '@angular/material/menu';
import * as i13 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i15$1 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
function AzavistaFlowStepAddNewComponent_ng_container_6_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 3);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepAddNewComponent_ng_container_6_azavista_input_field_1_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onActionTypeValueChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("field", ctx_r1.actionTypeField)("label", i0.ɵɵpipeBind1(1, 6, "ACTION_TYPE"))("value", ctx_r1.actionTypeFieldValue)("canEdit", true)("editMode", true)("fullWidth", true);
  }
}
function AzavistaFlowStepAddNewComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepAddNewComponent_ng_container_6_azavista_input_field_1_Template, 2, 8, "azavista-input-field", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.actionTypeField);
  }
}
function AzavistaFlowStepFieldMappingAttributeMappingDialogComponent_div_13_azavista_input_field_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "azavista-input-field", 11);
  }
  if (rf & 2) {
    const selectField_r1 = ctx.ngIf;
    const sourceItem_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("field", selectField_r1)("label", selectField_r1.label)("canEdit", false)("value", sourceItem_r2)("fullWidth", true);
  }
}
function AzavistaFlowStepFieldMappingAttributeMappingDialogComponent_div_13_azavista_input_field_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 12);
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepFieldMappingAttributeMappingDialogComponent_div_13_azavista_input_field_7_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const sourceItem_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.updateMapping(sourceItem_r2, $event.value));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectField_r5 = ctx.ngIf;
    const sourceItem_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("field", selectField_r5)("label", selectField_r5.label)("editMode", true)("canEdit", true)("value", ctx_r3.combinedMapping[sourceItem_r2])("fullWidth", true);
  }
}
function AzavistaFlowStepFieldMappingAttributeMappingDialogComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, AzavistaFlowStepFieldMappingAttributeMappingDialogComponent_div_13_azavista_input_field_2_Template, 1, 5, "azavista-input-field", 9);
    i0.ɵɵpipe(3, "apply");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-icon");
    i0.ɵɵtext(5, "keyboard_double_arrow_right");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 3);
    i0.ɵɵtemplate(7, AzavistaFlowStepFieldMappingAttributeMappingDialogComponent_div_13_azavista_input_field_7_Template, 1, 6, "azavista-input-field", 10);
    i0.ɵɵpipe(8, "apply");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(3, 2, ctx_r3.data.sourceField, ctx_r3.getSingleSelectField));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(8, 5, ctx_r3.data.targetField, ctx_r3.getSingleSelectField));
  }
}
function AzavistaFlowStepFieldMappingItemComponent_azavista_input_field_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 5);
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepFieldMappingItemComponent_azavista_input_field_2_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectSourceField($event.value));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", ctx_r1.sourceColumnConfig == null ? null : ctx_r1.sourceColumnConfig.headerLabel)("value", ctx_r1.sourceFieldAutocomplete.value)("options", ctx_r1.sourceFieldAutocomplete.options)("field", ctx_r1.sourceFieldAutocomplete.field)("editMode", !ctx_r1.readonly)("readonlyMode", ctx_r1.readonly)("fullWidth", true)("layoutDensity", "slim");
  }
}
function AzavistaFlowStepFieldMappingItemComponent_azavista_input_field_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 6);
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepFieldMappingItemComponent_azavista_input_field_6_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectTargetField($event.value));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", ctx_r1.targetColumnConfig == null ? null : ctx_r1.targetColumnConfig.headerLabel)("value", ctx_r1.targetFieldAutocomplete.value)("options", ctx_r1.targetFieldAutocomplete.options)("field", ctx_r1.targetFieldAutocomplete.field)("fullWidth", true)("editMode", !ctx_r1.readonly)("readonlyMode", ctx_r1.readonly)("layoutDensity", "slim");
  }
}
function AzavistaFlowStepFieldMappingItemComponent_azavista_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 7);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function AzavistaFlowStepFieldMappingItemComponent_azavista_button_7_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openAttributeMapping({
        attributeMapping: ctx_r1.attributeMapping
      }));
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "compare_arrows");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "ATTRIBUTE_MAPPING"));
  }
}
function AzavistaFlowStepFieldMappingItemListComponent_div_11_azavista_flat_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 9);
    i0.ɵɵlistener("click", function AzavistaFlowStepFieldMappingItemListComponent_div_11_azavista_flat_button_2_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const index_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.deleteFieldMappingItem(index_r2));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFlowStepFieldMappingItemListComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "azavista-flow-step-field-mapping-item", 7);
    i0.ɵɵlistener("updateMapping", function AzavistaFlowStepFieldMappingItemListComponent_div_11_Template_azavista_flow_step_field_mapping_item_updateMapping_1_listener($event) {
      const index_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.updateFieldMappingItem(index_r2, $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, AzavistaFlowStepFieldMappingItemListComponent_div_11_azavista_flat_button_2_Template, 3, 0, "azavista-flat-button", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const index_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("readonly", ctx_r2.readonly)("sourceFields", ctx_r2.sourceFields)("targetFields", ctx_r2.targetFields)("sourceColumnConfig", ctx_r2.sourceColumnConfig)("targetColumnConfig", ctx_r2.targetColumnConfig)("fieldMatching", ctx_r2.fieldMatching)("existingFieldMapping", ctx_r2.stepConfig.field_mapping)("fieldMappingIndex", index_r2)("data", item_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.readonly);
  }
}
function AzavistaFlowStepFieldMappingItemListComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "azavista-flat-button", 10);
    i0.ɵɵlistener("click", function AzavistaFlowStepFieldMappingItemListComponent_div_12_Template_azavista_flat_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.addNewFieldMapping());
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.addButtonConfig == null ? null : ctx_r2.addButtonConfig.label) || i0.ɵɵpipeBind1(5, 1, "ADD_FIELD_MAPPING"), "");
  }
}
const _c0 = ["offsetSecondsIsPositiveEl"];
const _c1 = () => [];
const _c2 = a0 => ({
  headerLabel: a0
});
function AzavistaFlowStepComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, "ACTION");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function AzavistaFlowStepComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, "QUERY");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function AzavistaFlowStepComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, "TIME");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function AzavistaFlowStepComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, "WAIT_UNTIL_FIELD");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function AzavistaFlowStepComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, "FINISH");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_3_span_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " > ");
    i0.ɵɵelement(2, "azavista-input-field", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("canEdit", false)("fullWidth", false)("value", ctx_r1.step.config == null ? null : ctx_r1.step.config.value)("editMode", false)("field", ctx_r1.currentActionStepField)("options", ctx_r1.getFieldOptions(ctx_r1.currentActionStepField));
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_3_span_1_span_2_Template, 3, 6, "span", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" > ", ctx_r1.currentActionStepField == null ? null : ctx_r1.currentActionStepField.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.value) || (ctx_r1.step.config == null ? null : ctx_r1.step.config.value) === 0);
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_3_span_1_Template, 3, 2, "span", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.config == null ? null : ctx_r1.step.config.field_id);
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" > ", ctx_r1.currentEmailTemplateName, "");
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_4_span_1_Template, 2, 1, "span", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.config == null ? null : ctx_r1.step.config.email_campaign_id);
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_3_Template, 2, 1, "ng-container", 5)(4, AzavistaFlowStepComponent_div_12_ng_container_1_ng_container_4_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r1.step.entity_type, " > ", i0.ɵɵpipeBind1(2, 4, ctx_r1.getActionLabelTranslationKey(ctx_r1.step.config == null ? null : ctx_r1.step.config.action)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.setField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.email);
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_2_span_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" > ", ctx_r1.operatorDisplayText, "");
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_2_span_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " > ");
    i0.ɵɵelement(2, "azavista-input-field", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("canEdit", false)("fullWidth", false)("value", ctx_r1.decisionCondition.value)("editMode", false)("field", ctx_r1.decisionCondition.field)("options", ctx_r1.getFieldOptions(ctx_r1.decisionCondition.field));
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, AzavistaFlowStepComponent_div_12_ng_container_2_span_2_span_2_Template, 2, 1, "span", 5)(3, AzavistaFlowStepComponent_div_12_ng_container_2_span_2_span_3_Template, 3, 6, "span", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" > ", ctx_r1.decisionCondition.field == null ? null : ctx_r1.decisionCondition.field.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.operatorDisplayText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.decisionCondition.value !== undefined && ctx_r1.decisionCondition.value !== null);
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, AzavistaFlowStepComponent_div_12_ng_container_2_span_2_Template, 4, 3, "span", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.step.entity_type, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.decisionCondition.field);
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3, "IS_IN_EXTERNAL_CRM");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.step.entity_type, " > ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" > ", ctx_r1.decisionExternalCRMName, " ");
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3, "IS_NOT_IN_EXTERNAL_CRM");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.step.entity_type, " > ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" > ", ctx_r1.decisionExternalCRMName, " ");
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_div_12_ng_container_3_ng_container_1_Template, 5, 2, "ng-container", 5)(2, AzavistaFlowStepComponent_div_12_ng_container_3_ng_container_2_Template, 5, 2, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.config.exists);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.step.config.exists);
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4, "COMPARE_CURRENT_DATE_TIME_TO_DATE_TIME_FIELD");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, " > ");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, " > ");
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.step.entity_type, " > ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.flowStepFields == null ? null : ctx_r1.flowStepFields.decisionNowCondition == null ? null : ctx_r1.flowStepFields.decisionNowCondition.value == null ? null : ctx_r1.flowStepFields.decisionNowCondition.value.selected == null ? null : ctx_r1.flowStepFields.decisionNowCondition.value.selected.label);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.step.config == null ? null : ctx_r1.step.config.difference);
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4, "PAYMENT_TYPE");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, " > ");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, " > ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.step.entity_type, " > ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.flowStepFields.decisionPayment.value == null ? null : ctx_r1.flowStepFields.decisionPayment.value.selected == null ? null : ctx_r1.flowStepFields.decisionPayment.value.selected.label);
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, "WAIT");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" > ", ctx_r1.waitStepTimeValue, " > ", ctx_r1.waitStepTimeType == null ? null : ctx_r1.waitStepTimeType.label, " ");
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, "WAIT_UNTIL_FIELD");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" > ", ctx_r1.waitUntilFieldStepField == null ? null : ctx_r1.waitUntilFieldStepField.label, " ");
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2, "CHANGE_STAGE");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" > ", ctx_r1.stageName, " ");
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_9_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const stepTitleData_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" > ", stepTitleData_r3.getDescription(ctx_r1), " ");
  }
}
function AzavistaFlowStepComponent_div_12_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, AzavistaFlowStepComponent_div_12_ng_container_9_ng_container_3_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const stepTitleData_r3 = ctx.ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", stepTitleData_r3.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", stepTitleData_r3.getDescription);
  }
}
function AzavistaFlowStepComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_div_12_ng_container_1_Template, 5, 6, "ng-container", 5)(2, AzavistaFlowStepComponent_div_12_ng_container_2_Template, 3, 2, "ng-container", 5)(3, AzavistaFlowStepComponent_div_12_ng_container_3_Template, 3, 2, "ng-container", 5)(4, AzavistaFlowStepComponent_div_12_ng_container_4_Template, 11, 3, "ng-container", 5)(5, AzavistaFlowStepComponent_div_12_ng_container_5_Template, 9, 2, "ng-container", 5)(6, AzavistaFlowStepComponent_div_12_ng_container_6_Template, 4, 2, "ng-container", 5)(7, AzavistaFlowStepComponent_div_12_ng_container_7_Template, 4, 1, "ng-container", 5)(8, AzavistaFlowStepComponent_div_12_ng_container_8_Template, 4, 1, "ng-container", 5)(9, AzavistaFlowStepComponent_div_12_ng_container_9_Template, 4, 2, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.action);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.decision);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.decisionExternalCRM);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.decisionNow);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.decisionPayment);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.wait);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.waitUntilField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.stageChange);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.stepTypesTranslationKeys[ctx_r1.step.type]);
  }
}
function AzavistaFlowStepComponent_button_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function AzavistaFlowStepComponent_button_13_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.deleteStep());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, " delete ");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_1_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "azavista-input-field", 13);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 7, "QUERY_TYPE"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.decisionType.field)("value", ctx_r1.flowStepFields.decisionType.value)("showLabelInReadonlyMode", true)("editMode", false)("canEdit", false)("fullWidth", true);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_15_ng_container_1_azavista_input_field_1_Template, 2, 9, "azavista-input-field", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.flowStepFields.decisionType == null ? null : ctx_r1.flowStepFields.decisionType.field);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_2_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 15);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_15_ng_container_2_azavista_input_field_1_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onDecisionTypeFieldChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 6, "QUERY_TYPE"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.decisionType.field)("value", ctx_r1.flowStepFields.decisionType.value)("editMode", true)("canEdit", true)("fullWidth", true);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_15_ng_container_2_azavista_input_field_1_Template, 2, 8, "azavista-input-field", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.flowStepFields.decisionType == null ? null : ctx_r1.flowStepFields.decisionType.field);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-form-field", 18);
    i0.ɵɵelement(5, "input", 19);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.decisionCondition.field == null ? null : ctx_r1.decisionCondition.field.label);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 4, "FIELD"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.operatorDisplayText);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 6, "OPERATOR"));
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_5_ng_container_3_mat_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const operator_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", operator_r8.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", operator_r8.displayText, " ");
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_5_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 16)(2, "mat-select", 20);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("selectionChange", function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_5_ng_container_3_Template_mat_select_selectionChange_2_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onDecisionOperatorChanged($event));
    });
    i0.ɵɵtwoWayListener("valueChange", function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_5_ng_container_3_Template_mat_select_valueChange_2_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r1.decisionCondition.operator, $event) || (ctx_r1.decisionCondition.operator = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(4, AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_5_ng_container_3_mat_option_4_Template, 2, 2, "mat-option", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 3, "OPERATOR"));
    i0.ɵɵtwoWayProperty("value", ctx_r1.decisionCondition.operator);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.allOperators);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 15);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_5_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onDecisionFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_5_ng_container_3_Template, 5, 5, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "FIELD"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.decisionCondition.field)("value", ctx_r1.flowStepFields.decisionCondition.value)("editMode", true)("canEdit", true)("fullWidth", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.decisionCondition.field);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_6_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 24);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_6_azavista_input_field_1_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onDecisionValueChanged($event.value));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_6_azavista_input_field_1_Template_azavista_input_field_invalidValueSet_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onDecisionValueChanged($event.value));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 8, "VALUE"));
    i0.ɵɵproperty("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("options", ctx_r1.getFieldOptions(ctx_r1.decisionCondition.field))("field", ctx_r1.decisionCondition.field)("value", ctx_r1.decisionCondition.value)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_6_azavista_input_field_1_Template, 2, 10, "azavista-input-field", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.operatorHasValue(ctx_r1.decisionCondition.operator));
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 16);
    i0.ɵɵelement(2, "input", 17);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_4_Template, 7, 8, "ng-container", 5)(5, AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_5_Template, 4, 9, "ng-container", 5)(6, AzavistaFlowStepComponent_ng_container_15_ng_container_3_ng_container_6_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.entity_type);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 5, "SELECT_ENTITY"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.decisionCondition.field);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "azavista-input-field", 25);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "mat-checkbox", 26)(4, "span", 8);
    i0.ɵɵtext(5, "EXISTS");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 9, "INTEGRATION"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.existInExternalCRMIntegration.field)("value", ctx_r1.flowStepFields.existInExternalCRMIntegration.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r1.step.config.exists)("disabled", true);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 27);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_15_ng_container_4_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onDecisionExternalCRMIntegrationChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-checkbox", 28);
    i0.ɵɵtwoWayListener("ngModelChange", function AzavistaFlowStepComponent_ng_container_15_ng_container_4_ng_container_2_Template_mat_checkbox_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.step.config.exists, $event) || (ctx_r1.step.config.exists = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(4, "span", 8);
    i0.ɵɵtext(5, "EXISTS");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 8, "INTEGRATION"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.existInExternalCRMIntegration.field)("value", ctx_r1.flowStepFields.existInExternalCRMIntegration.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.step.config.exists);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_15_ng_container_4_ng_container_1_Template, 6, 11, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_15_ng_container_4_ng_container_2_Template, 6, 10, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 29)(2, "azavista-input-field", 30);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_15_ng_container_5_Template_azavista_input_field_valueChanged_2_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDecisionNowFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "azavista-input-field", 31);
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_15_ng_container_5_Template_azavista_input_field_valueChanged_4_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDecisionNowPlusMinusChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "azavista-duration", 32);
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_15_ng_container_5_Template_azavista_duration_valueChanged_5_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDecisionNowDurationChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "azavista-input-field", 31);
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_15_ng_container_5_Template_azavista_input_field_valueChanged_6_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDecisionNowBeforeAfterChanged($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(3, 15, "FIELD"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.decisionNowCondition.field)("value", ctx_r1.flowStepFields.decisionNowCondition.value)("editMode", ctx_r1.editMode)("canEdit", ctx_r1.editMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.decisionNowPlusMinus.field)("value", ctx_r1.flowStepFields.decisionNowPlusMinus.value)("editMode", ctx_r1.editMode)("canEdit", ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("seconds", ctx_r1.flowStepFields.decisionNowDifferenceAbsValue)("editMode", ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.decisionNowDirection.field)("value", ctx_r1.flowStepFields.decisionNowDirection.value)("editMode", ctx_r1.editMode)("canEdit", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "azavista-input-field", 25);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "PAYMENT_TYPE"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.decisionPayment.field)("value", ctx_r1.flowStepFields.decisionPayment.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 34);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_15_ng_container_6_ng_container_3_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onDecisionPaymentFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 6, "PAYMENT_TYPE"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.decisionPayment.field)("value", ctx_r1.flowStepFields.decisionPayment.value)("fullWidth", true)("editMode", ctx_r1.editMode)("canEdit", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 33);
    i0.ɵɵtemplate(2, AzavistaFlowStepComponent_ng_container_15_ng_container_6_ng_container_2_Template, 3, 9, "ng-container", 5)(3, AzavistaFlowStepComponent_ng_container_15_ng_container_6_ng_container_3_Template, 3, 8, "ng-container", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_7_azavista_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 37);
    i0.ɵɵlistener("click", function AzavistaFlowStepComponent_ng_container_15_ng_container_7_azavista_button_1_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.updateStepAdvancedQueryCondition(ctx_r1.step));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "UPDATE_CONDITION"));
  }
}
function AzavistaFlowStepComponent_ng_container_15_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_15_ng_container_7_azavista_button_1_Template, 3, 3, "azavista-button", 35);
    i0.ɵɵelement(2, "azavista-filter-criteria-tree-nodes", 36);
    i0.ɵɵpipe(3, "apply");
    i0.ɵɵpipe(4, "apply");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("filterData", i0.ɵɵpipeBind3(3, 3, ctx_r1.step, ctx_r1.getStepAdvancedQueryFilterData, true))("criteriaTree", i0.ɵɵpipeBind3(4, 7, ctx_r1.step.condition, ctx_r1.flatSearchParamsToFilterTree, ctx_r1.step.id).criteriaTree);
  }
}
function AzavistaFlowStepComponent_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_15_ng_container_1_Template, 2, 1, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_15_ng_container_2_Template, 2, 1, "ng-container", 5)(3, AzavistaFlowStepComponent_ng_container_15_ng_container_3_Template, 7, 7, "ng-container", 5)(4, AzavistaFlowStepComponent_ng_container_15_ng_container_4_Template, 3, 2, "ng-container", 5)(5, AzavistaFlowStepComponent_ng_container_15_ng_container_5_Template, 7, 17, "ng-container", 5)(6, AzavistaFlowStepComponent_ng_container_15_ng_container_6_Template, 4, 2, "ng-container", 5)(7, AzavistaFlowStepComponent_ng_container_15_ng_container_7_Template, 5, 11, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.decision);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.decisionExternalCRM);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.decisionNow);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.decisionPayment);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.type === ctx_r1.stepType.advancedQuery);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentActionStepField == null ? null : ctx_r1.currentActionStepField.label);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 2, "FIELD"));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 38);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onActionFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 5, "FIELD"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.setField.field)("value", ctx_r1.flowStepFields.setField.value)("editMode", true)("fullWidth", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_3_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 40);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_3_azavista_input_field_1_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onActionValueChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 8, "VALUE"));
    i0.ɵɵproperty("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("field", ctx_r1.currentActionStepField)("value", ctx_r1.step.config == null ? null : ctx_r1.step.config.value)("showLabelInReadonlyMode", true)("options", ctx_r1.getFieldOptions(ctx_r1.currentActionStepField));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_3_azavista_input_field_1_Template, 2, 10, "azavista-input-field", 39);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.currentActionStepField);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_1_Template, 4, 4, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_2_Template, 3, 7, "ng-container", 5)(3, AzavistaFlowStepComponent_ng_container_16_ng_container_8_ng_container_3_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.step.config == null ? null : ctx_r1.step.config.field_id);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentEmailTemplateName);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 2, "EMAIL_CAMPAIGNS"));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_9_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 15);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_9_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onEmailTemplateChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 6, "EMAIL_CAMPAIGNS"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.emailTemplate.field)("value", ctx_r1.flowStepFields.emailTemplate.value)("editMode", true)("canEdit", true)("fullWidth", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_9_ng_container_1_Template, 4, 4, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_9_ng_container_2_Template, 3, 8, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentTeamName);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 2, "TEAM"));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_10_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 41);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_10_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onTeamChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 6, "TEAM"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.team.field)("value", ctx_r1.flowStepFields.team.value)("fullWidth", true)("canEdit", true)("editMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_10_ng_container_1_Template, 4, 4, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_10_ng_container_2_Template, 3, 8, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_11_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-form-field", 18);
    i0.ɵɵelement(5, "input", 19);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-form-field", 18);
    i0.ɵɵelement(8, "input", 19);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentEmailCampaignName);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 6, "EMAIL_CAMPAIGN"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentLanguageName);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 8, "LANGUAGE"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.to_email);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(9, 10, "TO_EMAIL"));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_11_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 42);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_11_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onEmailTemplateChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "azavista-input-field", 42);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_11_ng_container_2_Template_azavista_input_field_valueChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onLanguageChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "azavista-input-field", 43);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_11_ng_container_2_Template_azavista_input_field_valueChanged_5_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onGeneralEmailValueChanged($event));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_11_ng_container_2_Template_azavista_input_field_invalidValueSet_5_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onGeneralEmailInvalidValueSet());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 18, "EMAIL_CAMPAIGN"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.emailCampaign.field)("value", ctx_r1.flowStepFields.emailCampaign.value)("canEdit", true)("editMode", true)("fullWidth", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 20, "LANGUAGE"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.language.field)("value", ctx_r1.flowStepFields.language.value)("canEdit", true)("editMode", true)("fullWidth", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 22, "TO_EMAIL"));
    i0.ɵɵproperty("field", ctx_r1.generalEmailField)("value", ctx_r1.step.config.to_email)("editMode", true)("fullWidth", true)("options", ctx_r1.getFieldOptions(ctx_r1.generalEmailField));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_11_ng_container_1_Template, 10, 12, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_11_ng_container_2_Template, 7, 24, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_12_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-form-field", 18);
    i0.ɵɵelement(5, "input", 19);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-form-field", 18);
    i0.ɵɵelement(8, "input", 19);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentEmailCampaignName);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 6, "EMAIL_CAMPAIGN"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentLanguageName);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 8, "LANGUAGE"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentEmailFieldName);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(9, 10, "EMAIL_FIELD"));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_12_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 42);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_12_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onEmailTemplateChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "azavista-input-field", 42);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_12_ng_container_2_Template_azavista_input_field_valueChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onLanguageChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "azavista-input-field", 44);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_12_ng_container_2_Template_azavista_input_field_valueChanged_5_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onEmailFromFieldValueChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 18, "EMAIL_CAMPAIGN"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.emailCampaign.field)("value", ctx_r1.flowStepFields.emailCampaign.value)("canEdit", true)("editMode", true)("fullWidth", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 20, "LANGUAGE"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.language.field)("value", ctx_r1.flowStepFields.language.value)("canEdit", true)("editMode", true)("fullWidth", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 22, "EMAIL_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.emailFromFieldField)("value", ctx_r1.emailFromFieldFieldValue)("editMode", true)("fullWidth", true)("options", ctx_r1.getFieldOptions(ctx_r1.emailFromFieldField));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_12_ng_container_1_Template, 10, 12, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_12_ng_container_2_Template, 7, 24, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 27);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_13_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAddContactToEventEventFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "EVENT"));
    i0.ɵɵproperty("field", ctx_r1.addContactToEventFieldData.event.field)("value", ctx_r1.addContactToEventFieldData.event.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 27);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_14_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onGenerateCertificateDocumentChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "azavista-input-field", 27);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_14_Template_azavista_input_field_valueChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onGenerateCertificateDocumentFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "azavista-input-field", 27);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_14_Template_azavista_input_field_valueChanged_5_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onGenerateCertificateDocumentNameChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 21, "DOCUMENT"));
    i0.ɵɵproperty("field", ctx_r1.generateCertificateFieldData.document.field)("value", ctx_r1.generateCertificateFieldData.document.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 23, "DOCUMENT_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.generateCertificateFieldData.documentField.field)("value", ctx_r1.generateCertificateFieldData.documentField.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 25, "DOCUMENT_NAME"));
    i0.ɵɵproperty("field", ctx_r1.generateCertificateFieldData.documentName.field)("value", ctx_r1.generateCertificateFieldData.documentName.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_1_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const map_r22 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(map_r22.requesterField == null ? null : map_r22.requesterField.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(map_r22.eventField == null ? null : map_r22.eventField.label);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-form-field", 18);
    i0.ɵɵelement(5, "input", 19);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 45)(8, "h4", 46);
    i0.ɵɵtext(9, "FIELD_MAPPINGS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "h5", 8);
    i0.ɵɵtext(11, "REQUESTER_FIELD");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "h5", 8);
    i0.ɵɵtext(13, "EVENT_FIELD");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "h5");
    i0.ɵɵtemplate(15, AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_1_ng_container_15_Template, 6, 2, "ng-container", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentCreateEventTeamName);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 5, "TEAM"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.currentCreateEventEventName);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 7, "TEMPLATE_EVENT"));
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngForOf", ctx_r1.requesterFieldToEventFieldMap);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_mat_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r26 = ctx.$implicit;
    i0.ɵɵproperty("value", field_r26);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", field_r26.label, " ");
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_mat_option_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r27 = ctx.$implicit;
    i0.ɵɵproperty("value", field_r27);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", field_r27.label, " ");
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 16)(2, "mat-select", 52);
    i0.ɵɵlistener("selectionChange", function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_Template_mat_select_selectionChange_2_listener() {
      const map_r25 = i0.ɵɵrestoreView(_r24).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onRequesterFieldChange(map_r25));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_Template_mat_select_ngModelChange_2_listener($event) {
      const map_r25 = i0.ɵɵrestoreView(_r24).$implicit;
      i0.ɵɵtwoWayBindingSet(map_r25.requesterField, $event) || (map_r25.requesterField = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(3, AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_mat_option_3_Template, 2, 2, "mat-option", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "mat-form-field", 16)(5, "mat-select", 52);
    i0.ɵɵlistener("selectionChange", function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_Template_mat_select_selectionChange_5_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onEventFieldChange());
    });
    i0.ɵɵtwoWayListener("ngModelChange", function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_Template_mat_select_ngModelChange_5_listener($event) {
      const map_r25 = i0.ɵɵrestoreView(_r24).$implicit;
      i0.ɵɵtwoWayBindingSet(map_r25.eventField, $event) || (map_r25.eventField = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(6, AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_mat_option_6_Template, 2, 2, "mat-option", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "button", 11);
    i0.ɵɵlistener("click", function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_Template_button_click_7_listener() {
      const map_r25 = i0.ɵɵrestoreView(_r24).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.deleteFieldMap(map_r25));
    });
    i0.ɵɵelementStart(8, "mat-icon");
    i0.ɵɵtext(9, "delete");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const map_r25 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", map_r25.requesterField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.requesterFields);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", map_r25.eventField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", map_r25.possibleEventFields);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 42);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCreateEventTeamChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "azavista-input-field", 42);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_Template_azavista_input_field_valueChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onEventTemplateChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 45)(6, "h4", 46);
    i0.ɵɵtext(7, "FIELD_MAPPINGS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "h5", 48);
    i0.ɵɵtext(9, "REQUESTER_FIELD");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "h5", 49);
    i0.ɵɵtext(11, "EVENT_FIELD");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "h5");
    i0.ɵɵtemplate(13, AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_ng_container_13_Template, 10, 4, "ng-container", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 50);
    i0.ɵɵlistener("click", function AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_Template_div_click_14_listener() {
      i0.ɵɵrestoreView(_r23);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addNewFieldMap());
    });
    i0.ɵɵelementStart(15, "button", 51)(16, "mat-icon");
    i0.ɵɵtext(17, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "span", 8);
    i0.ɵɵtext(19, "ADD_FIELD_MAPPING");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 13, "TEAM"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.team.field)("value", ctx_r1.flowStepFields.team.value)("canEdit", true)("editMode", true)("fullWidth", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 15, "TEMPLATE_EVENT"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.eventTemplate.field)("value", ctx_r1.flowStepFields.eventTemplate.value)("canEdit", true)("editMode", true)("fullWidth", true);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngForOf", ctx_r1.requesterFieldToEventFieldMap);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_1_Template, 16, 9, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_15_ng_container_2_Template, 20, 17, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_16_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 2, "FIELD"));
    i0.ɵɵproperty("value", ctx_r1.selectedSetDateTimeFieldToCurrent == null ? null : ctx_r1.selectedSetDateTimeFieldToCurrent.label);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_16_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 41);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_16_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSetDateTimeFieldToCurrentFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 6, "FIELD"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.requesterDateTimeTypeField.field)("value", ctx_r1.flowStepFields.requesterDateTimeTypeField.value)("fullWidth", true)("canEdit", true)("editMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_16_ng_container_1_Template, 4, 4, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_16_ng_container_2_Template, 3, 8, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_17_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 57);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_17_ng_container_1_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r30);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSetDateTimeFieldToCurrentFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "FIELD"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.requesterDateTimeTypeField.field)("value", ctx_r1.flowStepFields.requesterDateTimeTypeField.value)("fullWidth", true)("canEdit", ctx_r1.editMode)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_17_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 57);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_17_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSetTimeFieldToCurrentFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "FIELD"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.requesterTimeTypeField.field)("value", ctx_r1.flowStepFields.requesterTimeTypeField.value)("fullWidth", true)("canEdit", ctx_r1.editMode)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_17_mat_form_field_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 16)(1, "mat-select", 58, 1);
    i0.ɵɵlistener("selectionChange", function AzavistaFlowStepComponent_ng_container_16_ng_container_17_mat_form_field_5_Template_mat_select_selectionChange_1_listener() {
      let tmp_6_0;
      i0.ɵɵrestoreView(_r32);
      const offsetSecondsIsPositiveEl_r33 = i0.ɵɵreference(2);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSetConfigProperty("offset_seconds", ctx_r1.Math.abs((tmp_6_0 = ctx_r1.step == null ? null : ctx_r1.step.config == null ? null : ctx_r1.step.config.offset_seconds) !== null && tmp_6_0 !== undefined ? tmp_6_0 : 0) * offsetSecondsIsPositiveEl_r33.value));
    });
    i0.ɵɵelementStart(3, "mat-option", 22);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "mat-option", 22);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", (ctx_r1.step == null ? null : ctx_r1.step.config == null ? null : ctx_r1.step.config.offset_seconds) >= 0 ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "AFTER"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 7, "BEFORE"));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_17_mat_form_field_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 16);
    i0.ɵɵelement(1, "input", 59);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", i0.ɵɵpipeBind1(2, 1, (ctx_r1.step == null ? null : ctx_r1.step.config == null ? null : ctx_r1.step.config.offset_seconds) >= 0 ? "AFTER" : "BEFORE"));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_17_ng_container_1_Template, 3, 9, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_17_ng_container_2_Template, 3, 9, "ng-container", 5);
    i0.ɵɵelementStart(3, "div", 53)(4, "div", 54);
    i0.ɵɵtemplate(5, AzavistaFlowStepComponent_ng_container_16_ng_container_17_mat_form_field_5_Template, 9, 9, "mat-form-field", 55)(6, AzavistaFlowStepComponent_ng_container_16_ng_container_17_mat_form_field_6_Template, 3, 3, "mat-form-field", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "azavista-duration", 56);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵpipe(9, "apply");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_17_Template_azavista_duration_valueChanged_7_listener($event) {
      let tmp_4_0;
      i0.ɵɵrestoreView(_r29);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSetConfigProperty("offset_seconds", $event * ((tmp_4_0 = ctx_r1.offsetSecondsIsPositiveEl == null ? null : ctx_r1.offsetSecondsIsPositiveEl.value) !== null && tmp_4_0 !== undefined ? tmp_4_0 : 1)));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_9_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.setRelativeDateTime);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.setRelativeTime);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(8, 7, ""));
    i0.ɵɵproperty("editMode", ctx_r1.editMode)("seconds", i0.ɵɵpipeBind2(9, 9, (tmp_9_0 = ctx_r1.step == null ? null : ctx_r1.step.config == null ? null : ctx_r1.step.config.offset_seconds) !== null && tmp_9_0 !== undefined ? tmp_9_0 : 0, ctx_r1.Math.abs));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_18_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 27);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_18_ng_container_1_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r34);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onWebhookIntegrationChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "INTEGRATION"));
    i0.ɵɵproperty("field", ctx_r1.webhookIntegrationField)("value", ctx_r1.webhookIntegrationFieldValue)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_18_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 27);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_18_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r35);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onWebhookIntegrationChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "INTEGRATION"));
    i0.ɵɵproperty("field", ctx_r1.webhookIntegrationField)("value", ctx_r1.webhookIntegrationFieldValue)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_18_ng_container_1_Template, 3, 9, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_18_ng_container_2_Template, 3, 9, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "azavista-input-field", 60);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "azavista-input-field", 60);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "azavista-input-field", 60);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelement(7, "azavista-input-field", 60);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelement(9, "azavista-input-field", 60);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelement(11, "azavista-input-field", 60);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelement(13, "azavista-input-field", 60);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelement(15, "azavista-input-field", 60);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 48, "EMAIL_TEMPLATE"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.emailTemplateField)("value", ctx_r1.sendGenericEmailData.emailTemplateFieldValue)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 50, "LANGUAGE"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.languageField)("value", ctx_r1.sendGenericEmailData.languageFieldValue)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.to_email);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 52, "TO_EMAIL"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.toEmailField)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.from.email);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(8, 54, "FROM_EMAIL"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.fromEmailField)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.from.name);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(10, 56, "FROM_NAME"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.fromNameField)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.reply_email);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(12, 58, "REPLY_EMAIL"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.replyEmailField)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.bounce_email);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(14, 60, "BOUNCE_EMAIL"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.bounceEmailField)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.subject);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(16, 62, "SUBJECT"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.subjectField)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 61);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.emailTemplateField, $event, false));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_invalidValueSet_1_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.emailTemplateField, $event, true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "azavista-input-field", 61);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_valueChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.languageField, $event, false));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_invalidValueSet_3_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.languageField, $event, true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "azavista-input-field", 61);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_valueChanged_5_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.toEmailField, $event, false));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_invalidValueSet_5_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.toEmailField, $event, true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "azavista-input-field", 61);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_valueChanged_7_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.fromEmailField, $event, false));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_invalidValueSet_7_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.fromEmailField, $event, true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "azavista-input-field", 61);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_valueChanged_9_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.fromNameField, $event, false));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_invalidValueSet_9_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.fromNameField, $event, true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "azavista-input-field", 61);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_valueChanged_11_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.replyEmailField, $event, false));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_invalidValueSet_11_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.replyEmailField, $event, true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "azavista-input-field", 61);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_valueChanged_13_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.bounceEmailField, $event, false));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_invalidValueSet_13_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.bounceEmailField, $event, true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "azavista-input-field", 61);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_valueChanged_15_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.subjectField, $event, false));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template_azavista_input_field_invalidValueSet_15_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendGenericEmailFieldChanged(ctx_r1.sendGenericEmailData.subjectField, $event, true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 40, "EMAIL_TEMPLATE"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.emailTemplateField)("value", ctx_r1.sendGenericEmailData.emailTemplateFieldValue)("fullWidth", true)("editMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 42, "LANGUAGE"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.languageField)("value", ctx_r1.sendGenericEmailData.languageFieldValue)("fullWidth", true)("editMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.to_email);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 44, "TO_EMAIL"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.toEmailField)("fullWidth", true)("editMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.from.email);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(8, 46, "FROM_EMAIL"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.fromEmailField)("fullWidth", true)("editMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.from.name);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(10, 48, "FROM_NAME"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.fromNameField)("fullWidth", true)("editMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.reply_email);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(12, 50, "REPLY_EMAIL"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.replyEmailField)("fullWidth", true)("editMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.bounce_email);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(14, 52, "BOUNCE_EMAIL"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.bounceEmailField)("fullWidth", true)("editMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.config.subject);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(16, 54, "SUBJECT"));
    i0.ɵɵproperty("field", ctx_r1.sendGenericEmailData.subjectField)("fullWidth", true)("editMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_1_Template, 17, 64, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_19_ng_container_2_Template, 17, 56, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 63);
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_azavista_input_field_1_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.patchStepConfig({
        approver_field_id: $event.value
      }));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_azavista_input_field_1_Template_azavista_input_field_invalidValueSet_0_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.patchStepConfig({
        approver_field_id: $event.value
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r38 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("field", field_r38)("label", field_r38.label)("canEdit", ctx_r1.editMode)("editMode", ctx_r1.editMode)("value", ctx_r1.step.config == null ? null : ctx_r1.step.config[field_r38.name])("fullWidth", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_azavista_input_field_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 63);
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_azavista_input_field_2_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r39);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.patchStepConfig({
        email_campaign_id: $event.value
      }));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_azavista_input_field_2_Template_azavista_input_field_invalidValueSet_0_listener($event) {
      i0.ɵɵrestoreView(_r39);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.patchStepConfig({
        email_campaign_id: $event.value
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r40 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("field", field_r40)("label", field_r40.label)("canEdit", ctx_r1.editMode)("editMode", ctx_r1.editMode)("value", ctx_r1.step.config == null ? null : ctx_r1.step.config[field_r40.name])("fullWidth", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_azavista_input_field_1_Template, 1, 6, "azavista-input-field", 62)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_azavista_input_field_2_Template, 1, 6, "azavista-input-field", 62);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.sendEmailToApproverData.approver_field_id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.sendEmailToApproverData.email_campaign_id);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_20_ng_container_1_Template, 3, 2, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.sendEmailToApproverData);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_21_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "azavista-input-field", 25);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "FIELD"));
    i0.ɵɵproperty("field", ctx_r1.setReferenceNumberField)("value", ctx_r1.setReferenceNumberFieldValue)("canEdit", false)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_21_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 64);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_21_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r41);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSetReferenceFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 6, "FIELD"));
    i0.ɵɵproperty("field", ctx_r1.setReferenceNumberField)("value", ctx_r1.setReferenceNumberFieldValue)("fullWidth", true)("canEdit", ctx_r1.editMode)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_21_ng_container_1_Template, 3, 9, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_21_ng_container_2_Template, 3, 8, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_22_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 27);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_22_ng_container_1_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r42);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendObjectIntegrationChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "INTEGRATION"));
    i0.ɵɵproperty("field", ctx_r1.sendObjectIntegrationField)("value", ctx_r1.sendObjectIntegrationFieldValue)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_22_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 27);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_22_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r43);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSendObjectIntegrationChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "INTEGRATION"));
    i0.ɵɵproperty("field", ctx_r1.sendObjectIntegrationField)("value", ctx_r1.sendObjectIntegrationFieldValue)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_22_ng_container_1_Template, 3, 9, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_22_ng_container_2_Template, 3, 9, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_1_azavista_input_field_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "azavista-input-field", 25);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 7, "PARTICIPANT_FIELD_VALUE"));
    i0.ɵɵproperty("field", ctx_r1.countSelectFieldData.participantFieldValue.field)("value", ctx_r1.countSelectFieldData.participantFieldValue.value)("canEdit", false)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "azavista-input-field", 25);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_1_azavista_input_field_3_Template, 2, 9, "azavista-input-field", 65);
    i0.ɵɵelement(4, "azavista-input-field", 25);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 15, "PARTICIPANT_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.countSelectFieldData.participantField.field)("value", ctx_r1.countSelectFieldData.participantField.value)("canEdit", false)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.countSelectFieldData.participantFieldValue.value);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(5, 17, "EVENT_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.countSelectFieldData.eventField.field)("value", ctx_r1.countSelectFieldData.eventField.value)("canEdit", false)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_2_azavista_input_field_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 66);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_2_azavista_input_field_3_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r45);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onCountSelectFieldParticipantFieldValueChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 6, "PARTICIPANT_FIELD_VALUE"));
    i0.ɵɵproperty("field", ctx_r1.countSelectFieldData.participantFieldValue.field)("value", ctx_r1.countSelectFieldData.participantFieldValue.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 66);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCountSelectFieldParticipantFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_2_azavista_input_field_3_Template, 2, 8, "azavista-input-field", 67);
    i0.ɵɵelementStart(4, "azavista-input-field", 66);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_2_Template_azavista_input_field_valueChanged_4_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCountSelectFieldEventFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 13, "PARTICIPANT_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.countSelectFieldData.participantField.field)("value", ctx_r1.countSelectFieldData.participantField.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.countSelectFieldData.participantFieldValue.value);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(5, 15, "EVENT_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.countSelectFieldData.eventField.field)("value", ctx_r1.countSelectFieldData.eventField.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_1_Template, 6, 19, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_23_ng_container_2_Template, 6, 17, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_24_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "azavista-input-field", 25);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "azavista-input-field", 25);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 14, "COPY_EVENT_START_DATE_TIME_TO_THIS_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.copyEventDatesFieldData.startDateField.field)("value", ctx_r1.copyEventDatesFieldData.startDateField.value)("canEdit", false)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 16, "COPY_EVENT_END_DATE_TIME_TO_THIS_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.copyEventDatesFieldData.endDateField.field)("value", ctx_r1.copyEventDatesFieldData.endDateField.value)("canEdit", false)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_24_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 66);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_24_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r46);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCopyEventDatesStartDateFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "azavista-input-field", 66);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_24_ng_container_2_Template_azavista_input_field_valueChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r46);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCopyEventDatesEndDateFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 12, "COPY_EVENT_START_DATE_TIME_TO_THIS_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.copyEventDatesFieldData.startDateField.field)("value", ctx_r1.copyEventDatesFieldData.startDateField.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 14, "COPY_EVENT_END_DATE_TIME_TO_THIS_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.copyEventDatesFieldData.endDateField.field)("value", ctx_r1.copyEventDatesFieldData.endDateField.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_24_ng_container_1_Template, 5, 18, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_24_ng_container_2_Template, 5, 16, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_25_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "azavista-input-field", 25);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "azavista-input-field", 25);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 14, "EVENT_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.copyEventTextFieldFieldData.eventField.field)("value", ctx_r1.copyEventTextFieldFieldData.eventField.value)("canEdit", false)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 16, "PARTICIPANT_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.copyEventTextFieldFieldData.participantField.field)("value", ctx_r1.copyEventTextFieldFieldData.participantField.value)("canEdit", false)("fullWidth", true)("editMode", false)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_25_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 66);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_25_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r47);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCopyEventTextFieldEventFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "azavista-input-field", 66);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_25_ng_container_2_Template_azavista_input_field_valueChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r47);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCopyEventTextFieldContactFieldChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 12, "EVENT_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.copyEventTextFieldFieldData.eventField.field)("value", ctx_r1.copyEventTextFieldFieldData.eventField.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 14, "PARTICIPANT_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.copyEventTextFieldFieldData.participantField.field)("value", ctx_r1.copyEventTextFieldFieldData.participantField.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_25_ng_container_1_Template, 5, 18, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_16_ng_container_25_ng_container_2_Template, 5, 16, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 66);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_1_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r49);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onMessageToContactOrParticipantFieldChanged("number", $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 6, "PHONE_NUMBER_FIELD"));
    i0.ɵɵproperty("field", ctx_r1.messageToContactOrParticipantFieldData.number.field)("value", ctx_r1.messageToContactOrParticipantFieldData.number.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 66);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_3_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r50);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onMessageToContactOrParticipantFieldChanged("subject", $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 6, "SUBJECT"));
    i0.ɵɵproperty("field", ctx_r1.messageToContactOrParticipantFieldData.subject.field)("value", ctx_r1.messageToContactOrParticipantFieldData.subject.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 66);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_5_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r51);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onMessageToContactOrParticipantFieldChanged("message", $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 6, "MESSAGE"));
    i0.ɵɵproperty("field", ctx_r1.messageToContactOrParticipantFieldData.message.field)("value", ctx_r1.messageToContactOrParticipantFieldData.message.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 66);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_7_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r52);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onMessageToContactOrParticipantFieldChanged("event_app_module", $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 6, "EVENT_APP_MODULE"));
    i0.ɵɵproperty("field", ctx_r1.messageToContactOrParticipantFieldData.event_app_module.field)("value", ctx_r1.messageToContactOrParticipantFieldData.event_app_module.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 66);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_9_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onMessageToContactOrParticipantFieldChanged("event_app_entity_id", $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entityIdField_r54 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 6, "EVENT_APP_MODULE_ENTITY"));
    i0.ɵɵproperty("field", entityIdField_r54.field)("value", entityIdField_r54.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_1_Template, 2, 8, "azavista-input-field", 67);
    i0.ɵɵpipe(2, "apply");
    i0.ɵɵtemplate(3, AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_3_Template, 2, 8, "azavista-input-field", 67);
    i0.ɵɵpipe(4, "apply");
    i0.ɵɵtemplate(5, AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_5_Template, 2, 8, "azavista-input-field", 67);
    i0.ɵɵpipe(6, "apply");
    i0.ɵɵtemplate(7, AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_7_Template, 2, 8, "azavista-input-field", 67);
    i0.ɵɵpipe(8, "apply");
    i0.ɵɵtemplate(9, AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_azavista_input_field_9_Template, 2, 8, "azavista-input-field", 67);
    i0.ɵɵpipe(10, "apply");
    i0.ɵɵpipe(11, "apply");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const fieldListByIntegrationSubType_r55 = ctx.ngIf;
    const config_r56 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(2, 5, fieldListByIntegrationSubType_r55, ctx_r1.findInArray, "number"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(4, 9, fieldListByIntegrationSubType_r55, ctx_r1.findInArray, "subject"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(6, 13, fieldListByIntegrationSubType_r55, ctx_r1.findInArray, "message"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(8, 17, fieldListByIntegrationSubType_r55, ctx_r1.findInArray, "event_app_module"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(10, 21, fieldListByIntegrationSubType_r55, ctx_r1.findInArray, "event_app_entity_id") && i0.ɵɵpipeBind2(11, 25, config_r56 == null ? null : config_r56.eventAppComponent == null ? null : config_r56.eventAppComponent.component, ctx_r1.getMessageToContactOrParticipantEventAppEntityField));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_ng_container_1_Template, 12, 28, "ng-container", 5);
    i0.ɵɵpipe(2, "apply");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const config_r56 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.IMessageToContactOrParticipantPropertyByIntegrationSubType[(tmp_5_0 = (tmp_5_0 = i0.ɵɵpipeBind2(2, 1, config_r56.integration_id, ctx_r1.getIntegration)) == null ? null : tmp_5_0.subtype) !== null && tmp_5_0 !== undefined ? tmp_5_0 : ""]);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 66);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_26_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r48);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onMessageToContactOrParticipantFieldChanged("integration", $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AzavistaFlowStepComponent_ng_container_16_ng_container_26_ng_container_3_Template, 3, 4, "ng-container", 5);
    i0.ɵɵpipe(4, "apply");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, "INTEGRATION"));
    i0.ɵɵproperty("field", ctx_r1.messageToContactOrParticipantFieldData.integration.field)("value", ctx_r1.messageToContactOrParticipantFieldData.integration.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(4, 9, ctx_r1.step.config, ctx_r1.getConfigAsMessageToEntityConfig));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_27_Template(rf, ctx) {
  if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 66);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_27_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r57);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSendMessageToUserFieldChanged("integration", $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "azavista-input-field", 68);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_27_Template_azavista_input_field_valueChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r57);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSendMessageToUserFieldChanged("userIds", $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "azavista-input-field", 66);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_16_ng_container_27_Template_azavista_input_field_valueChanged_5_listener($event) {
      i0.ɵɵrestoreView(_r57);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSendMessageToUserFieldChanged("message", $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 19, "INTEGRATION"));
    i0.ɵɵproperty("field", ctx_r1.sendMessageToUserFieldData.integration.field)("value", ctx_r1.sendMessageToUserFieldData.integration.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 21, "USERS"));
    i0.ɵɵproperty("field", ctx_r1.sendMessageToUserFieldData.userIds.field)("value", ctx_r1.sendMessageToUserFieldData.userIds.value)("canEdit", ctx_r1.editMode)("options", ctx_r1.sendMessageToUserFieldData.userIdsOptions)("fullWidth", true)("editMode", ctx_r1.editMode);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 23, "MESSAGE"));
    i0.ɵɵproperty("field", ctx_r1.sendMessageToUserFieldData.message.field)("value", ctx_r1.sendMessageToUserFieldData.message.value)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_28_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-flow-step-field-mapping-item-list", 69);
    i0.ɵɵpipe(2, "apply");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("stepConfigChange", function AzavistaFlowStepComponent_ng_container_16_ng_container_28_ng_container_1_ng_container_1_Template_azavista_flow_step_field_mapping_item_list_stepConfigChange_1_listener($event) {
      i0.ɵɵrestoreView(_r58);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.step.config = ctx_r1.getStepActionUpdateContactToOrganizationFromStepActionFieldMappingConfig($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const targetFields_r59 = ctx.ngIf;
    const sourceFields_r60 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("readonly", !ctx_r1.editMode)("sourceFields", sourceFields_r60)("targetFields", targetFields_r59)("fieldMatching", ctx_r1.FieldMappingMatchingType.exact)("stepConfig", i0.ɵɵpipeBind4(2, 7, ctx_r1.step.config, ctx_r1.getStepActionFieldMappingConfigFromStepActionUpdateContactToOrganization, sourceFields_r60, targetFields_r59))("sourceColumnConfig", i0.ɵɵpureFunction1(16, _c2, i0.ɵɵpipeBind1(3, 12, "CONTACT_FIELDS")))("targetColumnConfig", i0.ɵɵpureFunction1(18, _c2, i0.ɵɵpipeBind1(4, 14, "ORGANIZATION_FIELDS")));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_28_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_28_ng_container_1_ng_container_1_Template, 5, 20, "ng-container", 5);
    i0.ɵɵpipe(2, "apply");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (tmp_5_0 = (tmp_5_0 = i0.ɵɵpipeBind2(2, 1, ctx_r1.FlowBuilderStepEntityType.organization, ctx_r1.getFlowBuilderEntityTypeFieldsByEntityType)) == null ? null : tmp_5_0.fields) !== null && tmp_5_0 !== undefined ? tmp_5_0 : i0.ɵɵpureFunction0(4, _c1));
  }
}
function AzavistaFlowStepComponent_ng_container_16_ng_container_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_16_ng_container_28_ng_container_1_Template, 3, 5, "ng-container", 5);
    i0.ɵɵpipe(2, "apply");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (tmp_3_0 = (tmp_3_0 = i0.ɵɵpipeBind2(2, 1, ctx_r1.FlowBuilderStepEntityType.contact, ctx_r1.getFlowBuilderEntityTypeFieldsByEntityType)) == null ? null : tmp_3_0.fields) !== null && tmp_3_0 !== undefined ? tmp_3_0 : i0.ɵɵpureFunction0(4, _c1));
  }
}
function AzavistaFlowStepComponent_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 16);
    i0.ɵɵelement(2, "input", 17);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-form-field", 16);
    i0.ɵɵelement(5, "input", 17);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, AzavistaFlowStepComponent_ng_container_16_ng_container_8_Template, 4, 3, "ng-container", 5)(9, AzavistaFlowStepComponent_ng_container_16_ng_container_9_Template, 3, 2, "ng-container", 5)(10, AzavistaFlowStepComponent_ng_container_16_ng_container_10_Template, 3, 2, "ng-container", 5)(11, AzavistaFlowStepComponent_ng_container_16_ng_container_11_Template, 3, 2, "ng-container", 5)(12, AzavistaFlowStepComponent_ng_container_16_ng_container_12_Template, 3, 2, "ng-container", 5)(13, AzavistaFlowStepComponent_ng_container_16_ng_container_13_Template, 3, 9, "ng-container", 5)(14, AzavistaFlowStepComponent_ng_container_16_ng_container_14_Template, 7, 27, "ng-container", 5)(15, AzavistaFlowStepComponent_ng_container_16_ng_container_15_Template, 3, 2, "ng-container", 5)(16, AzavistaFlowStepComponent_ng_container_16_ng_container_16_Template, 3, 2, "ng-container", 5)(17, AzavistaFlowStepComponent_ng_container_16_ng_container_17_Template, 10, 12, "ng-container", 5)(18, AzavistaFlowStepComponent_ng_container_16_ng_container_18_Template, 3, 2, "ng-container", 5)(19, AzavistaFlowStepComponent_ng_container_16_ng_container_19_Template, 3, 2, "ng-container", 5)(20, AzavistaFlowStepComponent_ng_container_16_ng_container_20_Template, 2, 1, "ng-container", 5)(21, AzavistaFlowStepComponent_ng_container_16_ng_container_21_Template, 3, 2, "ng-container", 5)(22, AzavistaFlowStepComponent_ng_container_16_ng_container_22_Template, 3, 2, "ng-container", 5)(23, AzavistaFlowStepComponent_ng_container_16_ng_container_23_Template, 3, 2, "ng-container", 5)(24, AzavistaFlowStepComponent_ng_container_16_ng_container_24_Template, 3, 2, "ng-container", 5)(25, AzavistaFlowStepComponent_ng_container_16_ng_container_25_Template, 3, 2, "ng-container", 5)(26, AzavistaFlowStepComponent_ng_container_16_ng_container_26_Template, 5, 12, "ng-container", 5)(27, AzavistaFlowStepComponent_ng_container_16_ng_container_27_Template, 7, 25, "ng-container", 5)(28, AzavistaFlowStepComponent_ng_container_16_ng_container_28_Template, 3, 5, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.step.entity_type);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 25, "SELECT_ENTITY"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(6, 27, ctx_r1.getActionLabelTranslationKey(ctx_r1.step.config == null ? null : ctx_r1.step.config.action)));
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 29, "ACTION_TYPE"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.setField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.email);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isAddOrRemoveTeam);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isGeneralEmail);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isEmailFromField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isAddContactToEvent);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isGenerateCertificate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isCreateEvent);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSetDateTimeFieldToCurrent);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.setRelativeDateTime || (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.setRelativeTime);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isWebhook);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSendGenericEmail);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.sendEmailToApprover);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSetReferenceNumber);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSendObject);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isCountSelectField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isCopyEventDates);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isCopyEventTextField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isMessageToContactOrParticipant);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSendMessageToUser);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.step.config == null ? null : ctx_r1.step.config.action) === ctx_r1.actionType.updateContactToOrganization);
  }
}
function AzavistaFlowStepComponent_ng_container_17_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.waitStepTimeType == null ? null : ctx_r1.waitStepTimeType.label);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 2, "SELECTOR"));
  }
}
function AzavistaFlowStepComponent_ng_container_17_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 41);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_17_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r62);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onWaitStepTimeTypeChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 6, "SELECTOR"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.waitTimeType.field)("value", ctx_r1.flowStepFields.waitTimeType.value)("fullWidth", true)("canEdit", true)("editMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_17_ng_container_1_Template, 4, 4, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_17_ng_container_2_Template, 3, 8, "ng-container", 5);
    i0.ɵɵelementStart(3, "azavista-input-field", 70);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_17_Template_azavista_input_field_valueChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r61);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onWaitStepValueChanged($event));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_17_Template_azavista_input_field_invalidValueSet_3_listener() {
      i0.ɵɵrestoreView(_r61);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onWaitStepInvalidValueSet());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(4, 9, "NUMBER"));
    i0.ɵɵproperty("field", ctx_r1.waitAndWaitUntilFieldStepsAzavistaInputField)("value", ctx_r1.waitStepTimeValue)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_18_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-form-field", 18);
    i0.ɵɵelement(6, "input", 19);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "mat-form-field", 18);
    i0.ɵɵelement(9, "input", 19);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "mat-form-field", 18);
    i0.ɵɵelement(12, "input", 19);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "mat-form-field", 18);
    i0.ɵɵelement(15, "input", 59);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(3, 9, ctx_r1.waitUntilFieldStepFieldTypeTranslationKey));
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(4, 11, "FIELD_TYPE"));
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 13, "FIELD"));
    i0.ɵɵproperty("value", ctx_r1.waitUntilFieldStepField == null ? null : ctx_r1.waitUntilFieldStepField.label);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.waitUntilFieldStepTimeType == null ? null : ctx_r1.waitUntilFieldStepTimeType.label);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 15, "SELECTOR"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.waitUntilFieldStepOffsetSeconds);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(13, 17, "NUMBER"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(16, 19, ctx_r1.getTimeOffsetDirectionTranslationKey(ctx_r1.waitUntilFieldStepOffsetDirection)));
  }
}
function AzavistaFlowStepComponent_ng_container_18_ng_container_2_azavista_input_field_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 41);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_18_ng_container_2_azavista_input_field_3_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r64);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onWaitUntilFieldFieldChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 6, "FIELD"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.waitUntilField.field)("value", ctx_r1.flowStepFields.waitUntilField.value)("fullWidth", true)("canEdit", true)("editMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_18_ng_container_2_mat_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const timeType_r65 = ctx.$implicit;
    i0.ɵɵproperty("value", timeType_r65);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", timeType_r65.label, " ");
  }
}
function AzavistaFlowStepComponent_ng_container_18_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 41);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_18_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r63);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onWaitUntilFieldStepFieldTypeChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AzavistaFlowStepComponent_ng_container_18_ng_container_2_azavista_input_field_3_Template, 2, 8, "azavista-input-field", 71);
    i0.ɵɵelementStart(4, "mat-form-field", 16)(5, "mat-select", 20);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵlistener("selectionChange", function AzavistaFlowStepComponent_ng_container_18_ng_container_2_Template_mat_select_selectionChange_5_listener() {
      i0.ɵɵrestoreView(_r63);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onWaitUntilFieldStepTimeTypeChanged());
    });
    i0.ɵɵtwoWayListener("valueChange", function AzavistaFlowStepComponent_ng_container_18_ng_container_2_Template_mat_select_valueChange_5_listener($event) {
      i0.ɵɵrestoreView(_r63);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.waitUntilFieldStepTimeType, $event) || (ctx_r1.waitUntilFieldStepTimeType = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(7, AzavistaFlowStepComponent_ng_container_18_ng_container_2_mat_option_7_Template, 2, 2, "mat-option", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "azavista-input-field", 70);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_18_ng_container_2_Template_azavista_input_field_valueChanged_8_listener($event) {
      i0.ɵɵrestoreView(_r63);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onWaitUntilFieldStepOffsetSecondsChanged($event));
    })("invalidValueSet", function AzavistaFlowStepComponent_ng_container_18_ng_container_2_Template_azavista_input_field_invalidValueSet_8_listener() {
      i0.ɵɵrestoreView(_r63);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onWaitUntilFieldStepOffsetSecondsInvalidValueSet());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "mat-form-field", 16)(11, "mat-select", 72);
    i0.ɵɵtwoWayListener("ngModelChange", function AzavistaFlowStepComponent_ng_container_18_ng_container_2_Template_mat_select_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r63);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.waitUntilFieldStepOffsetDirection, $event) || (ctx_r1.waitUntilFieldStepOffsetDirection = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("selectionChange", function AzavistaFlowStepComponent_ng_container_18_ng_container_2_Template_mat_select_selectionChange_11_listener() {
      i0.ɵɵrestoreView(_r63);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onWaitUntilFieldStepOffsetDirectionChange());
    });
    i0.ɵɵelementStart(12, "mat-option", 73)(13, "span", 8);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "mat-option", 74)(17, "span", 8);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 20, "FIELD_TYPE"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.waitUntilFieldType.field)("value", ctx_r1.flowStepFields.waitUntilFieldType.value)("fullWidth", true)("canEdit", true)("editMode", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.flowStepFields.waitUntilField);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 22, "SELECTOR"));
    i0.ɵɵtwoWayProperty("value", ctx_r1.waitUntilFieldStepTimeType);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.waitUntilFieldStepTimeTypes);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(9, 24, "OFFSET"));
    i0.ɵɵproperty("field", ctx_r1.waitAndWaitUntilFieldStepsAzavistaInputField)("value", ctx_r1.waitUntilFieldStepOffsetSeconds)("canEdit", ctx_r1.editMode)("fullWidth", true)("editMode", ctx_r1.editMode)("showLabelInReadonlyMode", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.waitUntilFieldStepOffsetDirection);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 26, ctx_r1.getTimeOffsetDirectionTranslationKey("after")));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 28, ctx_r1.getTimeOffsetDirectionTranslationKey("before")));
  }
}
function AzavistaFlowStepComponent_ng_container_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_18_ng_container_1_Template, 17, 21, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_18_ng_container_2_Template, 20, 30, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_19_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 2, "NEXT_STAGE"));
    i0.ɵɵproperty("value", ctx_r1.stageName);
  }
}
function AzavistaFlowStepComponent_ng_container_19_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 41);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_19_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r66);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onStageChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 6, "NEXT_STAGE"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.stage.field)("value", ctx_r1.flowStepFields.stage.value)("fullWidth", true)("canEdit", true)("editMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_19_ng_container_1_Template, 4, 4, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_19_ng_container_2_Template, 3, 8, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowStepComponent_ng_container_20_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 18);
    i0.ɵɵelement(2, "input", 19);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "apply");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 2, "NEXT_WORKFLOW"));
    i0.ɵɵproperty("value", i0.ɵɵpipeBind2(4, 4, ctx_r1.step.workflow_id, ctx_r1.getWorkflowName));
  }
}
function AzavistaFlowStepComponent_ng_container_20_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "azavista-input-field", 41);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaFlowStepComponent_ng_container_20_ng_container_2_Template_azavista_input_field_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r67);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onWorkflowChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 6, "NEXT_WORKFLOW"));
    i0.ɵɵproperty("field", ctx_r1.flowStepFields.workflow_id.field)("value", ctx_r1.flowStepFields.workflow_id.value)("fullWidth", true)("canEdit", true)("editMode", true);
  }
}
function AzavistaFlowStepComponent_ng_container_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowStepComponent_ng_container_20_ng_container_1_Template, 5, 7, "ng-container", 5)(2, AzavistaFlowStepComponent_ng_container_20_ng_container_2_Template, 3, 8, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
const _c3 = a0 => ({
  elements: a0,
  level: 0,
  type: "base"
});
const _c4 = (a0, a1) => ({
  "status-active": a0,
  "status-inactive": a1
});
const _c5 = a0 => ({
  "query-droplist-container": a0
});
const _c6 = (a0, a1, a2) => ({
  elements: a0,
  level: a1,
  type: a2
});
function AzavistaFlowBuilderComponent_div_4_azavista_flat_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 18);
    i0.ɵɵlistener("click", function AzavistaFlowBuilderComponent_div_4_azavista_flat_button_4_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.cancelChanges());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "uppercase");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, i0.ɵɵpipeBind1(3, 1, "CANCEL")));
  }
}
function AzavistaFlowBuilderComponent_div_4_azavista_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 19);
    i0.ɵɵlistener("click", function AzavistaFlowBuilderComponent_div_4_azavista_button_5_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onChangesSaved());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "uppercase");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, i0.ɵɵpipeBind1(3, 1, "SAVE_CHANGES")));
  }
}
function AzavistaFlowBuilderComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "mat-slide-toggle", 14);
    i0.ɵɵlistener("change", function AzavistaFlowBuilderComponent_div_4_Template_mat_slide_toggle_change_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEditModeChanged($event));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function AzavistaFlowBuilderComponent_div_4_Template_mat_slide_toggle_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.editMode, $event) || (ctx_r1.editMode = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(2, "span", 15);
    i0.ɵɵtext(3, "EDIT_MODE");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, AzavistaFlowBuilderComponent_div_4_azavista_flat_button_4_Template, 5, 5, "azavista-flat-button", 16)(5, AzavistaFlowBuilderComponent_div_4_azavista_button_5_Template, 5, 5, "azavista-button", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.editMode);
    i0.ɵɵproperty("disabled", ctx_r1.editStepsDisabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.editMode);
  }
}
function AzavistaFlowBuilderComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
  }
}
function AzavistaFlowBuilderComponent_div_6_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "INACTIVE"));
  }
}
function AzavistaFlowBuilderComponent_div_6_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "STARTED"));
  }
}
function AzavistaFlowBuilderComponent_div_6_azavista_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 31);
    i0.ɵɵlistener("click", function AzavistaFlowBuilderComponent_div_6_azavista_button_5_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleFlowPaused());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("acl", ctx_r1.canEditPausedAcl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "START"), " ");
  }
}
function AzavistaFlowBuilderComponent_div_6_azavista_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 32);
    i0.ɵɵlistener("click", function AzavistaFlowBuilderComponent_div_6_azavista_button_6_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleFlowPaused());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("acl", ctx_r1.canEditPausedAcl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "STOP"), " ");
  }
}
function AzavistaFlowBuilderComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "mat-chip-set")(2, "mat-chip", 22);
    i0.ɵɵtemplate(3, AzavistaFlowBuilderComponent_div_6_span_3_Template, 3, 3, "span", 23)(4, AzavistaFlowBuilderComponent_div_6_span_4_Template, 3, 3, "span", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, AzavistaFlowBuilderComponent_div_6_azavista_button_5_Template, 3, 4, "azavista-button", 24)(6, AzavistaFlowBuilderComponent_div_6_azavista_button_6_Template, 3, 4, "azavista-button", 25);
    i0.ɵɵelementStart(7, "button", 26)(8, "mat-icon");
    i0.ɵɵtext(9, "more_vert");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "mat-menu", null, 1)(12, "div", 27)(13, "azavista-button", 28);
    i0.ɵɵlistener("click", function AzavistaFlowBuilderComponent_div_6_Template_azavista_button_click_13_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.interruptFlow());
    });
    i0.ɵɵelementStart(14, "mat-icon", 29);
    i0.ɵɵtext(15, "not_interested");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const triggerMenu_r8 = i0.ɵɵreference(11);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("background-color", ctx_r1.flowPaused ? "red" : "green");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c4, !ctx_r1.flowPaused, ctx_r1.flowPaused));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.flowPaused);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.flowPaused);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.flowPaused);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.flowPaused);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matMenuTriggerFor", triggerMenu_r8);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("acl", ctx_r1.canInterruptAcl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 10, "INTERRUPT"), " ");
  }
}
function AzavistaFlowBuilderComponent_ng_template_11_Template(rf, ctx) {}
function AzavistaFlowBuilderComponent_ng_container_12_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function AzavistaFlowBuilderComponent_ng_container_12_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAddStepClicked(ctx_r1.stepType.action));
    });
    i0.ɵɵelementStart(1, "mat-icon", 37);
    i0.ɵɵtext(2, "add_circle_outline");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFlowBuilderComponent_ng_container_12_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function AzavistaFlowBuilderComponent_ng_container_12_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAddStepClicked(ctx_r1.stepType.decision));
    });
    i0.ɵɵelementStart(1, "mat-icon", 38);
    i0.ɵɵtext(2, "add_circle_outline");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFlowBuilderComponent_ng_container_12_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function AzavistaFlowBuilderComponent_ng_container_12_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAddStepClicked(ctx_r1.stepType.wait));
    });
    i0.ɵɵelementStart(1, "mat-icon", 39);
    i0.ɵɵtext(2, "add_circle_outline");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFlowBuilderComponent_ng_container_12_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function AzavistaFlowBuilderComponent_ng_container_12_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAddStepClicked(ctx_r1.stepType.stageChange));
    });
    i0.ɵɵelementStart(1, "mat-icon", 40);
    i0.ɵɵtext(2, "add_circle_outline");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFlowBuilderComponent_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "mat-divider", 33);
    i0.ɵɵelementStart(2, "div", 34);
    i0.ɵɵtemplate(3, AzavistaFlowBuilderComponent_ng_container_12_button_3_Template, 3, 0, "button", 35)(4, AzavistaFlowBuilderComponent_ng_container_12_button_4_Template, 3, 0, "button", 35)(5, AzavistaFlowBuilderComponent_ng_container_12_button_5_Template, 3, 0, "button", 35)(6, AzavistaFlowBuilderComponent_ng_container_12_button_6_Template, 3, 0, "button", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.showAddActionStep);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showAddDecisionStep);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showAddWaitStep);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showAddStageChangeStep);
  }
}
function AzavistaFlowBuilderComponent_ng_template_13_div_2_ng_container_2_ng_template_1_Template(rf, ctx) {}
function AzavistaFlowBuilderComponent_ng_template_13_div_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFlowBuilderComponent_ng_template_13_div_2_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const element_r17 = i0.ɵɵnextContext().$implicit;
    const level_r18 = i0.ɵɵnextContext().level;
    i0.ɵɵnextContext();
    const recursiveLevel_r19 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", recursiveLevel_r19)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6, element_r17.steps_if_true, level_r18 + 1, element_r17.type));
  }
}
function AzavistaFlowBuilderComponent_ng_template_13_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵlistener("cdkDragEntered", function AzavistaFlowBuilderComponent_ng_template_13_div_2_Template_div_cdkDragEntered_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDragEntered($event));
    })("cdkDragStarted", function AzavistaFlowBuilderComponent_ng_template_13_div_2_Template_div_cdkDragStarted_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDragStarted($event));
    });
    i0.ɵɵelementStart(1, "azavista-flow-step", 44);
    i0.ɵɵlistener("delete", function AzavistaFlowBuilderComponent_ng_template_13_div_2_Template_azavista_flow_step_delete_1_listener() {
      const i_r15 = i0.ɵɵrestoreView(_r14).index;
      const elements_r16 = i0.ɵɵnextContext().elements;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDeleteStepClicked(elements_r16, i_r15));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, AzavistaFlowBuilderComponent_ng_template_13_div_2_ng_container_2_Template, 2, 6, "ng-container", 12);
    i0.ɵɵpipe(3, "apply");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r17 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cdkDragDisabled", !ctx_r1.enabledStepTypes[element_r17.type]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("step", element_r17)("editMode", ctx_r1.editMode)("stages", ctx_r1.stages)("workflows", ctx_r1.workflows)("entityTypeFields", ctx_r1.fields)("additionalEntityFields", ctx_r1.additionalFields)("sortStepFields", ctx_r1.sortStepFields)("globalProcessEntityType", ctx_r1.globalProcessEntityType)("emailTemplates", ctx_r1.emailTemplates)("teams", ctx_r1.teams)("eventActivities", ctx_r1.eventActivities)("eventAppPages", ctx_r1.eventAppPages)("emailCampaigns", ctx_r1.emailCampaigns)("integrations", ctx_r1.integrations)("languages", ctx_r1.languages)("fieldsOptions", ctx_r1.fieldsOptions)("templateEvents", ctx_r1.templateEvents)("templateEventFieldsSubject", ctx_r1.templateEventFieldsSubject)("deleteDisabled", !ctx_r1.enabledStepTypes[element_r17.type])("isGlobalParticipant", ctx_r1.isGlobalParticipant)("docxDocuments", ctx_r1.docxDocuments)("documentFields", ctx_r1.documentFields)("users", ctx_r1.users)("events", ctx_r1.events);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(3, 26, element_r17.type, ctx_r1.isHavingNestedStep));
  }
}
function AzavistaFlowBuilderComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵpipe(1, "apply");
    i0.ɵɵlistener("cdkDropListDropped", function AzavistaFlowBuilderComponent_ng_template_13_Template_div_cdkDropListDropped_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.elementDrop($event));
    });
    i0.ɵɵtemplate(2, AzavistaFlowBuilderComponent_ng_template_13_div_2_Template, 4, 29, "div", 42);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const elements_r16 = ctx.elements;
    const level_r18 = ctx.level;
    const type_r20 = ctx.type;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("padding-left", level_r18 === 0 ? "0" : "32", "px");
    i0.ɵɵproperty("cdkDropListData", elements_r16)("cdkDropListDisabled", !ctx_r1.editMode)("cdkDropListConnectedTo", ctx_r1.dls)("ngClass", i0.ɵɵpureFunction1(10, _c5, i0.ɵɵpipeBind2(1, 7, type_r20, ctx_r1.isHavingNestedStep) && elements_r16.length === 0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", elements_r16);
  }
}
var FlowBuilderStepType = /*#__PURE__*/function (FlowBuilderStepType) {
  FlowBuilderStepType["wait"] = "wait";
  FlowBuilderStepType["waitUntilField"] = "wait-until-field";
  FlowBuilderStepType["stageChange"] = "stage-change";
  FlowBuilderStepType["decision"] = "decision";
  FlowBuilderStepType["decisionExternalCRM"] = "decision_externalcrm";
  FlowBuilderStepType["decisionNow"] = "decision-now";
  FlowBuilderStepType["decisionPayment"] = "decision-payment";
  FlowBuilderStepType["action"] = "action";
  FlowBuilderStepType["stop"] = "stop";
  FlowBuilderStepType["advancedQuery"] = "advanced-query";
  FlowBuilderStepType["goToWorkflow"] = "go-to-workflow";
  return FlowBuilderStepType;
}(FlowBuilderStepType || {});
var FlowBuilderStepEntityType = /*#__PURE__*/function (FlowBuilderStepEntityType) {
  FlowBuilderStepEntityType["participant"] = "Participant";
  FlowBuilderStepEntityType["event"] = "Event";
  FlowBuilderStepEntityType["booking"] = "Booking";
  FlowBuilderStepEntityType["contact"] = "Contact";
  FlowBuilderStepEntityType["organization"] = "Organization";
  FlowBuilderStepEntityType["wait"] = "Wait";
  FlowBuilderStepEntityType["waitUntilField"] = "Wait until field";
  FlowBuilderStepEntityType["advancedQuery"] = "advanced-query";
  FlowBuilderStepEntityType["stop"] = "stop";
  FlowBuilderStepEntityType["stageChange"] = "stage-change";
  FlowBuilderStepEntityType["goToWorkflow"] = "go-to-workflow";
  // Additional entities that are used in Participant process
  FlowBuilderStepEntityType["eventSettings"] = "EventSettings";
  FlowBuilderStepEntityType["participantActivity"] = "ParticipantActivity";
  FlowBuilderStepEntityType["product"] = "Product";
  FlowBuilderStepEntityType["workflow"] = "Workflow";
  return FlowBuilderStepEntityType;
}(FlowBuilderStepEntityType || {});
var FlowBuilderStepActionType = /*#__PURE__*/function (FlowBuilderStepActionType) {
  FlowBuilderStepActionType["setField"] = "set-field";
  FlowBuilderStepActionType["email"] = "email";
  FlowBuilderStepActionType["addTeam"] = "add-team";
  FlowBuilderStepActionType["removeTeam"] = "remove-team";
  FlowBuilderStepActionType["generalEmail"] = "general-email";
  FlowBuilderStepActionType["emailFromField"] = "email-from-field";
  // This should be treated the same as email-from-field - event fields must be provided instead of participant fields
  // Also the action should be modified on notification to email-from-field
  FlowBuilderStepActionType["emailFromEventField"] = "email-from-event-field";
  FlowBuilderStepActionType["createEvent"] = "create-event";
  FlowBuilderStepActionType["setDateTimeFieldToCurrent"] = "set-date-time-to-current";
  FlowBuilderStepActionType["setRelativeDateTime"] = "set-relative-date-time";
  FlowBuilderStepActionType["setRelativeTime"] = "set-relative-time";
  FlowBuilderStepActionType["sendWebhook"] = "send-webhook";
  FlowBuilderStepActionType["sendGenericEmail"] = "send-generic-email";
  FlowBuilderStepActionType["sendEmailToApprover"] = "email-to-approver";
  FlowBuilderStepActionType["setReferenceNumber"] = "set-reference-number";
  FlowBuilderStepActionType["sendObject"] = "send-object";
  FlowBuilderStepActionType["countSelectField"] = "count-select-field";
  FlowBuilderStepActionType["copyEventDates"] = "copy-event-dates";
  FlowBuilderStepActionType["updateContactToOrganization"] = "update-contact-to-organization";
  FlowBuilderStepActionType["copyEventTextField"] = "copy-event-text-field";
  FlowBuilderStepActionType["messageToContact"] = "message-to-contact";
  FlowBuilderStepActionType["messageToParticipant"] = "message-to-participant";
  FlowBuilderStepActionType["sendMessageToUser"] = "send-message-to-user";
  FlowBuilderStepActionType["addContactToEvent"] = "add-contact-to-event";
  FlowBuilderStepActionType["generateCertificate"] = "generate-certificate";
  return FlowBuilderStepActionType;
}(FlowBuilderStepActionType || {});
var WaitUntilFieldStepFieldType = /*#__PURE__*/function (WaitUntilFieldStepFieldType) {
  WaitUntilFieldStepFieldType["eventField"] = "EventField";
  WaitUntilFieldStepFieldType["participantField"] = "ParticipantField";
  WaitUntilFieldStepFieldType["contactField"] = "ContactField";
  WaitUntilFieldStepFieldType["organizationField"] = "OrganizationField";
  return WaitUntilFieldStepFieldType;
}(WaitUntilFieldStepFieldType || {});
const FINISH_STEP_ENTITY_TYPES = [FlowBuilderStepEntityType.stageChange, FlowBuilderStepEntityType.stop, FlowBuilderStepEntityType.goToWorkflow];
const STEP_ENTITY_TYPES_TO_STEP_TYPE_MAPPING = {
  [FlowBuilderStepEntityType.stageChange]: FlowBuilderStepType.stageChange,
  [FlowBuilderStepEntityType.stop]: FlowBuilderStepType.stop,
  [FlowBuilderStepEntityType.goToWorkflow]: FlowBuilderStepType.goToWorkflow,
  [FlowBuilderStepEntityType.advancedQuery]: FlowBuilderStepType.advancedQuery
};
const STEP_TYPES_TRANSLATION_KEYS = {
  [FlowBuilderStepType.stop]: 'STOP',
  [FlowBuilderStepType.goToWorkflow]: 'GO_TO_WORKFLOW',
  [FlowBuilderStepType.stageChange]: 'CHANGE_STAGE',
  [FlowBuilderStepType.advancedQuery]: 'ADVANCED_QUERY'
};
const STEP_ENTITY_TYPES_TRANSLATION_KEYS = {
  [FlowBuilderStepEntityType.event]: 'EVENT',
  [FlowBuilderStepEntityType.eventSettings]: 'EVENT_SETTINGS',
  [FlowBuilderStepEntityType.participant]: 'PARTICIPANT',
  [FlowBuilderStepEntityType.participantActivity]: 'ACTIVITIES',
  [FlowBuilderStepEntityType.workflow]: 'WORKFLOW',
  [FlowBuilderStepEntityType.product]: 'PRODUCT'
};
let AzavistaFlowBuilderService = /*#__PURE__*/(() => {
  class AzavistaFlowBuilderService {
    constructor(translationSvc) {
      this.translationSvc = translationSvc;
    }
    createObjectEnumField() {
      const field = {
        editable: true,
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */
      };
      return field;
    }
    getActionLabelTranslation(action) {
      return this.translationSvc.getTranslation(this.getActionLabelTranslationKey(action));
    }
    getActionLabelTranslationKey(action) {
      if (action === FlowBuilderStepActionType.setField) {
        return 'SET_FIELD';
      } else if (action === FlowBuilderStepActionType.email) {
        return 'EMAIL_TO_PARTICIPANT';
      } else if (action === FlowBuilderStepActionType.addTeam) {
        return 'ADD_TEAM';
      } else if (action === FlowBuilderStepActionType.removeTeam) {
        return 'REMOVE_TEAM';
      } else if (action === FlowBuilderStepActionType.generalEmail) {
        return 'GENERAL_EMAIL';
      } else if (action === FlowBuilderStepActionType.emailFromField) {
        return 'EMAIL_FROM_FIELD';
      } else if (action === FlowBuilderStepActionType.emailFromEventField) {
        return 'EMAIL_FROM_EVENT_FIELD';
      } else if (action === FlowBuilderStepActionType.createEvent) {
        return 'CREATE_EVENT';
      } else if (action === FlowBuilderStepActionType.setDateTimeFieldToCurrent) {
        return 'SET_DATE_TIME_FIELD_TO_CURRENT';
      } else if (action === FlowBuilderStepActionType.setRelativeDateTime) {
        return 'SET_RELATIVE_DATE_TIME';
      } else if (action === FlowBuilderStepActionType.setRelativeTime) {
        return 'SET_RELATIVE_TIME';
      } else if (action === FlowBuilderStepActionType.sendWebhook) {
        return 'WEBHOOK';
      } else if (action === FlowBuilderStepActionType.sendGenericEmail) {
        return 'SEND_GENERIC_EMAIL';
      } else if (action === FlowBuilderStepActionType.sendEmailToApprover) {
        return 'SEND_EMAIL_TO_APPROVER';
      } else if (action === FlowBuilderStepActionType.setReferenceNumber) {
        return 'SET_REFERENCE_NUMBER';
      } else if (action === FlowBuilderStepActionType.sendObject) {
        return 'SEND_OBJECT';
      } else if (action === FlowBuilderStepActionType.countSelectField) {
        return 'COUNT_SELECT_FIELD';
      } else if (action === FlowBuilderStepActionType.copyEventDates) {
        return 'COPY_EVENT_DATES';
      } else if (action === FlowBuilderStepActionType.copyEventTextField) {
        return 'COPY_EVENT_TEXT_FIELD_TO_PARTICIPANT';
      } else if (action === FlowBuilderStepActionType.messageToContact) {
        return 'MESSAGE_TO_CONTACT';
      } else if (action === FlowBuilderStepActionType.messageToParticipant) {
        return 'MESSAGE_TO_PARTICIPANT';
      } else if (action === FlowBuilderStepActionType.sendMessageToUser) {
        return 'SEND_MESSAGE_TO_USER';
      } else if (action === FlowBuilderStepActionType.addContactToEvent) {
        return 'ADD_TO_EVENT';
      } else if (action === FlowBuilderStepActionType.generateCertificate) {
        return 'CREATE_CERTIFICATE_DOCUMENT';
      } else if (action === FlowBuilderStepActionType.updateContactToOrganization) {
        return 'UPDATE_MULTIPLE_ORGANIZATION_FIELDS';
      } else {
        return '';
      }
    }
    getNewStep(type, stepData) {
      let newStep;
      switch (type) {
        case FlowBuilderStepType.wait:
          newStep = {
            type: type,
            duration_seconds: 1
          };
          break;
        case FlowBuilderStepType.waitUntilField:
          newStep = {
            type: type,
            offset_seconds: 0,
            field_type: '',
            field_id: ''
          };
          break;
        case FlowBuilderStepType.stageChange:
          newStep = {
            type: type,
            stage_id: null
          };
          break;
        case FlowBuilderStepType.action:
          let config;
          if (stepData && stepData.action === FlowBuilderStepActionType.email) {
            config = {
              action: stepData.action,
              email_campaign_id: null,
              recipients: {
                actor: true
              }
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.setField) {
            config = {
              action: stepData.action,
              field_id: null,
              value: null
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.addTeam) {
            config = {
              action: stepData.action,
              team_id: 0
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.removeTeam) {
            config = {
              action: stepData.action,
              team_id: 0
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.generalEmail) {
            config = {
              action: stepData.action,
              email_campaign_id: '',
              to_email: '',
              language: ''
            };
          } else if (stepData && (stepData.action === FlowBuilderStepActionType.emailFromField || stepData.action === FlowBuilderStepActionType.emailFromEventField)) {
            config = {
              action: stepData.action,
              email_campaign_id: '',
              field: {
                type: '',
                id: ''
              },
              language: ''
            };
            // } else if (stepData && stepData.action === FlowBuilderStepActionType.emailFromEventField) {
            //     config = {
            //         action: stepData.action,
            //         email_campaign_id: '',
            //         field: {
            //             type: '',
            //             id: ''
            //         },
            //         language: ''
            //     };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.createEvent) {
            config = {
              action: stepData.action,
              initial_team_id: 0,
              template_id: '',
              field_mapping: {}
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.setDateTimeFieldToCurrent) {
            config = {
              action: stepData.action,
              offset_in_seconds_from_current: 0,
              field_id: ''
            };
          } else if (stepData && (stepData.action === FlowBuilderStepActionType.setRelativeDateTime || stepData.action === FlowBuilderStepActionType.setRelativeTime)) {
            config = {
              action: stepData.action,
              offset_seconds: 0,
              field_id: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.sendWebhook) {
            config = {
              action: stepData.action,
              integration_id: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.sendGenericEmail) {
            config = {
              action: stepData.action,
              email_template_id: '',
              to_email: '',
              language: '',
              from: {
                name: '',
                email: ''
              },
              reply_email: '',
              bounce_email: '',
              subject: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.sendEmailToApprover) {
            config = {
              action: stepData.action,
              email_campaign_id: '',
              approver_field_id: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.setReferenceNumber) {
            config = {
              action: FlowBuilderStepActionType.setReferenceNumber,
              field_id: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.sendObject) {
            config = {
              action: FlowBuilderStepActionType.sendObject,
              integration_id: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.countSelectField) {
            config = {
              action: FlowBuilderStepActionType.countSelectField,
              number_field_id: '',
              select_field_id: '',
              select_field_value: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.copyEventDates) {
            config = {
              action: FlowBuilderStepActionType.copyEventDates,
              end_date_field_id: '',
              start_date_field_id: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.copyEventTextField) {
            config = {
              action: FlowBuilderStepActionType.copyEventTextField,
              text_field_id: '',
              event_field_id: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.messageToContact) {
            config = {
              action: FlowBuilderStepActionType.messageToContact,
              email_id: '',
              first_name_id: '',
              integration_id: '',
              last_name_id: '',
              message: '',
              number_id: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.messageToParticipant) {
            config = {
              action: FlowBuilderStepActionType.messageToParticipant,
              email_id: '',
              first_name_id: '',
              integration_id: '',
              last_name_id: '',
              message: '',
              number_id: ''
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.sendMessageToUser) {
            config = {
              action: FlowBuilderStepActionType.sendMessageToUser,
              integration_id: '',
              message: '',
              user_ids: []
            };
          } else if (stepData && stepData.action === FlowBuilderStepActionType.addContactToEvent) {
            const cfg = {
              action: FlowBuilderStepActionType.addContactToEvent,
              event_id: ''
            };
            config = cfg;
          } else if (stepData && stepData.action === FlowBuilderStepActionType.generateCertificate) {
            const cfg = {
              action: FlowBuilderStepActionType.generateCertificate,
              document_field_id: '',
              document_id: '',
              document_name: ''
            };
            config = cfg;
          } else if (stepData && stepData.action === FlowBuilderStepActionType.updateContactToOrganization) {
            const cfg = {
              action: FlowBuilderStepActionType.updateContactToOrganization,
              fields: []
            };
            config = cfg;
          }
          newStep = {
            type: type,
            entity_type: stepData && stepData.entityType,
            config: config
          };
          break;
        case FlowBuilderStepType.decision:
          newStep = {
            type: type,
            steps_if_true: [],
            entity_type: stepData && stepData.entityType,
            // TODO: flatSearchToRecursive should generate "empty" object if empty array is provided
            condition: {
              and: []
            } // flatSearchToRecursive([], 'name')
          };
          break;
        case FlowBuilderStepType.decisionNow:
          newStep = {
            type: type,
            steps_if_true: [],
            entity_type: stepData && stepData.entityType,
            condition: {
              and: []
            },
            // flatSearchToRecursive([], 'name')
            config: {}
          };
          break;
        case FlowBuilderStepType.decisionPayment:
          newStep = {
            type: type,
            steps_if_true: [],
            entity_type: stepData?.entityType,
            config: {}
          };
          break;
        case FlowBuilderStepType.advancedQuery:
          newStep = {
            type,
            steps_if_true: [],
            condition: [[]]
          };
          break;
        case FlowBuilderStepType.goToWorkflow:
          newStep = {
            type,
            workflow_id: null
          };
          break;
        case FlowBuilderStepType.stop:
          newStep = {
            type
          };
          break;
      }
      return newStep;
    }
    getNewStepInitialValue(type, stepData) {
      if (type === FlowBuilderStepType.wait || type === FlowBuilderStepType.waitUntilField || type === FlowBuilderStepType.stageChange || stepData?.type === FlowBuilderStepType.advancedQuery) {
        type = stepData.type;
      }
      const newStep = this.getNewStep(type, stepData);
      newStep.id ||= this.getBsonId();
      return {
        newStep,
        type
      };
    }
    getBsonId() {
      return bsonObjectId().toHexString();
    }
    static {
      this.ɵfac = function AzavistaFlowBuilderService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowBuilderService)(i0.ɵɵinject(i2.TranslationService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaFlowBuilderService,
        factory: AzavistaFlowBuilderService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaFlowBuilderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FlowStepAddNewService = /*#__PURE__*/(() => {
  class FlowStepAddNewService {
    constructor(flowBuilderSvc, sharedSvc) {
      this.flowBuilderSvc = flowBuilderSvc;
      this.sharedSvc = sharedSvc;
    }
    createEntityTypeFieldValue(entityTypes, selectedEntityType) {
      const items = [];
      for (const entityType of entityTypes) {
        const translationKey = STEP_TYPES_TRANSLATION_KEYS[entityType];
        items.push({
          id: entityType,
          label: translationKey ? this.sharedSvc.translate(translationKey) : entityType
        });
      }
      const actionTypeFieldValue = {
        displayProperty: 'label',
        items: items,
        selected: items.find(x => x.id === selectedEntityType),
        reportProperty: 'id'
      };
      return actionTypeFieldValue;
    }
    createActionTypeFieldValue(actions, selectedAction) {
      const items = [];
      for (const action of actions) {
        items.push({
          id: action,
          label: this.flowBuilderSvc.getActionLabelTranslation(action)
        });
      }
      const actionTypeFieldValue = {
        displayProperty: 'label',
        items: items,
        selected: items.find(x => x.id === selectedAction),
        reportProperty: 'id'
      };
      return actionTypeFieldValue;
    }
    static {
      this.ɵfac = function FlowStepAddNewService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FlowStepAddNewService)(i0.ɵɵinject(AzavistaFlowBuilderService), i0.ɵɵinject(i2.AzavistaSharedService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FlowStepAddNewService,
        factory: FlowStepAddNewService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FlowStepAddNewService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFlowStepAddNewComponent = /*#__PURE__*/(() => {
  class AzavistaFlowStepAddNewComponent {
    constructor(dialogRef, data, flowBuilderSvc, flowStepAddNewSvc) {
      this.dialogRef = dialogRef;
      this.data = data;
      this.flowBuilderSvc = flowBuilderSvc;
      this.flowStepAddNewSvc = flowStepAddNewSvc;
      this.stepType = FlowBuilderStepType;
    }
    ngOnInit() {
      // this.titleTranslationKey = this.data.type === this.stepType.action ?
      //     'ADD_ACTION_BLOCK' :
      //     'ADD_QUERY_BLOCK';
      if (this.data.type === this.stepType.action) {
        this.titleTranslationKey = 'ADD_ACTION_BLOCK';
      } else if (this.data.type === FlowBuilderStepType.decision) {
        this.titleTranslationKey = 'ADD_QUERY_BLOCK';
      } else if (this.data.type === FlowBuilderStepType.wait) {
        this.titleTranslationKey = 'ADD_WAIT_BLOCK';
      } else if (this.data.type === FlowBuilderStepType.stageChange) {
        this.titleTranslationKey = 'ADD_PROCESS_FLOW_STEP';
      }
      if (this.data.type === this.stepType.decision && this.data.addNewConfig && this.data.addNewConfig.decisionStepConfig) {
        this.entityTypes = this.data.addNewConfig.decisionStepConfig.entityTypeNames;
        this.selectedEntityType = this.entityTypes && this.entityTypes[0];
      }
      if (this.data.type === this.stepType.action && this.data.addNewConfig && this.data.addNewConfig.actionStepConfig) {
        this.entityTypes = this.getActionStepEntityTypes(this.data.addNewConfig.actionStepConfig.entityTypes);
        this.selectedEntityType = this.entityTypes && this.entityTypes[0];
        this.actions = this.getActionStepActions(this.data.addNewConfig.actionStepConfig.entityTypes, this.selectedEntityType);
        this.selectedAction = this.actions && this.actions[0];
      }
      if (this.data.type === FlowBuilderStepType.wait || this.data.type === FlowBuilderStepType.waitUntilField) {
        this.entityTypes = [FlowBuilderStepEntityType.wait, FlowBuilderStepEntityType.waitUntilField];
        this.selectedEntityType = this.entityTypes[0];
      }
      if (this.data.type === FlowBuilderStepType.stageChange) {
        this.entityTypes = FINISH_STEP_ENTITY_TYPES;
        this.selectedEntityType = this.entityTypes[0];
      }
      this.createFields();
    }
    createFields() {
      this.entityTypeField = this.flowBuilderSvc.createObjectEnumField();
      this.entityTypeFieldValue = this.flowStepAddNewSvc.createEntityTypeFieldValue(this.entityTypes, this.selectedEntityType);
      this.setActionsSelectItems();
    }
    setActionsSelectItems() {
      if (this.actions) {
        this.actionTypeField = this.flowBuilderSvc.createObjectEnumField();
        this.actionTypeFieldValue = this.flowStepAddNewSvc.createActionTypeFieldValue(this.actions, this.selectedAction);
      }
    }
    onActionTypeValueChanged(args) {
      this.selectedAction = args.value;
    }
    onSelectedEntityTypeChange(args) {
      this.selectedEntityType = args.value;
      if (args.value === FlowBuilderStepEntityType.wait) {
        this.data.type = FlowBuilderStepType.wait;
        return;
      } else if (args.value === FlowBuilderStepEntityType.waitUntilField) {
        this.data.type = FlowBuilderStepType.waitUntilField;
        return;
      } else if (STEP_ENTITY_TYPES_TO_STEP_TYPE_MAPPING[args.value]) {
        this.data.type = STEP_ENTITY_TYPES_TO_STEP_TYPE_MAPPING[args.value];
        return;
      }
      const selectedEntityType = args.value;
      const entityTypes = this.data && this.data.addNewConfig && this.data.addNewConfig.actionStepConfig && this.data.addNewConfig.actionStepConfig.entityTypes;
      if (this.data.type !== FlowBuilderStepType.decision) {
        // The FlowBuilderStepType.decision (QUERY) block does not have actions
        this.actions = this.getActionStepActions(entityTypes, selectedEntityType);
        this.selectedAction = this.actions[0];
        window.setTimeout(() => {
          this.actionTypeField = null;
          this.setActionsSelectItems();
        }, 0);
      }
    }
    getActionStepEntityTypes(actionStepEntityTypes) {
      if (!actionStepEntityTypes || !actionStepEntityTypes.length) {
        return [];
      }
      return actionStepEntityTypes.map(et => et.entityTypeName);
    }
    getActionStepActions(actionStepEntityTypes, entityType) {
      if (!actionStepEntityTypes || !actionStepEntityTypes.length || !entityType) {
        return [];
      }
      return actionStepEntityTypes.find(et => et.entityTypeName === entityType).actions;
    }
    // getActionLabelTranslationKey(action: FlowBuilderStepActionType): string {
    //     return this.flowBuilderSvc.getActionLabelTranslationKey(action);
    // }
    onCancelClick() {
      this.dialogRef.close();
    }
    onAddClick() {
      this.dialogRef.close({
        type: this.data.type,
        entityType: this.selectedEntityType,
        action: this.selectedAction
      });
    }
    static {
      this.ɵfac = function AzavistaFlowStepAddNewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowStepAddNewComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(AzavistaFlowBuilderService), i0.ɵɵdirectiveInject(FlowStepAddNewService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFlowStepAddNewComponent,
        selectors: [["azavista-flow-step-add-new"]],
        standalone: false,
        decls: 18,
        vars: 20,
        consts: [["mat-dialog-title", "", "translate", "", 1, "add-new-step-header", "aza-cmp-dialog-title"], ["mat-dialog-content", "", 1, "aza-cmp-dialog-content"], [1, "aza-cmp-flex-column"], [3, "valueChanged", "field", "label", "value", "canEdit", "editMode", "fullWidth"], [4, "ngIf"], ["mat-dialog-actions", "", 1, "aza-cmp-dialog-actions"], ["color", "primary", 1, "aza-cmp-dialog-action-cancel-button", 3, "click"], ["color", "primary", 1, "aza-cmp-dialog-action-add-button", 3, "click"], [3, "field", "label", "value", "canEdit", "editMode", "fullWidth", "valueChanged", 4, "ngIf"]],
        template: function AzavistaFlowStepAddNewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "azavista-input-field", 3);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵlistener("valueChanged", function AzavistaFlowStepAddNewComponent_Template_azavista_input_field_valueChanged_4_listener($event) {
              return ctx.onSelectedEntityTypeChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, AzavistaFlowStepAddNewComponent_ng_container_6_Template, 2, 1, "ng-container", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 5)(8, "azavista-flat-button", 6);
            i0.ɵɵlistener("click", function AzavistaFlowStepAddNewComponent_Template_azavista_flat_button_click_8_listener() {
              return ctx.onCancelClick();
            });
            i0.ɵɵelementStart(9, "span");
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵpipe(12, "uppercase");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "azavista-button", 7);
            i0.ɵɵlistener("click", function AzavistaFlowStepAddNewComponent_Template_azavista_button_click_13_listener() {
              return ctx.onAddClick();
            });
            i0.ɵɵelementStart(14, "span");
            i0.ɵɵtext(15);
            i0.ɵɵpipe(16, "translate");
            i0.ɵɵpipe(17, "uppercase");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.titleTranslationKey);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("field", ctx.entityTypeField)("label", i0.ɵɵpipeBind1(5, 10, "SELECT_ENTITY"))("value", ctx.entityTypeFieldValue)("canEdit", true)("editMode", true)("fullWidth", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.type) === ctx.stepType.action);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 14, i0.ɵɵpipeBind1(11, 12, "CANCEL")));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 18, i0.ɵɵpipeBind1(16, 16, "ADD")));
          }
        },
        dependencies: [i4.NgIf, i6.TranslateDirective, i4$1.AzavistaInputFieldComponent, i6$1.AzavistaButtonComponent, i6$1.AzavistaFlatButtonComponent, i1.MatDialogTitle, i1.MatDialogActions, i1.MatDialogContent, i4.UpperCasePipe, i6.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AzavistaFlowStepAddNewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFlowStepService = /*#__PURE__*/(() => {
  class AzavistaFlowStepService {
    constructor(sharedSvc, filterCriteriaTreeSvc) {
      this.sharedSvc = sharedSvc;
      this.filterCriteriaTreeSvc = filterCriteriaTreeSvc;
      this.getStepAdvancedQueryFilterData = (step, entityTypeFieldsCombined, readonly = false) => {
        const filter = flatSearchParamsToFilterTree(step.condition, step.id);
        const filterDialogData = {
          availableFields: this.getFieldsForAdvancedQueryConditionDialog(entityTypeFieldsCombined, this.sharedSvc),
          filter,
          allowedCriteriaRelationPerTreeLevel: {
            0: [CriteriaRelationOperator.or],
            1: [CriteriaRelationOperator.and]
          },
          isSaveButtonEnabledFn: data => {
            return (data.criteriaTree?.criteria?.length ?? 0) > 0;
          },
          readonly,
          canDelete: false,
          dialogTitle: this.sharedSvc.translate('MANAGE_CONDITIONS')
        };
        return filterDialogData;
      };
    }
    isCreateEventMappingConfigured(config, fieldsMap) {
      const teamAndTemplateSelected = config.initial_team_id && config.template_id;
      if (!teamAndTemplateSelected) {
        return false;
      }
      if (!fieldsMap || fieldsMap.length === 0) {
        // No mappings - its OK
        return true;
      }
      // Check mappings for missing requester or event fields
      for (const map of fieldsMap) {
        if (!map.requesterField || !map.eventField) {
          return false;
        }
      }
      // Check mappings for same requester fields
      const fieldIdsHash = {};
      for (const map of fieldsMap) {
        if (fieldIdsHash[map.requesterField.id] || fieldIdsHash[map.eventField.id]) {
          return false;
        }
        fieldIdsHash[map.requesterField.id] = true;
        fieldIdsHash[map.eventField.id] = true;
      }
      return true;
    }
    getLabel(idWithLabels, id) {
      if (!idWithLabels) {
        return null;
      }
      const existing = idWithLabels.find(x => x.id === id);
      return existing ? existing.label : null;
    }
    getNumberIdLabel(numberIdWithLabels, id) {
      if (!numberIdWithLabels) {
        return null;
      }
      const existing = numberIdWithLabels.find(x => x.id === id);
      return existing ? existing.label : null;
    }
    createRequestedFieldMappingSetting(requesterFieldToEventFieldMap) {
      const fieldMapping = {};
      for (const map of requesterFieldToEventFieldMap) {
        if (map.requesterField && map.eventField) {
          fieldMapping[map.requesterField.id] = map.eventField.id;
        }
      }
      return fieldMapping;
    }
    createRequesterWithEventFieldMapping(mapObj, requesterFields, eventFields) {
      const map = [];
      if (!mapObj) {
        return map;
      }
      const objKeys = Object.keys(mapObj);
      for (const requesterFieldId of objKeys) {
        const eventFieldId = mapObj[requesterFieldId];
        const requesterField = requesterFields.find(x => x.id === requesterFieldId);
        const eventField = eventFields.find(x => x.id === eventFieldId);
        if (requesterField && eventField) {
          map.push({
            requesterField: requesterField,
            eventField: eventField,
            possibleEventFields: this.getSchemaMatchingFields(requesterField, eventFields)
          });
        }
      }
      return map;
    }
    getNonUsedFields(fields, usedFields) {
      const nonUsedFields = fields.filter(x => !usedFields.find(y => y.id === x.id));
      return nonUsedFields;
    }
    getSchemaMatchingFields(sourceField, allFields) {
      const fields = [];
      for (const field of allFields) {
        if (this.sharedSvc.areSchemasSame(sourceField, field)) {
          fields.push(field);
        }
      }
      return fields;
    }
    async updateStepAdvancedQueryCondition(step, entityTypeFieldsCombined, globalProcessEntityType, options) {
      const supportedEntityTypes = this.getSupportedEntityTypeByGlobalEntityType(globalProcessEntityType);
      const filteredEntityTypeFields = entityTypeFieldsCombined.filter(entity => supportedEntityTypes.includes(entity.entityTypeName));
      const result = await this.openUpdateStepAdvancedQueryConditionDialog(step, filteredEntityTypeFields, options);
      if (result.type === 'submit') {
        step.condition = filterTreeToFlatSearchParams(result.data);
      }
    }
    getSupportedEntityTypeByGlobalEntityType(globalProcessEntityType) {
      const supportedEntityForParticipantEntityOrEventContext = [FlowBuilderStepEntityType.event, FlowBuilderStepEntityType.eventSettings, FlowBuilderStepEntityType.participant, FlowBuilderStepEntityType.participantActivity, FlowBuilderStepEntityType.product, FlowBuilderStepEntityType.workflow];
      const isGlobalProcess = !!globalProcessEntityType;
      if (isGlobalProcess) {
        if (globalProcessEntityType === FlowBuilderStepEntityType.event) {
          return [FlowBuilderStepEntityType.event];
        } else if (globalProcessEntityType === FlowBuilderStepEntityType.contact) {
          return [FlowBuilderStepEntityType.contact];
        } else if (globalProcessEntityType === FlowBuilderStepEntityType.organization) {
          return [FlowBuilderStepEntityType.organization];
        } else return supportedEntityForParticipantEntityOrEventContext;
      } else {
        // participant process
        return supportedEntityForParticipantEntityOrEventContext;
      }
    }
    async openUpdateStepAdvancedQueryConditionDialog(step, entityTypeFieldsCombined, options) {
      const filterDialogData = {
        ...this.getStepAdvancedQueryFilterData(step, entityTypeFieldsCombined),
        isSaveButtonEnabledFn: data => {
          return isAdvancedQueryConditionConfigured(filterTreeToFlatSearchParams(data));
        },
        ...options?.filterDialogData
      };
      if (!isAdvancedQueryConditionConfigured(step.condition)) {
        filterDialogData.filter.criteriaTree = null;
      }
      const result = await this.filterCriteriaTreeSvc.open(filterDialogData, {
        panelClass: ['filter-criteria-tree-dialog', 'process-builder__advanced-query-dialog'],
        ...options?.dialogOptions
      });
      return result;
    }
    /**
     * @param entityTypeFieldsCombined a combined value as result of `getEntityTypeFieldsCombined()`
     * @returns
     */
    getFieldsForAdvancedQueryConditionDialog(entityTypeFieldsCombined, sharedSvc) {
      return entityTypeFieldsCombined.reduce((mergedArray, item) => {
        return mergedArray.concat(item.fields.map(field => ({
          ...field,
          category: STEP_ENTITY_TYPES_TRANSLATION_KEYS[item.entityTypeName] ? sharedSvc.translate(STEP_ENTITY_TYPES_TRANSLATION_KEYS[item.entityTypeName]) : item.entityTypeName,
          id: getFormattedFieldId(field, item),
          label: field.label
        })));
      }, []);
      function getFormattedFieldId(field, item) {
        return field.id.startsWith(getFieldIdPrefix(item)) ? field.id : `${getFieldIdPrefix(item)}${field.id}`;
      }
      function getFieldIdPrefix(item) {
        return `${item.entityTypeName}_`;
      }
    }
    static {
      this.ɵfac = function AzavistaFlowStepService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowStepService)(i0.ɵɵinject(i2.AzavistaSharedService), i0.ɵɵinject(i2$1.AzavistaFilterCriteriaTreeService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaFlowStepService,
        factory: AzavistaFlowStepService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaFlowStepService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const isAdvancedQueryConditionConfigured = conditions => {
  return conditions.some(condition => condition.length > 0);
};
const getEntityTypeFieldsCombined = (step, entityTypeFields, additionalEntityFields, sortStepFields) => {
  return entityTypeFields.map(entity => {
    const additionalByStep = additionalEntityFields?.[step?.type]?.[entity.entityTypeName];
    const eventFieldsCombined = entity.eventFields.concat(additionalByStep?.eventFields ?? []);
    const fieldsCombined = entity.fields.concat(additionalByStep?.fields ?? []);
    const combinedEntity = {
      ...entity,
      eventFields: sortStepFields ? sortAlphabetically(eventFieldsCombined, f => f.label) : eventFieldsCombined,
      fields: sortStepFields ? sortAlphabetically(fieldsCombined, f => f.label) : fieldsCombined
    };
    return combinedEntity;
  });
};
const EVENT_APP_COMPONENT_TYPES = ['content', 'embed', 'qr_code', 'chat', 'lead_scan', 'clear_cache', 'sessions', 'participants', 'profile', 'newsfeed', 'question', 'poll', 'moderation', 'notification'];
const getStepActionUpdateContactToOrganizationFieldFromMappingItem = mapping => {
  return {
    contact_field_id: mapping?.sourceField?.id,
    organization_field_id: mapping?.targetField?.id
  };
};
const getStepActionUpdateContactToOrganizationFromStepActionFieldMappingConfig = config => {
  return {
    action: FlowBuilderStepActionType.updateContactToOrganization,
    fields: config.field_mapping.map(getStepActionUpdateContactToOrganizationFieldFromMappingItem)
  };
};
const getMappingItemFromStepActionUpdateContactToOrganizationField = (data, sourceFields, targetFields, sharedSvc) => {
  const sourceField = sourceFields.find(field => field.id === data.contact_field_id);
  const targetField = targetFields.find(field => field.id === data.organization_field_id);
  const result = {};
  if (sourceField) {
    result.sourceField = {
      id: data.contact_field_id,
      type: sharedSvc.getFieldTypeFromField(sourceField)
    };
  }
  if (targetField && sourceField) {
    const enums = sharedSvc.getArrayOrEnumItems(sourceField.schema);
    result.targetField = {
      id: data.organization_field_id,
      attributeMapping: enums.reduce((record, value) => ({
        ...record,
        [value]: value
      }), {})
    };
  }
  return result;
};
const getStepActionFieldMappingConfigFromStepActionUpdateContactToOrganization = (data, sourceFields, targetFields, sharedSvc) => {
  return {
    field_mapping: data.fields.map(field => getMappingItemFromStepActionUpdateContactToOrganizationField(field, sourceFields, targetFields, sharedSvc))
  };
};
let AzavistaFlowStepFieldMappingAttributeMappingDialogComponent = /*#__PURE__*/(() => {
  class AzavistaFlowStepFieldMappingAttributeMappingDialogComponent {
    constructor(data, mappingSvc, sharedSvc) {
      this.data = data;
      this.mappingSvc = mappingSvc;
      this.sharedSvc = sharedSvc;
      this.getSingleSelectField = field => {
        const type = this.sharedSvc.getFieldTypeFromField(field);
        if (type === 'select') {
          return field;
        }
        if (type === 'multi-select' && !Array.isArray(field.schema.items)) {
          return {
            ...pick(field, ['id', 'name', 'label', 'editable', 'category', 'builtin', 'attributeTranslations']),
            schema: {
              enum: this.getFieldEnums(field),
              type: 'string'
            },
            component: "default" /* FieldComponentType.default */,
            editable: true,
            type: 'select'
          };
        }
      };
      this.getFieldEnums = field => {
        const type = this.sharedSvc.getFieldTypeFromField(field);
        if (type === 'select') {
          return field.schema.enum;
        }
        if (type === 'multi-select' && !Array.isArray(field.schema.items)) {
          return field.schema.items.enum;
        }
      };
      this.combinedMapping = {
        ...this.getAttributeMappingFromEqualValue(data),
        ...(this.mappingSvc[data.sourceField.id]?.[data.targetField.id] ?? {}),
        ...(data.attributeMapping ?? {})
      };
    }
    getAttributeMappingFromEqualValue(data) {
      const {
        sourceField,
        targetField
      } = data;
      const targetFieldEnums = this.getFieldEnums(targetField);
      return this.getFieldEnums(sourceField).reduce((record, enumItem) => {
        if (targetFieldEnums.includes(enumItem)) {
          record[enumItem] = enumItem;
        }
        return record;
      }, {});
    }
    updateMapping(sourceEnumItem, targetEnumValue) {
      this.combinedMapping[sourceEnumItem] = targetEnumValue;
      this.mappingSvc.storeMappingCache(this.data.sourceField.id, this.data.targetField.id, this.combinedMapping);
    }
    static {
      this.ɵfac = function AzavistaFlowStepFieldMappingAttributeMappingDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowStepFieldMappingAttributeMappingDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(AzavistaFlowStepFieldMappingAttributeMappingService), i0.ɵɵdirectiveInject(i2.AzavistaSharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFlowStepFieldMappingAttributeMappingDialogComponent,
        selectors: [["azavista-flow-step-field-mapping-attribute-mapping-dialog"]],
        standalone: false,
        decls: 22,
        vars: 19,
        consts: [["mat-dialog-title", ""], ["mat-dialog-content", "", 1, "aza-cmp-flex-column"], [1, "aza-cmp-flex-row"], [1, "aza-cmp-flex-item-grow"], ["color", "primary"], ["class", "aza-cmp-flex-row", 4, "ngFor", "ngForOf"], ["mat-dialog-actions", "", 1, "aza-cmp-flex-row"], [3, "mat-dialog-close"], ["color", "primary", 3, "mat-dialog-close"], [3, "field", "label", "canEdit", "value", "fullWidth", 4, "ngIf"], [3, "field", "label", "editMode", "canEdit", "value", "fullWidth", "valueChanged", 4, "ngIf"], [3, "field", "label", "canEdit", "value", "fullWidth"], [3, "valueChanged", "field", "label", "editMode", "canEdit", "value", "fullWidth"]],
        template: function AzavistaFlowStepFieldMappingAttributeMappingDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h5", 0);
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 1)(4, "div", 2)(5, "div", 3)(6, "mat-chip-listbox")(7, "mat-chip-option", 4);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "div", 3)(10, "mat-chip-listbox")(11, "mat-chip-option", 4);
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(13, AzavistaFlowStepFieldMappingAttributeMappingDialogComponent_div_13_Template, 9, 8, "div", 5);
            i0.ɵɵpipe(14, "apply");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "div", 6)(16, "azavista-flat-button", 7);
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "azavista-button", 8);
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 10, "ATTRIBUTE_MAPPING"));
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate2(" ", ctx.data.sourceColumnConfig == null ? null : ctx.data.sourceColumnConfig.headerLabel, " : ", ctx.data.sourceField.label, " ");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate2(" ", ctx.data.targetColumnConfig == null ? null : ctx.data.targetColumnConfig.headerLabel, " : ", ctx.data.targetField.label, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(14, 12, ctx.data.sourceField, ctx.getFieldEnums));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mat-dialog-close", undefined);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 15, "CANCEL"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", ctx.combinedMapping);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 17, "SAVE"));
          }
        },
        dependencies: [i4.NgForOf, i4.NgIf, i4$1.AzavistaInputFieldComponent, i5.MatIcon, i6$1.AzavistaButtonComponent, i6$1.AzavistaFlatButtonComponent, i7.MatChipListbox, i7.MatChipOption, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogActions, i1.MatDialogContent, i6.TranslatePipe, i2.ApplyFunctionPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return AzavistaFlowStepFieldMappingAttributeMappingDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFlowStepFieldMappingAttributeMappingService = /*#__PURE__*/(() => {
  class AzavistaFlowStepFieldMappingAttributeMappingService {
    constructor(dialog) {
      this.dialog = dialog;
      this.mappingCache = {};
    }
    storeMappingCache(sourceFieldId, targetFieldId, mapping) {
      this.mappingCache[sourceFieldId] = {
        ...(this.mappingCache[sourceFieldId] ?? {}),
        [targetFieldId]: mapping
      };
    }
    async updateAttributeMapping(data) {
      const result = await firstValueFrom(this.dialog.open(AzavistaFlowStepFieldMappingAttributeMappingDialogComponent, {
        data
      }).afterClosed());
      return result;
    }
    static {
      this.ɵfac = function AzavistaFlowStepFieldMappingAttributeMappingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowStepFieldMappingAttributeMappingService)(i0.ɵɵinject(i1.MatDialog));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaFlowStepFieldMappingAttributeMappingService,
        factory: AzavistaFlowStepFieldMappingAttributeMappingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaFlowStepFieldMappingAttributeMappingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var FieldMappingMatchingType = /*#__PURE__*/function (FieldMappingMatchingType) {
  /** Fields will be matched by `FieldType`. If it's a select/multi-select field, then there will be process to map the field's enums */
  FieldMappingMatchingType["partial"] = "partial";
  /** Fields will be matched by `FieldType` and Enums. If it's a select/multi-select field, then only field with identical enum can be matched */
  FieldMappingMatchingType["exact"] = "exact";
  return FieldMappingMatchingType;
}(FieldMappingMatchingType || {});
let AzavistaFlowStepFieldMappingItemComponent = /*#__PURE__*/(() => {
  class AzavistaFlowStepFieldMappingItemComponent {
    get existingFieldMapping() {
      return this._existingFieldMapping;
    }
    /**
     * this data is used to check duplicate field-mapping
     */
    set existingFieldMapping(value) {
      this._existingFieldMapping = value;
      if (this.updatedSourceField) {
        this.selectSourceField(this.updatedSourceField);
      }
    }
    get fieldMappingIndex() {
      return this._fieldMappingIndex;
    }
    set fieldMappingIndex(value) {
      this._fieldMappingIndex = value;
      if (this.updatedSourceField) {
        this.selectSourceField(this.updatedSourceField);
      }
    }
    constructor(sharedSvc, attributeMappingSvc) {
      this.sharedSvc = sharedSvc;
      this.attributeMappingSvc = attributeMappingSvc;
      this.readonly = false;
      /** @default `FieldMappingMatchingType.partial` */
      this.fieldMatching = FieldMappingMatchingType.partial;
      this.updateMapping = new EventEmitter();
      this.updatedSourceField = null;
      this.updatedTargetField = null;
      this.sourceFieldAutocomplete = {
        field: {
          schema: {
            type: 'object'
          },
          component: "object_enum" /* FieldComponentType.objectEnum */,
          editable: true,
          label: this.sourceColumnConfig?.headerLabel,
          mandatory_for_planners: true
        },
        options: {
          restoreLastSelectedValueWhenNoMatch: false,
          enableClearValue: false,
          useInternalFiltering: false
        }
      };
      this.targetFieldAutocomplete = {
        field: {
          schema: {
            type: 'object'
          },
          component: "object_enum" /* FieldComponentType.objectEnum */,
          editable: true,
          label: this.targetColumnConfig?.headerLabel,
          mandatory_for_planners: true
        },
        options: {
          restoreLastSelectedValueWhenNoMatch: false,
          enableClearValue: false,
          useInternalFiltering: false
        }
      };
      this.getShouldHaveAttributeMapping = field => {
        if (!field || this.fieldMatching === FieldMappingMatchingType.exact) {
          return false;
        }
        const fieldType = this.getFieldTypeFromField(field);
        const shouldHaveAttributeMapping = fieldType === 'multi-select' || fieldType === 'select';
        return shouldHaveAttributeMapping;
      };
    }
    ngOnInit() {
      this.targetFieldAutocomplete.value = {
        displayProperty: 'label',
        items: [],
        filteredItems: [],
        selected: this.data?.targetField ? this.targetFields.find(({
          id
        }) => id === this.data.targetField.id) : undefined
      };
      this.sourceFieldAutocomplete.value = {
        displayProperty: 'label',
        items: this.sourceFields,
        filteredItems: this.sourceFields,
        selected: this.data?.sourceField ? this.sourceFields.find(({
          id
        }) => id === this.data.sourceField.id) : undefined
      };
      this.updatedSourceField = this.sourceFieldAutocomplete.value?.selected;
      this.updatedTargetField = this.targetFieldAutocomplete.value?.selected;
      this.attributeMapping = this.data?.targetField?.attributeMapping;
      if (this.updatedSourceField) {
        this.selectSourceField(this.updatedSourceField);
      }
    }
    updateFieldSelectorOptions(autoCompleteItem, data) {
      const {
        options,
        value
      } = autoCompleteItem;
      if (!options.useInternalFiltering) {
        const lowercased = data.text.toLowerCase();
        value.filteredItems = value.items.filter(x => x.name.includes(lowercased));
      }
    }
    async selectSourceField(field) {
      const updatedSourceType = this.getFieldTypeFromField(field);
      const currentSourceType = this.updatedSourceField && this.getFieldTypeFromField(this.updatedSourceField);
      const shouldKeepTargetField = updatedSourceType === currentSourceType;
      if (!shouldKeepTargetField) {
        this.updatedTargetField = null;
      }
      const isSourceFieldChanged = this.updatedSourceField?.id !== field?.id;
      this.updatedSourceField = field;
      if (this.targetFieldAutocomplete.value) {
        this.targetFieldAutocomplete.field = {
          ...this.targetFieldAutocomplete.field
        };
        const filteredTargetFields = this.targetFields.filter(targetField => {
          const targetFieldType = this.getFieldTypeFromField(targetField);
          const isSameType = targetFieldType === updatedSourceType;
          switch (this.fieldMatching) {
            case FieldMappingMatchingType.partial:
              {
                return isSameType;
              }
            case FieldMappingMatchingType.exact:
              {
                if (!isSameType) {
                  return false;
                }
                const isSelectType = targetFieldType === 'select' || targetFieldType === 'multi-select';
                if (!isSelectType) {
                  return true;
                }
                const sourceEnums = this.sharedSvc.getArrayOrEnumItems(this.updatedSourceField.schema);
                const targetEnums = this.sharedSvc.getArrayOrEnumItems(targetField.schema);
                const isHavingExactEnums = sourceEnums.sort().join('|') === targetEnums.sort().join('|');
                return isHavingExactEnums;
              }
          }
        }).filter(filteredFieldItem => !this.existingFieldMapping.some((existingField, index) => {
          return this.fieldMappingIndex !== index && existingField.sourceField?.id === this.updatedSourceField.id && filteredFieldItem.id === existingField.targetField?.id;
        }));
        const isPreviousSelectedTargetFieldStillValid = filteredTargetFields.some(filteredFieldItem => this.targetFieldAutocomplete.value?.selected?.id === filteredFieldItem.id);
        const shouldKeepSelectedTargetField = isPreviousSelectedTargetFieldStillValid || !this.targetFieldAutocomplete.value?.selected;
        this.targetFieldAutocomplete.value = {
          ...this.targetFieldAutocomplete.value,
          selected: shouldKeepSelectedTargetField ? this.targetFieldAutocomplete.value?.selected : null,
          items: filteredTargetFields,
          filteredItems: filteredTargetFields
        };
        if (!shouldKeepSelectedTargetField) {
          this.updatedTargetField = null;
        }
        if (!shouldKeepSelectedTargetField || !shouldKeepTargetField || isSourceFieldChanged) {
          this.emitUpdateMapping();
        }
      }
    }
    async selectTargetField(targetField) {
      const shouldHaveAttributeMapping = this.getShouldHaveAttributeMapping(targetField);
      if (shouldHaveAttributeMapping) {
        const updatedMapping = await this.openAttributeMapping({
          targetField
        });
        if (updatedMapping) {
          this.updatedTargetField = targetField;
          this.attributeMapping = updatedMapping;
          this.emitUpdateMapping();
        }
        this.targetFieldAutocomplete = {
          ...this.targetFieldAutocomplete,
          value: {
            ...this.targetFieldAutocomplete.value,
            selected: this.updatedTargetField
          }
        };
      } else {
        this.updatedTargetField = targetField;
        this.emitUpdateMapping();
      }
    }
    async openAttributeMapping(data) {
      return this.attributeMappingSvc.updateAttributeMapping({
        sourceField: data?.sourceField ?? this.updatedSourceField,
        targetField: data?.targetField ?? this.updatedTargetField,
        sourceColumnConfig: this.sourceColumnConfig,
        targetColumnConfig: this.targetColumnConfig,
        attributeMapping: data?.attributeMapping
      });
    }
    emitUpdateMapping() {
      const sourceField = this.updatedSourceField ? {
        id: this.updatedSourceField.id,
        type: this.getFieldTypeFromField(this.updatedSourceField)
      } : undefined;
      const targetField = this.updatedTargetField ? {
        id: this.updatedTargetField.id
      } : undefined;
      if (this.getShouldHaveAttributeMapping(this.updatedTargetField)) {
        targetField.attributeMapping = this.attributeMapping;
      }
      this.updateMapping.emit({
        sourceField,
        targetField
      });
    }
    getFieldTypeFromField(field) {
      return this.sharedSvc.getFieldTypeFromField(field);
    }
    static {
      this.ɵfac = function AzavistaFlowStepFieldMappingItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowStepFieldMappingItemComponent)(i0.ɵɵdirectiveInject(i2.AzavistaSharedService), i0.ɵɵdirectiveInject(AzavistaFlowStepFieldMappingAttributeMappingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFlowStepFieldMappingItemComponent,
        selectors: [["azavista-flow-step-field-mapping-item"]],
        inputs: {
          sourceFields: "sourceFields",
          targetFields: "targetFields",
          existingFieldMapping: "existingFieldMapping",
          fieldMappingIndex: "fieldMappingIndex",
          data: "data",
          readonly: "readonly",
          sourceColumnConfig: "sourceColumnConfig",
          targetColumnConfig: "targetColumnConfig",
          addButtonConfig: "addButtonConfig",
          fieldMatching: "fieldMatching"
        },
        outputs: {
          updateMapping: "updateMapping"
        },
        standalone: false,
        decls: 9,
        vars: 6,
        consts: [[1, "flow-step-field-mapping-item", "aza-cmp-flex-row"], [1, "flow-step-field-mapping-item", "aza-cmp-flex-row", "aza-cmp-flex-item-grow"], ["class", "azavista-input-field-filter-field aza-cmp-flex-item-grow", 3, "label", "value", "options", "field", "editMode", "readonlyMode", "fullWidth", "layoutDensity", "valueChanged", 4, "ngIf"], ["class", "azavista-input-field-filter-field aza-cmp-flex-item-grow", 3, "label", "value", "options", "field", "fullWidth", "editMode", "readonlyMode", "layoutDensity", "valueChanged", 4, "ngIf"], [3, "matTooltip", "click", 4, "ngIf"], [1, "azavista-input-field-filter-field", "aza-cmp-flex-item-grow", 3, "valueChanged", "label", "value", "options", "field", "editMode", "readonlyMode", "fullWidth", "layoutDensity"], [1, "azavista-input-field-filter-field", "aza-cmp-flex-item-grow", 3, "valueChanged", "label", "value", "options", "field", "fullWidth", "editMode", "readonlyMode", "layoutDensity"], [3, "click", "matTooltip"]],
        template: function AzavistaFlowStepFieldMappingItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, AzavistaFlowStepFieldMappingItemComponent_azavista_input_field_2_Template, 1, 8, "azavista-input-field", 2);
            i0.ɵɵelementStart(3, "mat-icon");
            i0.ɵɵtext(4, "keyboard_double_arrow_right");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 1);
            i0.ɵɵtemplate(6, AzavistaFlowStepFieldMappingItemComponent_azavista_input_field_6_Template, 1, 8, "azavista-input-field", 3)(7, AzavistaFlowStepFieldMappingItemComponent_azavista_button_7_Template, 4, 3, "azavista-button", 4);
            i0.ɵɵpipe(8, "apply");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.sourceFieldAutocomplete.value);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.targetFieldAutocomplete.value);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(8, 3, ctx.updatedTargetField, ctx.getShouldHaveAttributeMapping));
          }
        },
        dependencies: [i4.NgIf, i4$1.AzavistaInputFieldComponent, i5.MatIcon, i6$1.AzavistaButtonComponent, i7$1.MatTooltip, i6.TranslatePipe, i2.ApplyFunctionPipe],
        styles: [".flow-step-field-mapping-item[_ngcontent-%COMP%]{flex:1}"],
        changeDetection: 0
      });
    }
  }
  return AzavistaFlowStepFieldMappingItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFlowStepFieldMappingItemListComponent = /*#__PURE__*/(() => {
  class AzavistaFlowStepFieldMappingItemListComponent {
    constructor() {
      this.readonly = false;
      /** @default `FieldMappingMatchingType.partial` */
      this.fieldMatching = FieldMappingMatchingType.partial;
      this.stepConfigChange = new EventEmitter();
    }
    addNewFieldMapping() {
      this.stepConfig.field_mapping = [...(this.stepConfig.field_mapping ?? []), null];
      this.emitStepConfigChange();
    }
    deleteFieldMappingItem(index) {
      this.stepConfig.field_mapping.splice(index, 1);
      this.emitStepConfigChange();
    }
    updateFieldMappingItem(index, data) {
      this.stepConfig.field_mapping[index] = data;
      this.emitStepConfigChange();
    }
    emitStepConfigChange() {
      this.stepConfigChange.emit(this.stepConfig);
    }
    static {
      this.ɵfac = function AzavistaFlowStepFieldMappingItemListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowStepFieldMappingItemListComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFlowStepFieldMappingItemListComponent,
        selectors: [["azavista-flow-step-field-mapping-item-list"]],
        inputs: {
          stepConfig: "stepConfig",
          readonly: "readonly",
          sourceColumnConfig: "sourceColumnConfig",
          targetColumnConfig: "targetColumnConfig",
          addButtonConfig: "addButtonConfig",
          sourceFields: "sourceFields",
          targetFields: "targetFields",
          fieldMatching: "fieldMatching"
        },
        outputs: {
          stepConfigChange: "stepConfigChange"
        },
        standalone: false,
        decls: 13,
        vars: 8,
        consts: [[1, "aza-cmp-flex-column", "aza-cmp-padding-block"], [1, "aza-cmp-flex-row"], [1, "aza-cmp-flex-item-grow"], ["color", "primary", 3, "highlighted", "selectable"], [1, "aza-cmp-flex-column"], ["class", "aza-cmp-flex-row", 4, "ngFor", "ngForOf"], ["class", "aza-cmp-flex-row", 4, "ngIf"], [1, "aza-cmp-flex-item-grow", 3, "updateMapping", "readonly", "sourceFields", "targetFields", "sourceColumnConfig", "targetColumnConfig", "fieldMatching", "existingFieldMapping", "fieldMappingIndex", "data"], ["color", "warn", 3, "click", 4, "ngIf"], ["color", "warn", 3, "click"], [3, "click"]],
        template: function AzavistaFlowStepFieldMappingItemListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "mat-chip-listbox")(4, "mat-chip-option", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(6, "div", 2)(7, "mat-chip-listbox")(8, "mat-chip-option", 3);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(10, "div", 4);
            i0.ɵɵtemplate(11, AzavistaFlowStepFieldMappingItemListComponent_div_11_Template, 3, 10, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, AzavistaFlowStepFieldMappingItemListComponent_div_12_Template, 6, 3, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("highlighted", true)("selectable", false);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.sourceColumnConfig == null ? null : ctx.sourceColumnConfig.headerLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("highlighted", true)("selectable", false);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.targetColumnConfig == null ? null : ctx.targetColumnConfig.headerLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.stepConfig.field_mapping);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.readonly);
          }
        },
        dependencies: [i4.NgForOf, i4.NgIf, i5.MatIcon, i6$1.AzavistaFlatButtonComponent, i7.MatChipListbox, i7.MatChipOption, AzavistaFlowStepFieldMappingItemComponent, i6.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return AzavistaFlowStepFieldMappingItemListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const STEP_TYPES_INFO_MAPPINGS = {
  [FlowBuilderStepType.stop]: {
    label: STEP_TYPES_TRANSLATION_KEYS[FlowBuilderStepType.stop]
  },
  [FlowBuilderStepType.advancedQuery]: {
    label: STEP_TYPES_TRANSLATION_KEYS[FlowBuilderStepType.advancedQuery]
  },
  [FlowBuilderStepType.goToWorkflow]: {
    label: STEP_TYPES_TRANSLATION_KEYS[FlowBuilderStepType.goToWorkflow],
    getDescription: stepComponent => stepComponent.getWorkflowName(stepComponent.step.workflow_id)
  }
};
let AzavistaFlowStepComponent = /*#__PURE__*/(() => {
  class AzavistaFlowStepComponent {
    get entityTypeFieldsCombined() {
      return getEntityTypeFieldsCombined(this.step, this.entityTypeFields, this.additionalEntityFields, this.sortStepFields);
    }
    constructor(flowBuilderSvc, sharedSvc, flowStepSvc) {
      this.flowBuilderSvc = flowBuilderSvc;
      this.sharedSvc = sharedSvc;
      this.flowStepSvc = flowStepSvc;
      this.isPanelExpanded = false;
      this.sortStepFields = false;
      /**
       * All active event's activities
       */
      this.eventActivities = [];
      /**
       * All published event's pages with type=event_app
       */
      this.eventAppPages = [];
      this.delete = new EventEmitter();
      this.stepType = FlowBuilderStepType;
      this.actionType = FlowBuilderStepActionType;
      this.waitStepSecondsValid = true;
      this.waitUntilFieldStepOffsetDirection = 'before';
      this.waitUntilFieldStepOffsetSeconds = 0;
      this.waitUntilFieldStepOffsetSecondsValid = true;
      this.waitAndWaitUntilFieldStepsAzavistaInputField = {
        schema: {
          type: 'integer'
        },
        editable: true,
        mandatory_for_planners: true
      };
      this.isGeneralEmailValueValid = false;
      this.isDecisionNowDifferenceValueValid = false;
      this.isEmailFromFieldValueValid = false;
      this.requesterFieldToEventFieldMap = [];
      // TODO: This is probably mistake - decision now does not need conditions - it compares now() with the value of the selected feld
      // decisionNowCondition: IFilterCriteria; // { field?: IField, operator?: any, value?: any }; // TODO: import FlatSearchParamsElement;
      this.fieldOperators = {};
      this.fieldMode = 'id';
      this.flowStepFields = {};
      this.isAddOrRemoveTeam = false;
      this.isGeneralEmail = false;
      this.isEmailFromField = false;
      // isEmailFromEventField = false;
      this.isCreateEvent = false;
      this.isSetDateTimeFieldToCurrent = false;
      this.isWebhook = false;
      this.isSendGenericEmail = false;
      this.isSetReferenceNumber = false;
      this.isSendObject = false;
      this.isCountSelectField = false;
      this.isCopyEventDates = false;
      this.isCopyEventTextField = false;
      this.isMessageToContactOrParticipant = false;
      this.isSendMessageToUser = false;
      this.isAddContactToEvent = false;
      this.isGenerateCertificate = false;
      this.requesterFields = [];
      this.IMessageToContactOrParticipantPropertyByIntegrationSubType = IMessageToContactOrParticipantPropertyByIntegrationSubType;
      this.destroyed$ = new Subject();
      this.subscribed = false;
      this.unsupportedFieldTypes = ["textarea" /* FieldComponentType.textarea */, "timezone" /* FieldComponentType.timezone */];
      this.stepTypesTranslationKeys = STEP_TYPES_INFO_MAPPINGS;
      this.this = this;
      this.stepEntityTypesMapping = STEP_ENTITY_TYPES_TO_STEP_TYPE_MAPPING;
      this.flatSearchParamsToFilterTree = flatSearchParamsToFilterTree;
      this.FlowBuilderStepEntityType = FlowBuilderStepEntityType;
      this.FieldMappingMatchingType = FieldMappingMatchingType;
      this.getStepActionUpdateContactToOrganizationFromStepActionFieldMappingConfig = getStepActionUpdateContactToOrganizationFromStepActionFieldMappingConfig;
      this.Math = Math;
      this.getFlowBuilderEntityTypeFieldsByEntityType = type => {
        return this.entityTypeFieldsCombined.find(x => x.entityTypeName === type);
      };
      this.getMessageToContactOrParticipantEventAppEntityField = type => {
        const config = this.step?.config;
        const entity_id = config?.eventAppComponent?.entity_id;
        const entityList = this.getEventAppComponentEntityList(type);
        if (!entityList) {
          return null;
        }
        const selectedItemId = entityList?.some(({
          id
        }) => id === entity_id) ? entity_id : null;
        const value = entityList && this.sharedSvc.createObjectEnumFieldValue(entityList, selectedItemId);
        return entityList ? {
          value,
          field: this.flowBuilderSvc.createObjectEnumField()
        } : null;
      };
      this.getWorkflowName = workflowId => {
        return workflowId ? this.workflows.find(({
          id
        }) => id === workflowId)?.label : '';
      };
      this.getStepAdvancedQueryFilterData = (step, readonly = false) => {
        return this.flowStepSvc.getStepAdvancedQueryFilterData(step, this.entityTypeFieldsCombined, readonly);
      };
      this.updateStepAdvancedQueryCondition = step => {
        return this.flowStepSvc.updateStepAdvancedQueryCondition(step, this.entityTypeFieldsCombined, this.globalProcessEntityType);
      };
      this.isFinishStep = stepType => {
        return FINISH_STEP_ENTITY_TYPES.includes(stepType);
      };
      this.getIntegration = integrationId => {
        return this.integrations.find(({
          id
        }) => id === integrationId);
      };
      this.getConfigAsMessageToEntityConfig = stepConfig => {
        return stepConfig;
      };
      this.findInArray = (array, valueToCheck, ...rest) => {
        const [getValueFromArray] = rest;
        return array.find(item => {
          const valueToCompare = getValueFromArray ? getValueFromArray(item) : item;
          return valueToCompare === valueToCheck;
        });
      };
      this.getStepActionFieldMappingConfigFromStepActionUpdateContactToOrganization = (data, sourceFields, targetFields) => {
        return getStepActionFieldMappingConfigFromStepActionUpdateContactToOrganization(data, sourceFields, targetFields, this.sharedSvc);
      };
      this.secondsToTimeType = {
        604800: TimeType.w,
        86400: TimeType.d,
        3600: TimeType.h,
        60: TimeType.m,
        1: TimeType.s
      };
      this.timeTypeToSeconds = {};
      for (const field of Object.keys(this.secondsToTimeType)) {
        this.timeTypeToSeconds[this.secondsToTimeType[field]] = field;
      }
      this.waitStepTimeTypes = [{
        id: TimeType.s,
        label: this.sharedSvc.translate('SECONDS')
      }, {
        id: TimeType.m,
        label: this.sharedSvc.translate('MINUTES')
      }, {
        id: TimeType.h,
        label: this.sharedSvc.translate('HOURS')
      }, {
        id: TimeType.d,
        label: this.sharedSvc.translate('DAYS')
      }, {
        id: TimeType.w,
        label: this.sharedSvc.translate('WEEKS')
      }];
      this.waitUntilFieldStepTimeTypes = this.waitStepTimeTypes;
      this.generalEmailField = {
        name: 'generalEmail',
        label: '',
        schema: {
          type: 'string',
          format: 'email'
        },
        editable: true,
        mandatory_for_planners: true
      };
      this.emailFromFieldField = {
        name: 'emailFromField',
        label: '',
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */,
        editable: true
      };
      this.webhookIntegrationField = {
        name: 'webhook',
        label: '',
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */,
        editable: true
      };
      this.setReferenceNumberField = {
        name: 'setReferenceNumberField',
        label: '',
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */,
        editable: true
      };
      this.sendObjectIntegrationField = {
        name: 'sendObjectIntegration',
        label: '',
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */,
        editable: true
      };
      this.countSelectFieldData = {
        participantField: {
          field: {
            name: 'countSelectFieldParticipantField',
            label: '',
            schema: {
              type: 'object'
            },
            component: "object_enum" /* FieldComponentType.objectEnum */,
            editable: true
          },
          value: null
        },
        participantFieldValue: {
          field: {
            name: 'countSelectFieldParticipantFieldValueField',
            label: '',
            schema: {
              type: 'object'
            },
            component: "object_enum" /* FieldComponentType.objectEnum */,
            editable: true
          },
          value: null
        },
        eventField: {
          field: {
            name: 'countSelectFieldEventField',
            label: '',
            schema: {
              type: 'object'
            },
            component: "object_enum" /* FieldComponentType.objectEnum */,
            editable: true
          },
          value: null
        }
      };
      this.copyEventDatesFieldData = {
        startDateField: {
          field: {
            name: 'copyEventDatesStartDateField',
            label: '',
            schema: {
              type: 'object'
            },
            component: "object_enum" /* FieldComponentType.objectEnum */,
            editable: true
          },
          value: null
        },
        endDateField: {
          field: {
            name: 'copyEventDatesEndDateField',
            label: '',
            schema: {
              type: 'object'
            },
            component: "object_enum" /* FieldComponentType.objectEnum */,
            editable: true
          },
          value: null
        }
      };
      this.copyEventTextFieldFieldData = {
        eventField: {
          field: {
            name: 'copyEventTextFieldFieldEventField',
            label: '',
            schema: {
              type: 'object'
            },
            component: "object_enum" /* FieldComponentType.objectEnum */,
            editable: true
          },
          value: null
        },
        participantField: {
          field: {
            name: 'copyEventTextFieldContactField',
            label: '',
            schema: {
              type: 'object'
            },
            component: "object_enum" /* FieldComponentType.objectEnum */,
            editable: true
          },
          value: null
        }
      };
      // this.emailFromFieldField = {
      //     name: 'emailFromEventField', label: '',
      //     schema: { type: 'object' }, component: FieldComponentType.objectEnum, editable: true,
      // } as IField;
    }
    ngOnInit() {
      this.cleanUnknownFields();
      this.flowStepFields.stage = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValueDisplayingName(this.stages, this.step.stage_id)
      };
      this.flowStepFields.workflow_id = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValue(this.workflows, this.step.workflow_id)
      };
    }
    cleanUnknownFields() {
      if (!this.entityTypeFieldsCombined) {
        return;
      }
      const unsupportedFieldTypes = this.unsupportedFieldTypes;
      for (const item of this.entityTypeFieldsCombined) {
        item.eventFields = item.eventFields.filter(x => !unsupportedFieldTypes.includes(x.component));
        item.fields = item.fields.filter(x => !unsupportedFieldTypes.includes(x.component));
      }
    }
    processEventFieldsMessage(data) {
      if (data.type === "fieldsAvailable" /* TemplateEventFieldsSubjectMessageType.fieldsAvailable */) {
        const body = data.body;
        if (body.step === this.step && body.eventTemplateId === this.step.config.template_id) {
          // Event fields for selected event template are received
          this.applyEventAndRequesterFields(body.eventFields, body.requesterFields);
        }
      }
    }
    applyEventAndRequesterFields(eventFields, requesterFields) {
      // TODO: Filter fields - left only visible for planners and used (this.sharedSvc.getVisibleAndUsedFields)
      //       Find used in this.step.config.field_mapping
      this.requesterFields = requesterFields;
      this.templateEventFields = eventFields;
      this.currentCreateEventEventName = this.flowStepSvc.getLabel(this.templateEvents, this.step.config.template_id);
      this.requesterFieldToEventFieldMap = this.flowStepSvc.createRequesterWithEventFieldMapping(this.step.config.field_mapping, requesterFields, eventFields);
    }
    subscribeToObservables() {
      this.templateEventFieldsSubject.pipe(takeUntil(this.destroyed$)).subscribe({
        next: data => this.processEventFieldsMessage(data)
      });
    }
    ngOnChanges(simpleChanges) {
      this.cleanUnknownFields();
      if (!this.subscribed) {
        this.subscribeToObservables();
        this.subscribed = true;
      }
      if (simpleChanges.step && simpleChanges.step.currentValue) {
        this.setFields();
        this.setStepData();
        this.setFlags();
      }
    }
    setFlags() {
      const action = this.step.config && this.step.config.action;
      this.isAddOrRemoveTeam = action === FlowBuilderStepActionType.addTeam || action === FlowBuilderStepActionType.removeTeam;
      this.isGeneralEmail = action === FlowBuilderStepActionType.generalEmail;
      this.isEmailFromField = action === FlowBuilderStepActionType.emailFromField || action === FlowBuilderStepActionType.emailFromEventField;
      this.isCreateEvent = action === FlowBuilderStepActionType.createEvent;
      this.isSetDateTimeFieldToCurrent = action === FlowBuilderStepActionType.setDateTimeFieldToCurrent;
      this.isWebhook = action === FlowBuilderStepActionType.sendWebhook;
      this.isSendGenericEmail = action === FlowBuilderStepActionType.sendGenericEmail;
      this.isSetReferenceNumber = action === FlowBuilderStepActionType.setReferenceNumber;
      this.isSendObject = action === FlowBuilderStepActionType.sendObject;
      this.isCountSelectField = action === FlowBuilderStepActionType.countSelectField;
      this.isCopyEventDates = action === FlowBuilderStepActionType.copyEventDates;
      this.isCopyEventTextField = action === FlowBuilderStepActionType.copyEventTextField;
      this.isMessageToContactOrParticipant = action === FlowBuilderStepActionType.messageToContact || action === FlowBuilderStepActionType.messageToParticipant;
      this.isSendMessageToUser = action === FlowBuilderStepActionType.sendMessageToUser;
      this.isAddContactToEvent = action === FlowBuilderStepActionType.addContactToEvent;
      this.isGenerateCertificate = action === FlowBuilderStepActionType.generateCertificate;
    }
    setFields() {
      this.entityTypeFieldsCopy = this.sharedSvc.clone(this.entityTypeFieldsCombined);
      for (const entityTypeField of this.entityTypeFieldsCopy) {
        this.setAvailableOperatorsForFields(entityTypeField.fields);
        // Select-type fields for filtering need to be converted from enum to array
        if (this.step.type === FlowBuilderStepType.decision) {
          this.convertEnumFieldsToArray(entityTypeField.fields);
        }
      }
      if (this.step && this.step.entity_type && this.entityTypeFieldsCopy) {
        const currentStepEntityTypeFields = this.entityTypeFieldsCopy.find(etf => etf.entityTypeName === this.step.entity_type);
        if (currentStepEntityTypeFields) {
          const action = this.step.config && this.step.config.action;
          if (action === FlowBuilderStepActionType.emailFromEventField) {
            this.fields = currentStepEntityTypeFields.eventFields;
          } else {
            this.fields = currentStepEntityTypeFields.fields;
          }
          this.emailTypeFields = this.fields.filter(x => x.schema.format === 'email');
          this.emailTypeFields = this.sharedSvc.getVisibleAndUsedFields(this.emailTypeFields, [this.step.config?.field?.id]);
          const selectedEmailField = this.emailTypeFields.find(x => x.id === this.step.config?.field?.id);
          this.currentEmailFieldName = selectedEmailField ? selectedEmailField.label : '';
          this.emailFromFieldFieldValue = {
            displayProperty: 'label',
            reportProperty: 'id',
            items: this.emailTypeFields,
            selected: selectedEmailField
          };
          // this.emailFromEventFieldFieldValue = {
          //     displayProperty: 'label', reportProperty: 'id', items: this.emailTypeFields, selected: selectedEmailField
          // };
        }
      }
    }
    setAvailableOperatorsForFields(fields) {
      for (const field of fields) {
        if (!this.fieldOperators[field.id]) {
          const operatorsByField = this.sharedSvc.getAllOperatorsByField(field);
          this.fieldOperators[field.id] = operatorsByField;
        }
      }
    }
    convertEnumFieldsToArray(fields) {
      const definedFields = fields.filter(x => !!x);
      for (const field of definedFields) {
        this.sharedSvc.convertEnumToArray(field.schema);
        if (field.schema.type === 'array' && this.step.type === FlowBuilderStepType.decision) {
          field.component = "default" /* FieldComponentType.default */;
        }
      }
    }
    setStepData() {
      if (this.step && this.step.type) {
        switch (this.step.type) {
          case FlowBuilderStepType.wait:
            this.setWaitStepData();
            break;
          case FlowBuilderStepType.waitUntilField:
            this.setWaitUntilFieldStepData();
            break;
          case FlowBuilderStepType.decision:
            this.setDecisionTypesField();
            this.setDecisionStepData();
            this.setDecisionExternalCRMStepData();
            this.setDecisionNowStepData();
            this.setDecisionPaymentStepData();
            delete this.step.config;
            break;
          case FlowBuilderStepType.decisionExternalCRM:
            this.setDecisionTypesField();
            this.setDecisionStepData();
            this.setDecisionExternalCRMStepData();
            this.setDecisionNowStepData();
            this.setDecisionPaymentStepData();
            break;
          case FlowBuilderStepType.decisionNow:
            this.setDecisionTypesField();
            this.setDecisionStepData();
            this.setDecisionExternalCRMStepData();
            this.setDecisionNowStepData();
            this.setDecisionPaymentStepData();
            break;
          case FlowBuilderStepType.decisionPayment:
            this.setDecisionTypesField();
            this.setDecisionStepData();
            this.setDecisionExternalCRMStepData();
            this.setDecisionNowStepData();
            this.setDecisionPaymentStepData();
            break;
          case FlowBuilderStepType.stageChange:
            this.setStageChangeStepData();
            break;
          case FlowBuilderStepType.action:
            this.setActionStepData();
        }
      }
    }
    setDecisionTypesField() {
      const decisionTypes = [];
      if (this.isGlobalParticipant) {
        decisionTypes.push({
          id: FlowBuilderStepType.decision,
          label: this.sharedSvc.translate('FIELD_CONDITION')
        });
        decisionTypes.push({
          id: FlowBuilderStepType.decisionPayment,
          label: this.sharedSvc.translate('PAYMENT_TYPE')
        });
      } else {
        if (this.step.entity_type === FlowBuilderStepEntityType.participant) {
          decisionTypes.push({
            id: FlowBuilderStepType.decision,
            label: this.sharedSvc.translate('FIELD_CONDITION')
          });
          decisionTypes.push({
            id: FlowBuilderStepType.decisionExternalCRM,
            label: this.sharedSvc.translate('IS_IN_EXTERNAL_CRM')
          });
          decisionTypes.push({
            id: FlowBuilderStepType.decisionNow,
            label: this.sharedSvc.translate('COMPARE_CURRENT_DATE_TIME_TO_DATE_TIME_FIELD')
          });
          decisionTypes.push({
            id: FlowBuilderStepType.decisionPayment,
            label: this.sharedSvc.translate('PAYMENT_TYPE')
          });
        } else if (this.step.entity_type === FlowBuilderStepEntityType.contact) {
          decisionTypes.push({
            id: FlowBuilderStepType.decision,
            label: this.sharedSvc.translate('FIELD_CONDITION')
          });
          decisionTypes.push({
            id: FlowBuilderStepType.decisionExternalCRM,
            label: this.sharedSvc.translate('IS_IN_EXTERNAL_CRM')
          });
        } else if (this.step.entity_type === FlowBuilderStepEntityType.event) {
          decisionTypes.push({
            id: FlowBuilderStepType.decision,
            label: this.sharedSvc.translate('FIELD_CONDITION')
          });
          decisionTypes.push({
            id: FlowBuilderStepType.decisionNow,
            label: this.sharedSvc.translate('COMPARE_CURRENT_DATE_TIME_TO_DATE_TIME_FIELD')
          });
        }
      }
      this.flowStepFields.decisionType = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValue(decisionTypes, this.step.type)
      };
    }
    setDecisionStepData() {
      if (this.step.condition) {
        const searchParams = this.createFlatSearchParams(this.step.condition);
        this.decisionCondition = searchParams[0] || {};
        // Creating new decision does not have field
        if (this.decisionCondition.field) {
          this.allOperators = this.fieldOperators[this.decisionCondition.field.id];
          // this.sharedSvc.getAllOperatorsByField(this.decisionCondition.field);
          this.convertEnumFieldsToArray([this.decisionCondition.field]);
        } else {
          // This will be filled when field is selected
          this.allOperators = [];
        }
        this.operatorDisplayText = this.getOperatorDisplayText(this.allOperators, this.decisionCondition.operator);
      } else {
        this.decisionCondition = {};
      }
      const availableFields = this.sharedSvc.getVisibleAndUsedFields(this.fields, [this.decisionCondition.field?.id]);
      this.flowStepFields.decisionCondition = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValue(availableFields, this.decisionCondition.field?.id)
      };
    }
    setDecisionExternalCRMStepData() {
      // TODO: Require these as input ?
      const externalCRMIntegrations = this.integrations?.filter(x => x.type === 'external-crm');
      this.flowStepFields.existInExternalCRMIntegration = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValueDisplayingName(externalCRMIntegrations, this.step.config?.integration_id)
      };
      // TODO: Send these as a parameter ?
      if (this.step.entity_type === FlowBuilderStepEntityType.participant || this.step.entity_type === FlowBuilderStepEntityType.contact) {
        if (this.step.type === FlowBuilderStepType.decisionExternalCRM) {
          this.step.config ||= {};
        }
        const selectedExternalCRMIntegration = externalCRMIntegrations.find(x => x.id === this.step.config?.integration_id);
        this.decisionExternalCRMName = selectedExternalCRMIntegration?.name;
      }
    }
    setDecisionNowStepData() {
      // TODO: Condition is probably not needed
      // if (this.step.condition) {
      //     const searchParams = this.createFlatSearchParams(this.step.condition);
      //     this.decisionNowCondition = searchParams[0] || {};
      //     // Creating new decision does not have field
      //     if (this.decisionNowCondition.field) {
      //         this.allDecisionNowFieldOperators = this.fieldOperators[this.decisionNowCondition.field.id];
      //         // this.sharedSvc.getAllOperatorsByField(this.decisionCondition.field);
      //         this.convertEnumFieldsToArray([this.decisionNowCondition.field]);
      //     } else {
      //         // This will be filled when field is selected
      //         this.allDecisionNowFieldOperators = [];
      //     }
      //     this.decisionNowOperatorDisplayText = this.getOperatorDisplayText(this.allDecisionNowFieldOperators, this.decisionNowCondition.operator);
      // } else {
      //     this.decisionNowCondition = {} as IFilterCriteria;
      // }
      // this.decisionNowCondition = {} as IFilterCriteria;
      let sourceFields;
      if (this.step.entity_type === FlowBuilderStepEntityType.event) {
        sourceFields = this.entityTypeFieldsCombined.find(x => x.entityTypeName === FlowBuilderStepEntityType.event).eventFields;
      } else if (this.step.entity_type === FlowBuilderStepEntityType.participant) {
        sourceFields = this.entityTypeFieldsCombined.find(x => x.entityTypeName === FlowBuilderStepEntityType.participant).fields;
      }
      const cfg = this.step.config || {
        difference: 0,
        after: false
      };
      this.normalizeStepDecisionNowConfig(cfg);
      this.step.config = cfg;
      this.isDecisionNowDifferenceValueValid = true;
      let eventDateTimeFields = (sourceFields || []).filter(x => this.sharedSvc.getFieldTypeFromField(x) === 'datetime' || this.sharedSvc.getFieldTypeFromField(x) === 'travel-date');
      eventDateTimeFields = this.sharedSvc.getVisibleAndUsedFields(eventDateTimeFields, [cfg.datetime_field_id]);
      this.flowStepFields.decisionNowCondition = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValue(eventDateTimeFields, cfg.datetime_field_id)
      };
      const beforeAndAfterItems = [{
        id: "before" /* BeforeOrAfter.before */,
        label: this.sharedSvc.translate(this.getTimeOffsetDirectionTranslationKey("before" /* BeforeOrAfter.before */))
      }, {
        id: "after" /* BeforeOrAfter.after */,
        label: this.sharedSvc.translate(this.getTimeOffsetDirectionTranslationKey("after" /* BeforeOrAfter.after */))
      }];
      const selectedBeforeOrAfter = cfg.after ? "after" /* BeforeOrAfter.after */ : "before" /* BeforeOrAfter.before */;
      this.flowStepFields.decisionNowDirection = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValue(beforeAndAfterItems, selectedBeforeOrAfter)
      };
      const plusMinusItems = [{
        id: "plus" /* PlusMinus.plus */,
        label: this.sharedSvc.translate('PLUS')
      }, {
        id: "minus" /* PlusMinus.minus */,
        label: this.sharedSvc.translate('MINUS')
      }];
      const selectedPlusMinus = cfg.difference < 0 ? "minus" /* PlusMinus.minus */ : "plus" /* PlusMinus.plus */;
      this.flowStepFields.decisionNowDifferenceAbsValue = Math.abs(cfg.difference);
      this.flowStepFields.decisionNowPlusMinus = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValue(plusMinusItems, selectedPlusMinus)
      };
    }
    setDecisionPaymentStepData() {
      const cfg = this.step.config || {
        payment_type: "invoice" /* StepDecisionPaymentType.invoce */
      };
      this.step.config = cfg;
      const decisionPaymentItems = [{
        id: "invoice" /* StepDecisionPaymentType.invoce */,
        label: this.sharedSvc.translate('INVOICE')
      }, {
        id: "online" /* StepDecisionPaymentType.online */,
        label: this.sharedSvc.translate('ONLINE')
      }];
      const field = this.flowBuilderSvc.createObjectEnumField();
      field.mandatory_for_planners = true;
      this.flowStepFields.decisionPayment = {
        field,
        value: this.sharedSvc.createObjectEnumFieldValue(decisionPaymentItems, cfg?.payment_type)
      };
    }
    normalizeStepDecisionNowConfig(cfg) {
      if (!Object.keys(cfg).includes('after')) {
        cfg.after = false;
      }
      if (!Object.keys(cfg).includes('difference')) {
        cfg.difference = 0;
      }
    }
    setWebhookStepData() {
      this.setWebhookFields();
    }
    setWebhookFields() {
      // TODO: Require these as @Input rather than filtering them here ?
      const webhookIntegrations = this.getIntegrationsBasedOnStepAction();
      this.webhookIntegrationFieldValue = {
        displayProperty: 'name',
        items: webhookIntegrations,
        selected: webhookIntegrations ? webhookIntegrations.find(x => x.id === this.step?.config?.integration_id) : null
      };
    }
    setSendGenericEmailStepData() {
      // TODO: send generic email
      const stepConfig = this.step.config;
      const emailTemplateField = {
        id: 'emailTemplateField',
        editable: true,
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */,
        mandatory_for_planners: true
      };
      const emailTemplateFieldValue = this.createDefaultObjectEnumInputFieldValueReportingId(this.emailTemplates.map(x => ({
        id: x.id,
        label: x.name
      })), stepConfig.email_template_id);
      const languageField = {
        id: 'languageField',
        editable: true,
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */,
        mandatory_for_planners: true
      };
      const languageFieldValue = this.createDefaultObjectEnumInputFieldValueReportingId(this.languages, stepConfig.language);
      const toEmailField = {
        id: 'toEmailField',
        editable: true,
        schema: {
          type: 'string',
          format: 'email'
        },
        mandatory_for_planners: true
      };
      const fromEmailField = {
        id: 'fromEmailField',
        editable: true,
        schema: {
          type: 'string',
          format: 'email'
        },
        mandatory_for_planners: true
      };
      const fromNamefield = {
        id: 'fromNamefield',
        editable: true,
        schema: {
          type: 'string'
        },
        mandatory_for_planners: true
      };
      const replyEmailField = {
        id: 'replyEmailField',
        editable: true,
        schema: {
          type: 'string',
          format: 'email'
        },
        mandatory_for_planners: true
      };
      const bounceEmailField = {
        id: 'bounceEmailField',
        editable: true,
        schema: {
          type: 'string',
          format: 'email'
        },
        mandatory_for_planners: true
      };
      const subjectField = {
        id: 'subjectField',
        editable: true,
        schema: {
          type: 'string'
        },
        mandatory_for_planners: true
      };
      this.sendGenericEmailData = {
        emailTemplateField: emailTemplateField,
        emailTemplateFieldValue: emailTemplateFieldValue,
        languageField: languageField,
        languageFieldValue: languageFieldValue,
        toEmailField: toEmailField,
        fromEmailField: fromEmailField,
        fromNameField: fromNamefield,
        replyEmailField: replyEmailField,
        bounceEmailField: bounceEmailField,
        subjectField: subjectField,
        invalidValueMap: {}
      };
    }
    setSendEmailToApproverData() {
      const emailParticipantFields = this.getFlowBuilderEntityTypeFieldsByEntityType(FlowBuilderStepEntityType.participant).fields.filter(field => this.sharedSvc.getFieldTypeFromField(field) === 'email');
      const lang = this.sharedSvc.getCurrentLanguage();
      const data = {
        approver_field_id: {
          type: 'select',
          editable: true,
          schema: {
            type: 'string',
            enum: emailParticipantFields.map(({
              id
            }) => id)
          },
          id: 'approver_field_id',
          name: 'approver_field_id',
          label: this.sharedSvc.translate('APPROVAL_EMAIL_FIELD'),
          attributeTranslations: emailParticipantFields.map(field => ({
            trans: {
              [lang]: field.label
            },
            value: field.id
          }))
        },
        email_campaign_id: {
          type: 'select',
          editable: true,
          schema: {
            type: 'string',
            enum: this.emailCampaigns.map(({
              id
            }) => id)
          },
          id: 'email_campaign_id',
          name: 'email_campaign_id',
          label: this.sharedSvc.translate('EMAIL_CAMPAIGN'),
          attributeTranslations: this.emailCampaigns.map(field => ({
            trans: {
              [lang]: field.label
            },
            value: field.id
          }))
        }
      };
      this.sendEmailToApproverData = data;
    }
    createDefaultObjectEnumInputFieldValueReportingId(items, selectedId) {
      const result = {
        items: items,
        displayProperty: 'label',
        selected: items?.find(x => x.id === selectedId),
        reportProperty: 'id'
      };
      return result;
    }
    onDecisionExternalCRMIntegrationChanged(args) {
      this.step.config ||= {};
      this.step.config.integration_id = args?.value.id;
    }
    onWebhookIntegrationChanged(args) {
      this.step.config.integration_id = args?.value.id;
    }
    onSendObjectIntegrationChanged(args) {
      this.step.config.integration_id = args?.value.id;
    }
    onCountSelectFieldParticipantFieldChanged(args) {
      const field = args.value;
      const config = this.step.config;
      config.select_field_id = field.id;
      config.select_field_value = null;
      this.setCountParticipantFieldValueFieldValue(field.schema.enum || [], null);
    }
    onCountSelectFieldParticipantFieldValueChanged(args) {
      this.step.config.select_field_value = args?.value.id;
    }
    onCountSelectFieldEventFieldChanged(args) {
      this.step.config.number_field_id = args?.value.id;
    }
    onCopyEventDatesStartDateFieldChanged(args) {
      const field = args.value;
      const config = this.step.config;
      config.start_date_field_id = field.id;
    }
    onCopyEventDatesEndDateFieldChanged(args) {
      const field = args.value;
      const config = this.step.config;
      config.end_date_field_id = field.id;
    }
    onCopyEventTextFieldEventFieldChanged(args) {
      const field = args.value;
      const config = this.step.config;
      config.event_field_id = field.id;
    }
    onCopyEventTextFieldContactFieldChanged(args) {
      const field = args.value;
      const config = this.step.config;
      config.text_field_id = field.id;
    }
    onMessageToContactOrParticipantFieldChanged(fieldTypeString, args) {
      const fieldType = fieldTypeString;
      const selectedField = args.value;
      const config = this.step.config;
      if (fieldType === 'integration') {
        config.integration_id = selectedField.id;
      } else if (fieldType === 'number') {
        config.number_id = selectedField.id;
      } else if (fieldType === 'message') {
        config.message = args.value;
      } else if (fieldType === 'subject') {
        config.subject = args.value;
      } else if (fieldType === 'event_app_entity_id') {
        config.eventAppComponent = {
          ...config.eventAppComponent,
          entity_id: args.value?.id
        };
      } else if (fieldType === 'event_app_module') {
        const eventAppModule = args.value?.id;
        const entityListField = eventAppModule && this.getMessageToContactOrParticipantEventAppEntityField(eventAppModule);
        config.eventAppComponent = {
          ...config.eventAppComponent,
          component: eventAppModule,
          entity_id: entityListField?.value?.selected
        };
      }
    }
    onSendMessageToUserFieldChanged(fieldType, args) {
      const selectedField = args.value;
      const config = this.step.config;
      if (fieldType === 'integration') {
        config.integration_id = selectedField.id;
      } else if (fieldType === 'userIds') {
        // TODO: Input field do not support multi select fields with integer type (appears without content) - it was created as string array
        //       We need to convert string array to integer array
        config.user_ids = args.value.map(x => +x);
      } else if (fieldType === 'message') {
        config.message = args.value;
      }
    }
    onAddContactToEventEventFieldChanged(args) {
      const selectedField = args.value;
      const config = this.step.config;
      config.event_id = selectedField.id;
    }
    onGenerateCertificateDocumentChanged(args) {
      const selectedField = args.value;
      const config = this.step.config;
      config.document_id = selectedField.id;
    }
    onGenerateCertificateDocumentFieldChanged(args) {
      const selectedField = args.value;
      const config = this.step.config;
      config.document_field_id = selectedField.id;
    }
    onGenerateCertificateDocumentNameChanged(args) {
      const documentName = args.value;
      const config = this.step.config;
      config.document_name = documentName;
    }
    setActionStepData() {
      if (!this.step.config) {
        return;
      }
      const config = this.step.config;
      const action = config.action;
      if (action === FlowBuilderStepActionType.setField) {
        const availableFields = this.sharedSvc.getVisibleAndUsedFields(this.fields, [config.field_id]);
        this.flowStepFields.setField = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(availableFields, config.field_id)
        };
        if (config.field_id) {
          this.currentActionStepField = this.getCurrentActionStepField();
        }
      } else if (action === FlowBuilderStepActionType.email) {
        this.flowStepFields.emailTemplate = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValueDisplayingName(this.emailTemplates, config.email_campaign_id)
        };
        if (config.email_campaign_id) {
          this.currentEmailTemplateName = this.getCurrentEmailTemplateName();
        }
      } else if (action === FlowBuilderStepActionType.addTeam) {
        this.flowStepFields.team = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.teams, config.team_id)
        };
        if (config.team_id) {
          this.currentTeamName = this.flowStepSvc.getNumberIdLabel(this.teams, config.team_id);
        }
      } else if (action === FlowBuilderStepActionType.removeTeam) {
        this.flowStepFields.team = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.teams, config.team_id)
        };
        if (config.team_id) {
          this.currentTeamName = this.flowStepSvc.getNumberIdLabel(this.teams, config.team_id);
        }
      } else if (action === FlowBuilderStepActionType.generalEmail) {
        // TODO: We need mechanism for the input field to set whether its vlaue is valid according to ajv vlaidation
        this.flowStepFields.emailCampaign = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.emailCampaigns, config.email_campaign_id)
        };
        this.isGeneralEmailValueValid = !!config.to_email;
        this.currentEmailCampaignName = this.flowStepSvc.getLabel(this.emailCampaigns, config.email_campaign_id);
        this.flowStepFields.language = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.languages, config.language)
        };
        this.currentLanguageName = this.flowStepSvc.getLabel(this.languages, config.language);
      } else if (action === FlowBuilderStepActionType.emailFromField || action === FlowBuilderStepActionType.emailFromEventField) {
        this.flowStepFields.emailCampaign = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.emailCampaigns, config.email_campaign_id)
        };
        config.field.type = this.step.entity_type;
        this.isEmailFromFieldValueValid = !!config.field.id;
        this.currentEmailCampaignName = this.flowStepSvc.getLabel(this.emailCampaigns, config.email_campaign_id);
        this.flowStepFields.language = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.languages, config.language)
        };
        this.currentLanguageName = this.flowStepSvc.getLabel(this.languages, config.language);
      } else if (action === FlowBuilderStepActionType.createEvent) {
        this.flowStepFields.team = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.teams, config.initial_team_id)
        };
        this.currentCreateEventTeamName = this.flowStepSvc.getNumberIdLabel(this.teams, config.initial_team_id);
        this.flowStepFields.eventTemplate = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.templateEvents, config.template_id)
        };
        const configuredEventTemplateId = config.template_id;
        if (configuredEventTemplateId) {
          this.requestEventTemplateFields(configuredEventTemplateId);
        }
      } else if (action === FlowBuilderStepActionType.setDateTimeFieldToCurrent) {
        this.setSetDateTimeFieldToCurrentStepData();
      } else if (action === FlowBuilderStepActionType.setRelativeDateTime) {
        this.setSetDateTimeFieldToCurrentStepData(['start']);
      } else if (action === FlowBuilderStepActionType.setRelativeTime) {
        this.setSetTimeFieldToCurrentStepData([]);
      } else if (action === FlowBuilderStepActionType.sendWebhook) {
        this.setWebhookStepData();
      } else if (action === FlowBuilderStepActionType.sendGenericEmail) {
        this.setSendGenericEmailStepData();
      } else if (action === FlowBuilderStepActionType.sendEmailToApprover) {
        this.setSendEmailToApproverData();
      } else if (action === FlowBuilderStepActionType.setReferenceNumber) {
        this.setSetReferenceNumberStepData();
      } else if (action === FlowBuilderStepActionType.sendObject) {
        this.setSendObjectStepData();
      } else if (action === FlowBuilderStepActionType.countSelectField) {
        this.setCountSelectFieldStepData();
      } else if (action === FlowBuilderStepActionType.copyEventDates) {
        this.setCopyEventDatesStepData();
      } else if (action === FlowBuilderStepActionType.copyEventTextField) {
        this.setCopyEventTextFieldStepData();
      } else if (action === FlowBuilderStepActionType.messageToContact) {
        this.setMessageToContactStepData();
      } else if (action === FlowBuilderStepActionType.messageToParticipant) {
        this.setMessageToParticipantStepData();
      } else if (action === FlowBuilderStepActionType.sendMessageToUser) {
        this.setSendMessageToUserStepData();
      } else if (action === FlowBuilderStepActionType.addContactToEvent) {
        this.setAddContactToEventStepData();
      } else if (action === FlowBuilderStepActionType.generateCertificate) {
        this.setGenerateCertificateStepData();
      }
    }
    onCreateEventTeamChanged(args) {
      this.step.config.initial_team_id = args.value.id;
    }
    onLanguageChanged(args) {
      this.step.config.language = args.value.id;
      this.currentLanguageName = this.flowStepSvc.getLabel(this.languages, this.step.config.language);
    }
    operatorHasValue(operator) {
      return this.sharedSvc.operatorHasValue(operator);
    }
    fieldsMappingChanged() {
      const fieldMapping = this.flowStepSvc.createRequestedFieldMappingSetting(this.requesterFieldToEventFieldMap);
      this.step.config.field_mapping = fieldMapping;
    }
    patchStepConfig(patchData) {
      Object.assign(this.this.step.config, patchData);
    }
    onRequesterFieldChange(map) {
      const matchingFields = this.flowStepSvc.getSchemaMatchingFields(map.requesterField, this.templateEventFields);
      const usedFields = [...this.requesterFieldToEventFieldMap.map(x => x.eventField)].filter(x => x);
      map.possibleEventFields = this.flowStepSvc.getNonUsedFields(matchingFields, usedFields);
      map.eventField = null;
      this.fieldsMappingChanged();
    }
    onEventFieldChange() {
      this.fieldsMappingChanged();
    }
    deleteFieldMap(map) {
      this.requesterFieldToEventFieldMap.splice(this.requesterFieldToEventFieldMap.findIndex(x => x === map), 1);
      this.fieldsMappingChanged();
    }
    addNewFieldMap() {
      this.requesterFieldToEventFieldMap.push({
        requesterField: null,
        eventField: null,
        possibleEventFields: this.templateEventFields
      });
      this.fieldsMappingChanged();
    }
    getCurrentActionStepField() {
      if (!this.fields) {
        return null;
      }
      return this.fields.find(x => x.id === this.step.config.field_id);
    }
    getTimeOffsetDirectionTranslationKey(direction) {
      if (direction === 'after') {
        return 'AFTER';
      } else if (direction === 'before') {
        return 'BEFORE';
      } else {
        return direction;
      }
    }
    getCurrentEmailTemplateName() {
      if (!this.emailTemplates) {
        return null;
      }
      const currentEmailTemplate = this.emailTemplates.find(x => x.id === this.step.config.email_campaign_id);
      return currentEmailTemplate ? currentEmailTemplate.name : null;
    }
    setStageChangeStepData() {
      this.stageName = this.getStageName();
    }
    setWaitStepData() {
      const timeTypesInSecondsDescending = [604800, 86400, 3600, 60, 1];
      const highestTimeFactor = timeTypesInSecondsDescending.find(t => this.step.duration_seconds % t === 0);
      const timeType = this.secondsToTimeType[highestTimeFactor];
      this.waitStepTimeType = this.getWaitStepTimeType(timeType);
      this.waitStepTimeValue = this.step.duration_seconds / highestTimeFactor;
      this.flowStepFields.waitTimeType = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValue(this.waitStepTimeTypes, this.waitStepTimeType?.id)
      };
    }
    setWaitUntilFieldStepData() {
      this.setWaitUntilFieldFields();
      const isGlobalProcess = !!this.globalProcessEntityType;
      if (isGlobalProcess) {
        if (this.globalProcessEntityType === FlowBuilderStepEntityType.event) {
          this.waitUntilFieldStepFieldTypes = [{
            id: WaitUntilFieldStepFieldType.eventField,
            label: this.sharedSvc.translate('EVENT_FIELD')
          }];
          this.step.field_type = WaitUntilFieldStepFieldType.eventField;
        } else if (this.globalProcessEntityType === FlowBuilderStepEntityType.contact) {
          this.waitUntilFieldStepFieldTypes = [{
            id: WaitUntilFieldStepFieldType.contactField,
            label: this.sharedSvc.translate('CONTACT_FIELD')
          }];
          this.step.field_type = WaitUntilFieldStepFieldType.contactField;
        } else if (this.globalProcessEntityType === FlowBuilderStepEntityType.organization) {
          this.waitUntilFieldStepFieldTypes = [{
            id: WaitUntilFieldStepFieldType.organizationField,
            label: this.sharedSvc.translate('ORGANIZATION_FIELD')
          }];
          this.step.field_type = WaitUntilFieldStepFieldType.organizationField;
        }
      } else {
        // participant process
        this.waitUntilFieldStepFieldTypes = [{
          id: WaitUntilFieldStepFieldType.eventField,
          label: this.sharedSvc.translate('EVENT_FIELD')
        }, {
          id: WaitUntilFieldStepFieldType.participantField,
          label: this.sharedSvc.translate('PARTICIPANT_FIELD')
        }];
      }
      this.waitUntilFieldStepSelectedFieldType = this.step.field_type;
      this.waitUntilFieldStepField = this.waitUntilFieldStepFields ? this.waitUntilFieldStepFields.find(x => x.id === this.step.field_id) : null;
      this.waitUntilFieldStepFieldType = this.step.field_type;
      this.waitUntilFieldStepOffsetSeconds = Math.abs(this.step.offset_seconds);
      if (this.step.offset_seconds < 0) {
        this.waitUntilFieldStepOffsetDirection = 'before';
      } else {
        this.waitUntilFieldStepOffsetDirection = 'after';
      }
      const timeTypesInSecondsDescending = [604800, 86400, 3600, 60, 1];
      const highestTimeFactor = this.waitUntilFieldStepOffsetSeconds === 0 ? 1 : timeTypesInSecondsDescending.find(t => this.waitUntilFieldStepOffsetSeconds % t === 0);
      const timeType = this.secondsToTimeType[highestTimeFactor];
      this.waitUntilFieldStepTimeType = this.getWaitStepTimeType(timeType);
      this.waitUntilFieldStepOffsetSeconds = this.waitUntilFieldStepOffsetSeconds / highestTimeFactor;
      if (!this.flowStepFields.waitUntilFieldType) {
        this.flowStepFields.waitUntilFieldType = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.waitUntilFieldStepFieldTypes, this.step.field_type)
        };
      }
    }
    onWaitUntilFieldStepFieldTypeChanged(args) {
      this.step.field_type = args.value.id;
      this.step.field_id = '';
      // TODO: ? Is this needed ? can we call only this.setWaitUntilFieldFields()
      this.setWaitUntilFieldStepData();
    }
    onWaitUntilFieldStepOffsetSecondsChanged(changes) {
      this.waitUntilFieldStepOffsetSecondsValid = true;
      this.waitUntilFieldStepOffsetSeconds = +changes.value;
      this.setWaitUntilFieldStepOffsetSecondsValue();
    }
    onWaitUntilFieldStepOffsetDirectionChange() {
      this.setWaitUntilFieldStepOffsetSecondsValue();
    }
    setWaitUntilFieldStepOffsetSecondsValue() {
      if (this.waitUntilFieldStepOffsetDirection === 'before') {
        this.step.offset_seconds = this.getDurationInSeconds(-this.waitUntilFieldStepOffsetSeconds, this.waitUntilFieldStepTimeType.id);
      } else {
        this.step.offset_seconds = this.getDurationInSeconds(this.waitUntilFieldStepOffsetSeconds, this.waitUntilFieldStepTimeType.id);
      }
    }
    onWaitUntilFieldFieldChanged(args) {
      this.step.field_id = args.value.id;
    }
    onWaitUntilFieldStepOffsetSecondsInvalidValueSet() {
      this.waitUntilFieldStepOffsetSecondsValid = false;
      this.step.offset_seconds = '';
    }
    setWaitUntilFieldFields() {
      const isGlobalProcess = !!this.globalProcessEntityType;
      if (this.globalProcessEntityType === FlowBuilderStepEntityType.event) {
        this.waitUntilFieldStepFieldTypeTranslationKey = 'EVENT_FIELD';
      } else if (this.globalProcessEntityType === FlowBuilderStepEntityType.contact) {
        this.waitUntilFieldStepFieldTypeTranslationKey = 'CONTACT_FIELD';
      } else if (this.globalProcessEntityType === FlowBuilderStepEntityType.organization) {
        this.waitUntilFieldStepFieldTypeTranslationKey = 'ORGANIZATION_FIELD';
      }
      if (isGlobalProcess) {
        const eventEntityTypeFields = this.entityTypeFieldsCopy.find(x => x.entityTypeName === this.globalProcessEntityType);
        this.waitUntilFieldStepFields = eventEntityTypeFields && eventEntityTypeFields.fields ? eventEntityTypeFields.fields.filter(x => x.schema.format === 'date-time') : [];
        this.waitUntilFieldStepFields = this.sharedSvc.getVisibleAndUsedFields(this.waitUntilFieldStepFields, [this.step.field_id]);
        this.flowStepFields.waitUntilField = null;
        window.setTimeout(() => {
          this.flowStepFields.waitUntilField = {
            field: this.flowBuilderSvc.createObjectEnumField(),
            value: this.sharedSvc.createObjectEnumFieldValue(this.waitUntilFieldStepFields || [], this.step.field_id)
          };
        });
        return;
      }
      if (this.step.field_type === WaitUntilFieldStepFieldType.eventField) {
        const eventFields = this.entityTypeFieldsCopy.find(x => x.entityTypeName === FlowBuilderStepEntityType.event);
        this.waitUntilFieldStepFields = eventFields && eventFields.fields ? eventFields.fields.filter(x => x.schema.format === 'date-time') : [];
        this.waitUntilFieldStepFields = this.sharedSvc.getVisibleAndUsedFields(this.waitUntilFieldStepFields, [this.step.field_id]);
        this.waitUntilFieldStepFieldTypeTranslationKey = 'EVENT_FIELD';
      } else if (this.step.field_type === WaitUntilFieldStepFieldType.participantField) {
        const participantFields = this.entityTypeFieldsCopy.find(x => x.entityTypeName === FlowBuilderStepEntityType.participant);
        this.waitUntilFieldStepFields = participantFields && participantFields.fields ? participantFields.fields.filter(x => x.schema.format === 'date-time') : [];
        this.waitUntilFieldStepFields = this.sharedSvc.getVisibleAndUsedFields(this.waitUntilFieldStepFields, [this.step.field_id]);
        this.waitUntilFieldStepFieldTypeTranslationKey = 'PARTICIPANT_FIELD';
      }
      this.flowStepFields.waitUntilField = null;
      window.setTimeout(() => {
        this.flowStepFields.waitUntilField = {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.waitUntilFieldStepFields || [], this.step.field_id)
        };
      });
    }
    onWaitUntilFieldStepTimeTypeChanged() {
      this.step.offset_seconds = this.getDurationInSeconds(this.waitUntilFieldStepOffsetSeconds, this.waitUntilFieldStepTimeType.id);
    }
    setSetDateTimeFieldToCurrentStepData(excludeFieldNames) {
      // this.requesterDateTimeTypeFields = this.fields.filter(x => x.schema.format === 'date-time');
      let requesterDateTimeTypeFields = this.fields.filter(x => x.schema.format === 'date-time');
      if (excludeFieldNames) {
        requesterDateTimeTypeFields = requesterDateTimeTypeFields.filter(x => !excludeFieldNames.includes(x.name));
      }
      requesterDateTimeTypeFields = this.sharedSvc.getVisibleAndUsedFields(requesterDateTimeTypeFields, [this.step.config.field_id]);
      this.flowStepFields.requesterDateTimeTypeField = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValue(requesterDateTimeTypeFields, this.step.config.field_id)
      };
      this.selectedSetDateTimeFieldToCurrent = requesterDateTimeTypeFields.find(x => x.id === this.step.config.field_id);
    }
    setSetTimeFieldToCurrentStepData(excludeFieldNames) {
      let requesterTimeTypeFields = this.fields.filter(field => fieldType(field) === 'time');
      if (excludeFieldNames) {
        requesterTimeTypeFields = requesterTimeTypeFields.filter(x => !excludeFieldNames.includes(x.name));
      }
      requesterTimeTypeFields = this.sharedSvc.getVisibleAndUsedFields(requesterTimeTypeFields, [this.step.config.field_id]);
      this.flowStepFields.requesterTimeTypeField = {
        field: this.flowBuilderSvc.createObjectEnumField(),
        value: this.sharedSvc.createObjectEnumFieldValue(requesterTimeTypeFields, this.step.config.field_id)
      };
      this.selectedSetTimeFieldToCurrent = requesterTimeTypeFields.find(x => x.id === this.step.config.field_id);
    }
    setSetReferenceNumberStepData() {
      let textOnlyFields = this.fields.filter(x => this.sharedSvc.getFieldTypeFromField(x) === 'text');
      textOnlyFields = this.sharedSvc.getVisibleAndUsedFields(textOnlyFields, [this.step.config.field_id]);
      this.setReferenceNumberFieldValue = {
        displayProperty: 'label',
        items: textOnlyFields,
        selected: textOnlyFields ? textOnlyFields.find(x => x.id === this.step?.config?.field_id) : null
      };
    }
    setSendObjectStepData() {
      // TODO: Require these as @Input rather than filtering them here ?
      const externalCrmIntegrations = this.getIntegrationsBasedOnStepAction();
      const config = this.step?.config;
      this.sendObjectIntegrationFieldValue = {
        displayProperty: 'name',
        items: externalCrmIntegrations,
        selected: externalCrmIntegrations ? externalCrmIntegrations.find(x => x.id === config?.integration_id) : null
      };
    }
    setCountSelectFieldStepData() {
      const config = this.step?.config;
      const participantEntityTypeFields = this.entityTypeFieldsCombined.find(x => x.entityTypeName === FlowBuilderStepEntityType.participant);
      let participantSelectFields = participantEntityTypeFields.fields.filter(x => x.type === 'select');
      participantSelectFields = this.sharedSvc.getVisibleAndUsedFields(participantSelectFields, [config?.select_field_id]);
      const selectedParticipantField = participantSelectFields.find(x => x.id === config?.select_field_id);
      let eventNumberFields = participantEntityTypeFields.eventFields.filter(x => x.type === 'integer' || x.type === 'number');
      eventNumberFields = this.sharedSvc.getVisibleAndUsedFields(eventNumberFields, [config?.number_field_id]);
      this.countSelectFieldData.participantField.value = {
        displayProperty: 'label',
        selected: selectedParticipantField,
        items: participantSelectFields
      };
      this.setCountParticipantFieldValueFieldValue(selectedParticipantField?.schema.enum || [], config?.select_field_value);
      this.countSelectFieldData.eventField.value = {
        displayProperty: 'label',
        selected: eventNumberFields.find(x => x.id === config?.number_field_id),
        items: eventNumberFields
      };
    }
    setCopyEventDatesStepData() {
      const config = this.step?.config;
      const eventFields = this.entityTypeFieldsCopy.find(x => x.entityTypeName === FlowBuilderStepEntityType.event);
      let dateFields = eventFields.fields.filter(x => x.schema.format === 'date');
      dateFields = this.sharedSvc.getVisibleAndUsedFields(dateFields, [config.start_date_field_id, config.end_date_field_id]);
      this.copyEventDatesFieldData.startDateField.value = this.sharedSvc.createObjectEnumFieldValue(dateFields, config.start_date_field_id);
      this.copyEventDatesFieldData.endDateField.value = this.sharedSvc.createObjectEnumFieldValue(dateFields, config.end_date_field_id);
    }
    setCopyEventTextFieldStepData() {
      const config = this.step?.config;
      const eventFields = this.entityTypeFieldsCopy.find(x => x.entityTypeName === FlowBuilderStepEntityType.event);
      let eventTextFields = [];
      for (const eventField of eventFields.fields) {
        const fieldType = this.sharedSvc.getFieldTypeFromField(eventField);
        if (fieldType === 'text' || fieldType === 'select') {
          eventTextFields.push(eventField);
        }
      }
      eventTextFields = this.sharedSvc.getVisibleAndUsedFields(eventTextFields, [config.event_field_id]);
      const contactFields = this.entityTypeFieldsCopy.find(x => x.entityTypeName === FlowBuilderStepEntityType.participant);
      let contactTextFields = contactFields.fields.filter(x => this.sharedSvc.getFieldTypeFromField(x) === 'text');
      contactTextFields = this.sharedSvc.getVisibleAndUsedFields(contactTextFields, [config.text_field_id]);
      this.copyEventTextFieldFieldData.eventField.value = this.sharedSvc.createObjectEnumFieldValue(eventTextFields, config.event_field_id);
      this.copyEventTextFieldFieldData.participantField.value = this.sharedSvc.createObjectEnumFieldValue(contactTextFields, config.text_field_id);
    }
    setMessageToContactStepData() {
      this.setMessageToContactOrParticipantData(FlowBuilderStepEntityType.contact);
    }
    setMessageToParticipantStepData() {
      this.setMessageToContactOrParticipantData(FlowBuilderStepEntityType.participant);
    }
    setSendMessageToUserStepData() {
      const config = this.step?.config;
      const userIdsField = {
        id: 'user_ids',
        name: 'user_ids',
        editable: true,
        schema: {
          type: 'array',
          items: {
            type: 'string',
            enum: this.users.map(x => '' + x.id)
          }
        }
      };
      const messageGatewayIntegrations = this.getIntegrationsBasedOnStepAction();
      const userIdsStringArray = (config?.user_ids || []).map(x => '' + x);
      const userIdsTranslations = {};
      this.users.forEach(x => userIdsTranslations[x.id] = x.label);
      this.sendMessageToUserFieldData = {
        integration: {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValueDisplayingName(messageGatewayIntegrations, config.integration_id)
        },
        message: {
          field: {
            schema: {
              type: 'string'
            },
            editable: true
          },
          value: config.message
        },
        userIds: {
          field: userIdsField,
          value: userIdsStringArray
        },
        userIdsOptions: {
          translations: {
            [this.sharedSvc.locale]: userIdsTranslations
          }
        }
      };
    }
    setAddContactToEventStepData() {
      const config = this.step?.config;
      this.addContactToEventFieldData = {
        event: {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.events || [], config.event_id)
        }
      };
    }
    setGenerateCertificateStepData() {
      const config = this.step?.config;
      this.generateCertificateFieldData = {
        document: {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.docxDocuments || [], config.document_id)
        },
        documentField: {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(this.documentFields || [], config.document_field_id)
        },
        documentName: {
          field: {
            schema: {
              type: 'string'
            },
            editable: true
          },
          value: config.document_name
        }
      };
    }
    setMessageToContactOrParticipantData(entityTypeName) {
      const config = this.step?.config;
      let participantFields = this.entityTypeFieldsCopy.find(x => x.entityTypeName === entityTypeName).fields;
      participantFields = this.sharedSvc.getVisibleAndUsedFields(participantFields, [config.number_id]);
      this.messageToContactOrParticipantFieldData = {
        integration: {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValueDisplayingName(this.getIntegrationsBasedOnStepAction(), config.integration_id)
        },
        number: {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(participantFields, config.number_id)
        },
        subject: {
          field: {
            schema: {
              type: 'string'
            },
            editable: true
          },
          value: config.message
        },
        message: {
          field: {
            schema: {
              type: 'string'
            },
            editable: true
          },
          value: config.message
        },
        event_app_module: {
          field: this.flowBuilderSvc.createObjectEnumField(),
          value: this.sharedSvc.createObjectEnumFieldValue(EVENT_APP_COMPONENT_TYPES.map(type => ({
            id: type,
            label: this.sharedSvc.translate(type.toUpperCase())
          })), config.eventAppComponent?.component)
        }
      };
      config.email_id = participantFields.find(x => x.name === 'email')?.id;
      config.first_name_id = participantFields.find(x => x.name === 'first_name')?.id;
      config.last_name_id = participantFields.find(x => x.name === 'last_name')?.id;
    }
    getEventAppComponentEntityList(type) {
      const entityListMap = {
        content: this.eventAppPages,
        sessions: this.eventActivities
      };
      const entityList = entityListMap[type];
      return entityList;
    }
    setCountParticipantFieldValueFieldValue(values, selected) {
      this.countSelectFieldData.participantFieldValue.value = null;
      window.setTimeout(() => {
        const items = values.map(x => ({
          id: x,
          label: x
        }));
        this.countSelectFieldData.participantFieldValue.value = {
          displayProperty: 'label',
          selected: items.find(x => x.id === selected),
          items: items
        };
      });
    }
    onSetReferenceFieldChanged(args) {
      this.step.config.field_id = args.value.id;
    }
    onSetConfigProperty(propertyName, value) {
      this.step.config[propertyName] = value;
    }
    onWaitStepValueChanged(changedArgs) {
      this.waitStepTimeValue = changedArgs.value;
      this.step.duration_seconds = this.getDurationInSeconds(this.waitStepTimeValue, this.waitStepTimeType.id);
      this.waitStepSecondsValid = true;
    }
    onWaitStepInvalidValueSet() {
      this.waitStepSecondsValid = false;
    }
    onWaitStepTimeTypeChanged(args) {
      this.waitStepTimeType = args.value;
      this.step.duration_seconds = this.getDurationInSeconds(this.waitStepTimeValue, this.waitStepTimeType.id);
    }
    onSetDateTimeFieldToCurrentFieldChanged(args) {
      this.step.config.field_id = args.value.id;
      this.selectedSetDateTimeFieldToCurrent = args.value;
    }
    onSetTimeFieldToCurrentFieldChanged(args) {
      this.step.config.field_id = args.value.id;
      this.selectedSetTimeFieldToCurrent = args.value;
    }
    getWaitStepTimeType(type) {
      return this.waitStepTimeTypes.find(x => x.id === type);
    }
    getDurationInSeconds(timeValue, timeType) {
      return timeValue * this.timeTypeToSeconds[timeType];
    }
    deleteStep() {
      this.delete.emit();
    }
    getActionLabelTranslationKey(action) {
      return this.flowBuilderSvc.getActionLabelTranslationKey(action);
    }
    onStageChange(args) {
      this.step.stage_id = args.value.id;
      this.stageName = this.getStageName();
    }
    onWorkflowChange(args) {
      const workflowId = args.value.id;
      this.step.workflow_id = workflowId;
      this.goToWorkflowWorkflowName = this.getWorkflowName(workflowId);
    }
    getStageName() {
      const currentStage = this.stages.find(s => s.id === this.step.stage_id);
      return currentStage ? currentStage.name : '';
    }
    setDecisionStepCondition() {
      this.step.condition = this.sharedSvc.criteriaToSearchParams([this.decisionCondition], this.fieldMode);
    }
    createFlatSearchParams(stepCondition) {
      return this.sharedSvc.searchParamsToCriteria(stepCondition, this.fields, this.fieldMode);
      // return recursiveSearchToFlat(stepCondition, this.fieldMode, this.fields);
    }
    onDecisionTypeFieldChanged(args) {
      const selection = args.value;
      const stepType = selection.id;
      this.step.type = stepType;
      if (stepType === FlowBuilderStepType.decisionExternalCRM) {
        this.clearDecisionStepConfig();
        delete this.step.condition;
        this.step.config = {
          exists: false
        };
      } else if (stepType === FlowBuilderStepType.decisionNow) {
        this.clearDecisionStepConfig();
        delete this.step.condition;
        this.step.config = {};
      } else if (stepType === FlowBuilderStepType.decision) {
        this.decisionCondition ||= {};
        this.clearDecisionStepConfig();
      } else if (stepType === FlowBuilderStepType.decisionPayment) {
        this.clearDecisionStepConfig();
        delete this.step.condition;
        this.step.config = {
          payment_type: null
        };
      }
    }
    clearDecisionStepConfig() {
      // TODO: This is needed so config does not leak if it does not have one
      delete this.step.config;
      this.flowStepFields.decisionNowCondition.value.selected = null;
      this.flowStepFields.existInExternalCRMIntegration.value.selected = null;
      this.flowStepFields.decisionPayment.value.selected = null;
    }
    onDecisionFieldChanged(args) {
      if (!this.decisionCondition) {
        return;
      }
      this.decisionCondition.field = args.value;
      if (this.decisionCondition.field.schema.format === 'email') {
        this.decisionCondition.field = {
          ...this.decisionCondition.field
        };
        delete this.decisionCondition.field.schema.format;
      }
      // On field change always set default value
      this.decisionCondition.value = this.sharedSvc.getDefaultValueForField(this.decisionCondition.field);
      // Refresh operators availability based on the field
      // this.sharedSvc.getAllOperatorsByField(this.decisionCondition.field);
      this.allOperators = this.fieldOperators[this.decisionCondition.field.id];
      const selected = this.allOperators.find(x => x.name === this.decisionCondition.operator);
      if (!selected) {
        // Previous operator selection is not available for the new field
        // Find first available or clear it if available operator is not found
        this.decisionCondition.operator = this.getFirstAvailableOperator(this.allOperators);
      }
      this.operatorDisplayText = this.getOperatorDisplayText(this.allOperators, this.decisionCondition.operator);
      this.setDecisionStepCondition();
    }
    onDecisionOperatorChanged(change) {
      this.decisionCondition.operator = change.value;
      this.operatorDisplayText = this.getOperatorDisplayText(this.allOperators, this.decisionCondition.operator);
      this.setDecisionStepCondition();
    }
    onDecisionValueChanged(value) {
      this.decisionCondition.value = value;
      this.setDecisionStepCondition();
    }
    onDecisionPaymentFieldChanged(args) {
      const config = this.step.config;
      config.payment_type = args.value?.id;
    }
    onDecisionNowFieldChanged(args) {
      // TODO: decisionNowCondition is probably not needed - decision now should not have conditiion
      // if (!this.decisionNowCondition) {
      //     return;
      // }
      // this.decisionNowCondition.field = args.value;
      // // On field change always set default value
      // this.decisionNowCondition.value = this.sharedSvc.getDefaultValueForField(this.decisionNowCondition.field);
      // // Refresh operators availability based on the field
      // // this.sharedSvc.getAllOperatorsByField(this.decisionCondition.field);
      // this.allDecisionNowFieldOperators = this.fieldOperators[this.decisionNowCondition.field.id];
      // const selected = this.allOperators.find(x => x.name === this.decisionNowCondition.operator);
      // if (!selected) {
      //     // Previous operator selection is not available for the new field
      //     // Find first available or clear it if available operator is not found
      //     this.decisionNowCondition.operator = this.getFirstAvailableOperator(this.allDecisionNowFieldOperators);
      // }
      // this.decisionNowOperatorDisplayText = this.getOperatorDisplayText(this.allDecisionNowFieldOperators, this.decisionNowCondition.operator);
      const config = this.step.config;
      // config.datetime_field_id = this.decisionNowCondition.field.id;
      config.datetime_field_id = args.value.id;
      this.normalizeStepDecisionNowConfig(config);
      // this.setDecisionNowStepCondition();
    }
    onDecisionNowPlusMinusChanged(args) {
      const cfg = this.step.config;
      const value = args.value.id;
      const abs = Math.abs(cfg.difference);
      cfg.difference = value === "minus" /* PlusMinus.minus */ ? -abs : abs;
      this.normalizeStepDecisionNowConfig(cfg);
    }
    adjustDecisionNowPlusMinus(cfg) {
      const value = this.flowStepFields.decisionNowPlusMinus.value.selected;
      const abs = Math.abs(cfg.difference);
      cfg.difference = value.id === "minus" /* PlusMinus.minus */ ? -abs : abs;
    }
    onDecisionNowDurationChanged(seconds) {
      const cfg = this.step.config;
      cfg.difference = seconds;
      this.normalizeStepDecisionNowConfig(cfg);
      this.adjustDecisionNowPlusMinus(cfg);
    }
    onDecisionNowBeforeAfterChanged(args) {
      const cfg = this.step.config;
      const value = args.value.id;
      cfg.after = value === "after" /* BeforeOrAfter.after */;
      this.normalizeStepDecisionNowConfig(cfg);
      this.adjustDecisionNowPlusMinus(cfg);
    }
    // TODO: This is probably not needed - decision now should not have conditiion
    // onDecisionNowOperatorChanged(change: MatSelectChange) {
    //     this.decisionNowCondition.operator = change.value as FieldOperator;
    //     this.decisionNowOperatorDisplayText = this.getOperatorDisplayText(this.allDecisionNowFieldOperators, this.decisionNowCondition.operator);
    //     this.setDecisionNowStepCondition();
    // }
    // TODO: This is probably not needed - decision now should not have conditiion
    // onDecisionNowValueChanged(value: any) {
    //     this.decisionNowCondition.value = value;
    //     this.setDecisionNowStepCondition();
    // }
    // TODO: This is probably not needed - decision now should not have conditiion
    // setDecisionNowStepCondition(): void {
    //     this.step.condition = this.sharedSvc.criteriaToSearchParams([this.decisionNowCondition], this.fieldMode);
    // }
    getOperatorDisplayText(operatorWithAvailability, operatorName) {
      const currentOperator = operatorWithAvailability.find(x => x.name === operatorName);
      if (currentOperator) {
        return currentOperator.displayText;
      } else {
        return null;
      }
    }
    getFirstAvailableOperator(operatorWithAvailability) {
      const firstAvailableOperatorWithAvailability = operatorWithAvailability[0];
      if (firstAvailableOperatorWithAvailability) {
        return firstAvailableOperatorWithAvailability.name;
      } else {
        return null;
      }
    }
    onActionFieldChanged(args) {
      // TODO: Implement the same as this.countSelectFieldData in "private setCountParticipantFieldValueFieldValue"
      this.currentActionStepField = null;
      this.executeOnNextCycle(() => {
        this.currentActionStepField = args.value;
        this.step.config.field_id = this.currentActionStepField.id;
        // On field change always set default value
        this.step.config.value = this.sharedSvc.getDefaultValueForField(this.currentActionStepField);
      });
    }
    onActionValueChanged(args) {
      this.step.config.value = args.value;
    }
    onEmailTemplateChanged(args) {
      this.step.config.email_campaign_id = args.value.id;
      this.currentEmailTemplateName = this.getCurrentEmailTemplateName();
    }
    onSendGenericEmailFieldChanged(field, change, isInvalid) {
      const stepConfig = this.step.config;
      const value = change.value;
      if (field === this.sendGenericEmailData.emailTemplateField) {
        stepConfig.email_template_id = value;
      } else if (field === this.sendGenericEmailData.languageField) {
        stepConfig.language = value;
      } else if (field === this.sendGenericEmailData.fromEmailField) {
        stepConfig.from.email = value;
      } else if (field === this.sendGenericEmailData.fromNameField) {
        stepConfig.from.name = value;
      } else if (field === this.sendGenericEmailData.bounceEmailField) {
        stepConfig.bounce_email = value;
      } else if (field === this.sendGenericEmailData.replyEmailField) {
        stepConfig.reply_email = value;
      } else if (field === this.sendGenericEmailData.toEmailField) {
        stepConfig.to_email = value;
      } else if (field === this.sendGenericEmailData.subjectField) {
        stepConfig.subject = value;
      }
      this.sendGenericEmailData.invalidValueMap[field.id] = isInvalid;
    }
    onEventTemplateChanged(args) {
      const eventId = args.value.id;
      this.step.config.template_id = eventId;
      // Clear current mappings and request the fields
      this.requesterFieldToEventFieldMap = [];
      this.requestEventTemplateFields(eventId);
    }
    requestEventTemplateFields(eventId) {
      const body = {
        eventTemplateId: eventId,
        step: this.step
      };
      const msg = {
        type: "fieldsRequired" /* TemplateEventFieldsSubjectMessageType.fieldsRequired */,
        body: body
      };
      this.templateEventFieldsSubject.next(msg);
    }
    onTeamChanged(args) {
      this.step.config.team_id = args.value.id;
      this.currentTeamName = this.flowStepSvc.getNumberIdLabel(this.teams, this.step.config.team_id);
    }
    isConfigured() {
      switch (this.step.type) {
        case FlowBuilderStepType.wait:
          return this.isWaitStepConfigured();
        case FlowBuilderStepType.waitUntilField:
          return this.isWaitUntilFieldStepConfigured();
        case FlowBuilderStepType.decision:
          return this.isDecisionStepConfigured();
        case FlowBuilderStepType.decisionExternalCRM:
          return this.isDecisionExternalCRMStepConfigured();
        case FlowBuilderStepType.decisionNow:
          return this.isDecisionNowStepConfigured();
        case FlowBuilderStepType.decisionPayment:
          return this.isDecisionPaymentStepConfigured();
        case FlowBuilderStepType.advancedQuery:
          return isAdvancedQueryConditionConfigured(this.step.condition);
        case FlowBuilderStepType.stageChange:
          return !!this.step.stage_id;
        case FlowBuilderStepType.goToWorkflow:
          return !!this.step.workflow_id;
        case FlowBuilderStepType.action:
          return this.isActionStepConfigured();
        case FlowBuilderStepType.stop:
          return true;
        // always true because stop doesn't have mandatory additional properties
      }
    }
    isSetDateTimeFieldToCurrentConfigured() {
      return !!this.selectedSetDateTimeFieldToCurrent;
    }
    isSetTimeFieldToCurrentConfigured() {
      return !!this.selectedSetTimeFieldToCurrent;
    }
    isWaitStepConfigured() {
      return this.waitStepSecondsValid;
    }
    isWaitUntilFieldStepConfigured() {
      return this.waitUntilFieldStepOffsetSecondsValid && !!this.step.field_id && !!this.waitUntilFieldStepFields.find(x => x.id === this.step.field_id) && !!this.step.field_type && !!this.waitUntilFieldStepFieldType && this.waitUntilFieldStepOffsetSeconds !== '' && !isNaN(+this.waitUntilFieldStepOffsetSeconds);
    }
    isDecisionStepConfigured() {
      if (!this.decisionCondition) {
        return false;
      }
      return !!(this.decisionCondition.field && this.decisionCondition.operator);
    }
    isDecisionExternalCRMStepConfigured() {
      return !!this.step.config?.integration_id;
    }
    isDecisionNowStepConfigured() {
      // if (!this.decisionNowCondition) {
      //     return false;
      // }
      // if (!this.decisionNowCondition.field || !this.decisionNowCondition.operator) {
      //     return false;
      // }
      if (!this.isDecisionNowDifferenceValueValid) {
        return false;
      }
      const cfg = this.step.config;
      if (!cfg) {
        return false;
      }
      if (!cfg.datetime_field_id) {
        return false;
      }
      return true;
    }
    isDecisionPaymentStepConfigured() {
      const stepConfig = this.step.config;
      if (!stepConfig) {
        return false;
      }
      return !!stepConfig.payment_type;
    }
    isWebhookConfigured() {
      return !!this.step?.config?.integration_id;
    }
    isSendGenericEmailConfigured() {
      const stepConfig = this.step.config;
      const values = [stepConfig.bounce_email, stepConfig.email_template_id, stepConfig.from.email, stepConfig.from.name, stepConfig.language, stepConfig.reply_email, stepConfig.subject, stepConfig.to_email];
      if (values.some(x => this.sharedSvc.isNullOrWhitespace(x))) {
        return false;
      }
      const hasInvalidField = Object.keys(this.sendGenericEmailData.invalidValueMap).some(x => this.sendGenericEmailData.invalidValueMap[x]);
      if (hasInvalidField) {
        return false;
      }
      return true;
    }
    isSendEmailToApproverConfigured() {
      const config = this.step.config;
      return !!config.approver_field_id && !!config.email_campaign_id;
    }
    isSetReferenceNumberConfigured() {
      return !!this.step.config.field_id;
    }
    isSendObjectConfigured() {
      return !!this.step?.config?.integration_id;
    }
    isCountSelectFieldConfigured() {
      const config = this.step?.config;
      if (!config) {
        return false;
      }
      return !!(config.number_field_id && config.select_field_value && config.select_field_id);
    }
    isCopyEventDatesConfigured() {
      const config = this.step?.config;
      if (!config) {
        return false;
      }
      return !!(config.end_date_field_id && config.start_date_field_id);
    }
    isCopyEventTextFieldConfigured() {
      const config = this.step?.config;
      if (!config) {
        return false;
      }
      return !!(config.text_field_id && config.event_field_id);
    }
    isMessageToContactConfigured() {
      return this.isMessageToContactOrParticipantConfigured();
    }
    isMessageToParticipantConfigured() {
      return this.isMessageToContactOrParticipantConfigured();
    }
    isSendMessateToUserConfigured() {
      const config = this.step.config;
      return !!(config.integration_id && config.message && config.user_ids.length > 0);
    }
    isAddContactToEventConfigured() {
      const config = this.step.config;
      return !!config.event_id;
    }
    isGenerateCertificateConfigured() {
      const config = this.step.config;
      return !!(config.document_id && config.document_field_id);
    }
    isUpdateContactToOrganizationConfigured() {
      const config = this.step.config;
      return config.fields?.length > 0 && config.fields.every(item => {
        return item.contact_field_id && item.organization_field_id;
      });
    }
    isMessageToContactOrParticipantConfigured() {
      const config = this.step.config;
      const integrationSubType = this.getIntegration(config.integration_id)?.subtype;
      switch (integrationSubType) {
        case 'messagebird':
        case 'zapier':
          return this.isMessageToContactOrParticipantWithSmsConfigured(config);
        case 'fcm':
          return this.isMessageToContactOrParticipantWithPushConfigured(config);
        default:
          return false;
      }
    }
    isMessageToContactOrParticipantWithSmsConfigured(config) {
      if (config.email_id && config.first_name_id && config.integration_id && config.last_name_id && config.message && config.number_id) {
        return true;
      }
      return false;
    }
    isMessageToContactOrParticipantWithPushConfigured(config) {
      if (config.integration_id && config.message && config.subject && config.eventAppComponent?.component) {
        const entityListField = this.getMessageToContactOrParticipantEventAppEntityField(config.eventAppComponent.component);
        const eventAppComponentEntityId = entityListField?.value?.selected;
        return entityListField ? eventAppComponentEntityId : true;
      }
      return false;
    }
    getFieldOptions(field) {
      if (!field) {
        return null;
      }
      return this.sharedSvc.getFieldOptions(field.id, this.fieldsOptions);
    }
    isActionStepConfigured() {
      if (!this.step.config || !this.step.config.action) {
        return false;
      }
      const config = this.step.config;
      const action = this.step.config.action;
      if (action === FlowBuilderStepActionType.setField) {
        const field = this.fields ? this.fields.find(x => x.id === config.field_id) : null;
        return !!field;
      } else if (action === FlowBuilderStepActionType.email) {
        const emailTemplate = this.emailTemplates ? this.emailTemplates.find(x => x.id === config.email_campaign_id) : null;
        return !!emailTemplate;
      } else if (action === FlowBuilderStepActionType.addTeam) {
        const team = this.teams ? this.teams.find(x => x.id === config.team_id) : null;
        return !!team;
      } else if (action === FlowBuilderStepActionType.removeTeam) {
        const team = this.teams ? this.teams.find(x => x.id === config.team_id) : null;
        return !!team;
      } else if (action === FlowBuilderStepActionType.generalEmail) {
        const valuesSelected = config.email_campaign_id && config.language && config.to_email;
        return !!(valuesSelected && this.isGeneralEmailValueValid);
      } else if (action === FlowBuilderStepActionType.emailFromField || action === FlowBuilderStepActionType.emailFromEventField) {
        const valuesSelected = config.email_campaign_id && config.language && config.field.id;
        return !!(valuesSelected && this.isEmailFromFieldValueValid);
      } else if (action === FlowBuilderStepActionType.createEvent) {
        return this.flowStepSvc.isCreateEventMappingConfigured(config, this.requesterFieldToEventFieldMap);
      } else if (action === FlowBuilderStepActionType.setDateTimeFieldToCurrent) {
        return this.isSetDateTimeFieldToCurrentConfigured();
      } else if (action === FlowBuilderStepActionType.setRelativeDateTime) {
        return this.isSetDateTimeFieldToCurrentConfigured();
      } else if (action === FlowBuilderStepActionType.setRelativeTime) {
        return this.isSetTimeFieldToCurrentConfigured();
      } else if (action === FlowBuilderStepActionType.sendWebhook) {
        return this.isWebhookConfigured();
      } else if (action === FlowBuilderStepActionType.sendGenericEmail) {
        return this.isSendGenericEmailConfigured();
      } else if (action === FlowBuilderStepActionType.sendEmailToApprover) {
        return this.isSendEmailToApproverConfigured();
      } else if (action === FlowBuilderStepActionType.setReferenceNumber) {
        return this.isSetReferenceNumberConfigured();
      } else if (action === FlowBuilderStepActionType.sendObject) {
        return this.isSendObjectConfigured();
      } else if (action === FlowBuilderStepActionType.countSelectField) {
        return this.isCountSelectFieldConfigured();
      } else if (action === FlowBuilderStepActionType.copyEventDates) {
        return this.isCopyEventDatesConfigured();
      } else if (action === FlowBuilderStepActionType.copyEventTextField) {
        return this.isCopyEventTextFieldConfigured();
      } else if (action === FlowBuilderStepActionType.messageToContact) {
        return this.isMessageToContactConfigured();
      } else if (action === FlowBuilderStepActionType.messageToParticipant) {
        return this.isMessageToParticipantConfigured();
      } else if (action === FlowBuilderStepActionType.sendMessageToUser) {
        return this.isSendMessateToUserConfigured();
      } else if (action === FlowBuilderStepActionType.addContactToEvent) {
        return this.isAddContactToEventConfigured();
      } else if (action === FlowBuilderStepActionType.generateCertificate) {
        return this.isGenerateCertificateConfigured();
      } else if (action === FlowBuilderStepActionType.updateContactToOrganization) {
        return this.isUpdateContactToOrganizationConfigured();
      }
    }
    onGeneralEmailValueChanged(value) {
      this.step.config.to_email = value.value;
      this.isGeneralEmailValueValid = !!value;
    }
    onGeneralEmailInvalidValueSet() {
      this.isGeneralEmailValueValid = false;
    }
    onEmailFromFieldValueChanged(value) {
      this.step.config.field.id = value.value;
      this.isEmailFromFieldValueValid = true;
    }
    onDecisionNowDifferenceValueChanged(value) {
      this.step.config.difference = +value.value;
      this.isDecisionNowDifferenceValueValid = true;
    }
    onDecisionNowDifferenceInvalidValueSet() {
      this.isDecisionNowDifferenceValueValid = false;
    }
    executeOnNextCycle(fn) {
      window.setTimeout(() => fn());
    }
    ngOnDestroy() {
      this.destroyed$.next();
      this.destroyed$.complete();
    }
    getIntegrationsBasedOnStepAction() {
      return this.sharedSvc.sortAlphabetically(filterIntegrationsBasedOnStepAction(this.step?.config?.action, this.integrations), integration => integration.name);
    }
    isStepTypeDecision(stepType) {
      return stepType === this.stepType.decision || stepType === this.stepType.decisionExternalCRM || stepType === this.stepType.decisionNow || stepType === this.stepType.decisionPayment || stepType === this.stepType.advancedQuery;
    }
    static {
      this.ɵfac = function AzavistaFlowStepComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowStepComponent)(i0.ɵɵdirectiveInject(AzavistaFlowBuilderService), i0.ɵɵdirectiveInject(i2.AzavistaSharedService), i0.ɵɵdirectiveInject(AzavistaFlowStepService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFlowStepComponent,
        selectors: [["azavista-flow-step"]],
        viewQuery: function AzavistaFlowStepComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.offsetSecondsIsPositiveEl = _t.first);
          }
        },
        inputs: {
          step: "step",
          editMode: "editMode",
          isPanelExpanded: "isPanelExpanded",
          stages: "stages",
          workflows: "workflows",
          entityTypeFields: "entityTypeFields",
          additionalEntityFields: "additionalEntityFields",
          sortStepFields: "sortStepFields",
          globalProcessEntityType: "globalProcessEntityType",
          fieldsOptions: "fieldsOptions",
          emailTemplates: "emailTemplates",
          deleteDisabled: "deleteDisabled",
          teams: "teams",
          emailCampaigns: "emailCampaigns",
          eventActivities: "eventActivities",
          eventAppPages: "eventAppPages",
          integrations: "integrations",
          users: "users",
          events: "events",
          languages: "languages",
          templateEvents: "templateEvents",
          templateEventFieldsSubject: "templateEventFieldsSubject",
          isGlobalParticipant: "isGlobalParticipant",
          docxDocuments: "docxDocuments",
          documentFields: "documentFields"
        },
        outputs: {
          delete: "delete"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 21,
        vars: 33,
        consts: [["baseElementRef", ""], ["offsetSecondsIsPositiveEl", ""], [1, "base-element", "azavista-flow-step-component", "mat-elevation-z0", 3, "expandedChange", "expanded"], [1, "header-container", "aza-cmp-flex-row"], [1, "base-element-label", "mat-elevation-z1"], [4, "ngIf"], ["class", "main-condition", 4, "ngIf"], ["mat-icon-button", "", 3, "click", 4, "ngIf"], ["translate", ""], [1, "main-condition"], [3, "canEdit", "fullWidth", "value", "editMode", "field", "options"], ["mat-icon-button", "", 3, "click"], [3, "field", "value", "showLabelInReadonlyMode", "editMode", "canEdit", "fullWidth", "label", 4, "ngIf"], [3, "field", "value", "showLabelInReadonlyMode", "editMode", "canEdit", "fullWidth", "label"], [3, "field", "value", "editMode", "canEdit", "fullWidth", "label", "valueChanged", 4, "ngIf"], [3, "valueChanged", "field", "value", "editMode", "canEdit", "fullWidth", "label"], [1, "aza-cmp-full-width"], ["matInput", "", "disabled", "", 3, "value", "placeholder"], [1, "aza-cmp-full-width", "aza-readonly-form-input-field"], ["matInput", "", "readonly", "", 3, "value", "placeholder"], [3, "selectionChange", "valueChange", "value", "placeholder"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [3, "canEdit", "fullWidth", "editMode", "options", "field", "value", "label", "showLabelInReadonlyMode", "valueChanged", "invalidValueSet", 4, "ngIf"], [3, "valueChanged", "invalidValueSet", "canEdit", "fullWidth", "editMode", "options", "field", "value", "label", "showLabelInReadonlyMode"], [3, "field", "value", "canEdit", "label", "fullWidth", "editMode", "showLabelInReadonlyMode"], [3, "checked", "disabled"], [3, "valueChanged", "field", "value", "canEdit", "label", "fullWidth", "editMode", "showLabelInReadonlyMode"], ["color", "primary", 3, "ngModelChange", "ngModel"], [1, "aza-flex-row", "aza-cmp-flex-wrap"], [3, "valueChanged", "field", "value", "editMode", "canEdit", "label"], [3, "valueChanged", "field", "value", "editMode", "canEdit"], [3, "valueChanged", "seconds", "editMode"], [1, "aza-cmp-min-small-width"], [3, "valueChanged", "field", "value", "fullWidth", "editMode", "canEdit", "label"], ["color", "primary", 3, "click", 4, "ngIf"], [3, "filterData", "criteriaTree"], ["color", "primary", 3, "click"], [3, "valueChanged", "field", "value", "editMode", "fullWidth", "label"], [3, "canEdit", "fullWidth", "editMode", "field", "value", "label", "showLabelInReadonlyMode", "options", "valueChanged", 4, "ngIf"], [3, "valueChanged", "canEdit", "fullWidth", "editMode", "field", "value", "label", "showLabelInReadonlyMode", "options"], [3, "valueChanged", "field", "value", "fullWidth", "canEdit", "editMode", "label"], [3, "valueChanged", "field", "value", "canEdit", "editMode", "fullWidth", "label"], [3, "valueChanged", "invalidValueSet", "field", "label", "value", "editMode", "fullWidth", "options"], [3, "valueChanged", "field", "label", "value", "editMode", "fullWidth", "options"], [1, "create-event-mapping", "aza-cmp-grid"], ["translate", "", 1, "field-mapping-header"], [4, "ngFor", "ngForOf"], ["translate", "", 1, "requester-field-header"], ["translate", "", 1, "event-field-header"], [1, "aza-cmp-margin-block", 3, "click"], ["mat-button", ""], [3, "selectionChange", "ngModelChange", "ngModel"], [1, "aza-cmp-flex-row"], [1, "aza-cmp-flex-grow"], ["class", "aza-cmp-full-width", 4, "ngIf"], [3, "valueChanged", "label", "editMode", "seconds"], [3, "valueChanged", "field", "value", "fullWidth", "canEdit", "editMode", "label", "showLabelInReadonlyMode"], [3, "selectionChange", "value"], ["matInput", "", "readonly", "", 3, "value"], [3, "field", "value", "label", "fullWidth", "editMode", "showLabelInReadonlyMode"], [3, "valueChanged", "invalidValueSet", "field", "value", "label", "fullWidth", "editMode"], [3, "field", "label", "canEdit", "editMode", "value", "fullWidth", "valueChanged", "invalidValueSet", 4, "ngIf"], [3, "valueChanged", "invalidValueSet", "field", "label", "canEdit", "editMode", "value", "fullWidth"], [3, "valueChanged", "field", "value", "label", "fullWidth", "canEdit", "showLabelInReadonlyMode"], [3, "field", "value", "canEdit", "label", "fullWidth", "editMode", "showLabelInReadonlyMode", 4, "ngIf"], [3, "valueChanged", "field", "value", "canEdit", "label", "fullWidth", "editMode"], [3, "field", "value", "canEdit", "label", "fullWidth", "editMode", "valueChanged", 4, "ngIf"], [3, "valueChanged", "field", "value", "canEdit", "options", "label", "fullWidth", "editMode"], [3, "stepConfigChange", "readonly", "sourceFields", "targetFields", "fieldMatching", "stepConfig", "sourceColumnConfig", "targetColumnConfig"], [3, "valueChanged", "invalidValueSet", "field", "value", "canEdit", "label", "fullWidth", "editMode", "showLabelInReadonlyMode"], [3, "field", "value", "fullWidth", "canEdit", "editMode", "label", "valueChanged", 4, "ngIf"], [3, "ngModelChange", "selectionChange", "ngModel"], ["value", "after"], ["value", "before"]],
        template: function AzavistaFlowStepComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "mat-expansion-panel", 2, 0);
            i0.ɵɵpipe(2, "apply");
            i0.ɵɵtwoWayListener("expandedChange", function AzavistaFlowStepComponent_Template_mat_expansion_panel_expandedChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.isPanelExpanded, $event) || (ctx.isPanelExpanded = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementStart(3, "mat-expansion-panel-header")(4, "div", 3)(5, "h5", 4);
            i0.ɵɵtemplate(6, AzavistaFlowStepComponent_ng_container_6_Template, 3, 0, "ng-container", 5)(7, AzavistaFlowStepComponent_ng_container_7_Template, 3, 0, "ng-container", 5)(8, AzavistaFlowStepComponent_ng_container_8_Template, 3, 0, "ng-container", 5)(9, AzavistaFlowStepComponent_ng_container_9_Template, 3, 0, "ng-container", 5)(10, AzavistaFlowStepComponent_ng_container_10_Template, 3, 0, "ng-container", 5);
            i0.ɵɵpipe(11, "apply");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, AzavistaFlowStepComponent_div_12_Template, 10, 9, "div", 6)(13, AzavistaFlowStepComponent_button_13_Template, 3, 0, "button", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div");
            i0.ɵɵtemplate(15, AzavistaFlowStepComponent_ng_container_15_Template, 8, 7, "ng-container", 5)(16, AzavistaFlowStepComponent_ng_container_16_Template, 29, 31, "ng-container", 5)(17, AzavistaFlowStepComponent_ng_container_17_Template, 5, 11, "ng-container", 5)(18, AzavistaFlowStepComponent_ng_container_18_Template, 3, 2, "ng-container", 5)(19, AzavistaFlowStepComponent_ng_container_19_Template, 3, 2, "ng-container", 5)(20, AzavistaFlowStepComponent_ng_container_20_Template, 3, 2, "ng-container", 5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const baseElementRef_r68 = i0.ɵɵreference(1);
            i0.ɵɵclassProp("query-type", ctx.isStepTypeDecision(ctx.step.type))("action-type", ctx.step.type === ctx.stepType.action)("time-type", ctx.step.type === ctx.stepType.wait || ctx.step.type === ctx.stepType.waitUntilField)("finish-type", ctx.step.type === ctx.stepType.stageChange || i0.ɵɵpipeBind2(2, 27, ctx.step.type, ctx.isFinishStep))("not-configured", !ctx.isConfigured());
            i0.ɵɵtwoWayProperty("expanded", ctx.isPanelExpanded);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", ctx.step.type === ctx.stepType.action);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isStepTypeDecision(ctx.step.type));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.step.type === ctx.stepType.wait);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.step.type === ctx.stepType.waitUntilField);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.step.type === ctx.stepType.stageChange || i0.ɵɵpipeBind2(11, 30, ctx.step.type, ctx.isFinishStep));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !baseElementRef_r68.expanded);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", baseElementRef_r68.expanded && ctx.editMode && !ctx.deleteDisabled);
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("flow-step-container flow-step-container--", ctx.step.type, " aza-cmp-min-medium-width");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isStepTypeDecision(ctx.step.type));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.step.type === ctx.stepType.action);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.step.type === ctx.stepType.wait);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.step.type === ctx.stepType.waitUntilField);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.step.type === ctx.stepType.stageChange);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.step.type === ctx.stepType.goToWorkflow);
          }
        },
        dependencies: [i4.NgForOf, i4.NgIf, i5$1.NgControlStatus, i5$1.NgModel, i6.TranslateDirective, i4$1.AzavistaInputFieldComponent, i5.MatIcon, i9.MatCheckbox, i10.MatInput, i10.MatFormField, i11.MatButton, i11.MatIconButton, i12.MatSelect, i12.MatOption, i6$1.AzavistaButtonComponent, i2$1.AzavistaFilterCriteriaTreeNodesComponent, i15.MatExpansionPanel, i15.MatExpansionPanelHeader, i16.AzavistaDurationComponent, AzavistaFlowStepFieldMappingItemListComponent, i6.TranslatePipe, i2.ApplyFunctionPipe],
        styles: [".base-element[_ngcontent-%COMP%]{border-radius:4px;padding:4px;-webkit-user-select:none;user-select:none}.base-element-label[_ngcontent-%COMP%]{text-align:center;border-radius:4px;padding:8px;margin:0 10px 0 0}.query-type[_ngcontent-%COMP%]{background-color:#daeaf3;border:1px solid #006db0}.query-type[_ngcontent-%COMP%]   .base-element-label[_ngcontent-%COMP%]{background-color:#006db0;color:#fff}.query-type[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#006db0}.action-type[_ngcontent-%COMP%]{background-color:#dbf2c9;border:1px solid #75A935}.action-type[_ngcontent-%COMP%]   .base-element-label[_ngcontent-%COMP%]{background-color:#75a935;color:#fff}.action-type[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#75a935}.time-type[_ngcontent-%COMP%]{background-color:#f6facc;border:1px solid #C2AC0C}.time-type[_ngcontent-%COMP%]   .base-element-label[_ngcontent-%COMP%]{background-color:#c2ac0c;color:#fff}.time-type[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#c2ac0c}.finish-type[_ngcontent-%COMP%]{background-color:#f3e5f5;border:1px solid #9c64a6}.finish-type[_ngcontent-%COMP%]   .base-element-label[_ngcontent-%COMP%]{background-color:#9c64a6;color:#fff}.finish-type[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#9c64a6}.header-container[_ngcontent-%COMP%]{place-content:center flex-start}.not-configured.base-element[_ngcontent-%COMP%]{background-color:#ddd;border:1px solid #595b5a}.not-configured.base-element[_ngcontent-%COMP%]   .base-element-label[_ngcontent-%COMP%]{background-color:#595b5a;color:#ddd}.not-configured.base-element[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#595b5a}.create-event-mapping[_ngcontent-%COMP%]{grid-template-columns:1fr 1fr 0fr}.field-mapping-header[_ngcontent-%COMP%]{grid-column:1/4}", ".flow-step-container--advanced-query[_ngcontent-%COMP%]    >azavista-filter-criteria-tree-nodes{margin-top:1em;max-height:300px;overflow-y:auto}.flow-step-container--advanced-query[_ngcontent-%COMP%]     azavista-filter-criteria-tree-nodes{display:flex;flex-direction:column;gap:0em;padding:0 1em}.flow-step-container--advanced-query[_ngcontent-%COMP%]     azavista-filter-criteria-tree-nodes azavista-filter-criteria-tree-nodes{background-color:#f0f0f0b3;display:block}.flow-step-container--advanced-query[_ngcontent-%COMP%]     azavista-filter-criteria-tree-nodes .azavista-input-field-filter-value{display:flex;align-items:baseline}.flow-step-container--advanced-query[_ngcontent-%COMP%]     azavista-filter-criteria-tree-nodes .azavista-input-field-filter-value:before, .flow-step-container--advanced-query[_ngcontent-%COMP%]     azavista-filter-criteria-tree-nodes .azavista-input-field-filter-value:after{display:inline;content:'\"'}.flow-step-container--advanced-query[_ngcontent-%COMP%]     .filter-tree__tree-nodes__operator-wrapper{height:2em;display:flex;align-items:center}.flow-step-container--advanced-query[_ngcontent-%COMP%]     .filter-tree__tree-nodes__operator{padding:0!important}.flow-step-container--advanced-query[_ngcontent-%COMP%]     .filter-tree__horizonal-stack.filter-tree__tree-nodes__parent-operator{display:flex;align-items:center;height:30px}.flow-step-container--advanced-query[_ngcontent-%COMP%]     .filter-tree__horizonal-stack{display:flex;align-items:center;flex-wrap:wrap;gap:0px 1em;padding:2px 0}  .filter-criteria-tree-dialog.process-builder__advanced-query-dialog azavista-filter-criteria-tree>azavista-input-field{display:none}"]
      });
    }
  }
  return AzavistaFlowStepComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const filterIntegrationsBasedOnStepAction = (stepAction, integrations) => {
  switch (stepAction) {
    case FlowBuilderStepActionType.sendMessageToUser:
    case FlowBuilderStepActionType.messageToContact:
      return integrations?.filter(x => x.type === 'messaging-gateway' && x.subtype === 'messagebird');
    case FlowBuilderStepActionType.messageToParticipant:
      {
        return integrations?.filter(x => x.type === 'messaging-gateway' && (x.subtype === 'messagebird' || x.subtype === 'fcm' || x.subtype === 'zapier'));
      }
    case FlowBuilderStepActionType.sendWebhook:
      return integrations?.filter(x => x.type === 'webhook');
    case FlowBuilderStepActionType.sendObject:
      return integrations?.filter(x => x.type === 'external-crm');
    default:
      return integrations;
  }
};
const IMessageToContactOrParticipantPropertyByIntegrationSubType = {
  messagebird: ['integration', 'message', 'number'],
  fcm: ['integration', 'message', 'event_app_module', 'event_app_entity_id', 'subject'],
  zapier: ['integration', 'message', 'number']
};
let AzavistaFlowBuilderComponent = /*#__PURE__*/(() => {
  class AzavistaFlowBuilderComponent {
    constructor(matDialog, sharedSvc, flowBuilderSvc) {
      this.matDialog = matDialog;
      this.sharedSvc = sharedSvc;
      this.flowBuilderSvc = flowBuilderSvc;
      this.canEditSteps = false;
      this.canEditStatus = false;
      /** @default true */
      this.sortStepFields = true;
      /**
       * All active event's activities
       */
      this.eventActivities = [];
      /**
       * All published event's pages with type=event_app
       */
      this.eventAppPages = [];
      this.changesSaved = new EventEmitter(); // Step[] from azavista-servicelib
      this.notConfigured = new EventEmitter();
      this.flowPausedChanged = new EventEmitter();
      this.flowInterrupted = new EventEmitter();
      this.dls = [];
      this.editMode = false;
      this.editStepsDisabled = false;
      this.stepType = FlowBuilderStepType;
      this.showAddActionStep = false;
      this.showAddDecisionStep = false;
      this.showAddWaitStep = false;
      this.showAddStageChangeStep = false;
      this.isHavingNestedStep = type => {
        return type === FlowBuilderStepType.decision || type === FlowBuilderStepType.decisionExternalCRM || type === FlowBuilderStepType.decisionNow || type === FlowBuilderStepType.decisionPayment || type === FlowBuilderStepType.advancedQuery;
      };
    }
    ngAfterViewInit() {
      this.setDropListIds();
    }
    ngOnChanges(simpleChanges) {
      if (simpleChanges.steps && simpleChanges.steps.currentValue) {
        this.setInternalStepsCopy();
      }
      if (simpleChanges.addNewConfig && simpleChanges.addNewConfig.currentValue) {
        this.setAddNewConfigData();
      }
      if (simpleChanges.canEditStepsAcl) {
        this.editStepsDisabled = !this.sharedSvc.hasAccess(this.canEditStepsAcl);
      }
    }
    toggleFlowPaused() {
      this.flowPausedChanged.next(!this.flowPaused);
    }
    interruptFlow() {
      this.flowInterrupted.emit();
    }
    setInternalStepsCopy() {
      // Deep copy
      this.internalStepsCopy = this.sharedSvc.clone(this.steps);
    }
    setAddNewConfigData() {
      if (this.addNewConfig && this.addNewConfig.availableStepTypes) {
        const ast = this.addNewConfig.availableStepTypes;
        this.showAddActionStep = ast.includes(FlowBuilderStepType.action);
        this.showAddDecisionStep = ast.includes(FlowBuilderStepType.decision);
        this.showAddWaitStep = ast.includes(FlowBuilderStepType.wait);
        this.showAddStageChangeStep = ast.includes(FlowBuilderStepType.stageChange);
        this.enabledStepTypes = {};
        for (const stepType of ast) {
          this.enabledStepTypes[stepType] = true;
        }
      } else {
        this.enabledStepTypes = {};
        this.showAddActionStep = false;
        this.showAddDecisionStep = false;
        this.showAddWaitStep = false;
        this.showAddStageChangeStep = false;
      }
    }
    onEditModeChanged(ev) {
      this.editMode = ev.checked;
      if (!this.editMode) {
        // Clear edit mode data if edit mode is turned off
        this.cancelChanges();
      }
    }
    cancelChanges() {
      this.setInternalStepsCopy();
      this.editMode = false;
    }
    onChangesSaved() {
      const notConfigured = this.stepComponents && this.stepComponents.some(sc => !sc.isConfigured());
      if (notConfigured) {
        this.notConfigured.next();
      } else {
        const copy = this.sharedSvc.clone(this.internalStepsCopy);
        this.changesSaved.next(copy);
        this.editMode = false;
      }
    }
    setDropListIds() {
      let ldls = [];
      this.dlq.forEach(dl => {
        ldls.push(dl);
      });
      ldls = ldls.reverse();
      asapScheduler.schedule(() => {
        this.dls = ldls;
      });
    }
    onDragEntered(event) {
      this.enforceDragToSelf(event.container);
    }
    onDragStarted(event) {
      this.enforceDragToSelf(event.source.dropContainer);
    }
    enforceDragToSelf(dl) {
      const siblings = dl.connectedTo;
      const ref = dl._dropListRef;
      asapScheduler.schedule(() => {
        ref.connectedTo(siblings.map(list => list._dropListRef));
      });
    }
    elementDrop(event) {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        this.setDropListIdsAfterRendered();
      }
    }
    setDropListIdsAfterRendered() {
      setTimeout(() => this.setDropListIds());
    }
    onDeleteStepClicked(elements, index) {
      elements.splice(index, 1);
    }
    onAddStepClicked(type) {
      if (type === FlowBuilderStepType.action || type === FlowBuilderStepType.decision || type === FlowBuilderStepType.stageChange || type === FlowBuilderStepType.wait) {
        this.openAddStepDialog(type);
      } else {
        this.addStep(type);
      }
    }
    openAddStepDialog(type) {
      this.matDialog.open(AzavistaFlowStepAddNewComponent, {
        data: {
          type: type,
          addNewConfig: this.addNewConfig
        },
        width: '400px'
      }).afterClosed().subscribe(stepData => {
        if (stepData) {
          this.addStep(type, stepData);
        }
      });
    }
    addStep(stepType, stepData) {
      const {
        newStep,
        type
      } = this.flowBuilderSvc.getNewStepInitialValue(stepType, stepData);
      this.internalStepsCopy.push(newStep);
      if (type === FlowBuilderStepType.decision || type === FlowBuilderStepType.advancedQuery) {
        this.setDropListIdsAfterRendered();
      }
    }
    static {
      this.ɵfac = function AzavistaFlowBuilderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowBuilderComponent)(i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i2.AzavistaSharedService), i0.ɵɵdirectiveInject(AzavistaFlowBuilderService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFlowBuilderComponent,
        selectors: [["azavista-flow-builder"]],
        viewQuery: function AzavistaFlowBuilderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(AzavistaFlowStepComponent, 5);
            i0.ɵɵviewQuery(CdkDropList, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stepComponents = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dlq = _t);
          }
        },
        inputs: {
          canEditStepsAcl: "canEditStepsAcl",
          canEditPausedAcl: "canEditPausedAcl",
          canInterruptAcl: "canInterruptAcl",
          steps: "steps",
          title: "title",
          canEditSteps: "canEditSteps",
          canEditStatus: "canEditStatus",
          addNewConfig: "addNewConfig",
          globalProcessEntityType: "globalProcessEntityType",
          stages: "stages",
          workflows: "workflows",
          fields: "fields",
          sortStepFields: "sortStepFields",
          additionalFields: "additionalFields",
          fieldsOptions: "fieldsOptions",
          emailTemplates: "emailTemplates",
          eventActivities: "eventActivities",
          eventAppPages: "eventAppPages",
          teams: "teams",
          users: "users",
          events: "events",
          emailCampaigns: "emailCampaigns",
          integrations: "integrations",
          languages: "languages",
          flowPaused: "flowPaused",
          templateEvents: "templateEvents",
          templateEventFieldsSubject: "templateEventFieldsSubject",
          isGlobalParticipant: "isGlobalParticipant",
          docxDocuments: "docxDocuments",
          documentFields: "documentFields"
        },
        outputs: {
          changesSaved: "changesSaved",
          notConfigured: "notConfigured",
          flowPausedChanged: "flowPausedChanged",
          flowInterrupted: "flowInterrupted"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 15,
        vars: 9,
        consts: [["recursiveLevel", ""], ["triggerMenu", "matMenu"], [1, "edit-mode-controls-container"], [1, "flow-builder-title"], [1, "edit-mode-container", "aza-cmp-flex-row", "aza-cmp-content-center"], ["class", "edit-mode-controls aza-cmp-flex-row", 4, "ngIf"], ["class", "edit-mode-separator", 4, "ngIf"], ["class", "process-controls aza-cmp-flex-row", 4, "ngIf"], [1, "trigger-container", "aza-cmp-flex-column", "aza-cmp-half-gap", "aza-cmp-half-padding", "aza-cmp-rounded-border"], ["translate", "", 1, "trigger-label", "aza-cmp-flex-row", "aza-cmp-content-center", "aza-cmp-no-margin"], [1, "steps-container", "aza-cmp-flex-row", "aza-cmp-content-center"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngIf"], [1, "edit-mode-controls", "aza-cmp-flex-row"], ["color", "primary", 1, "edit-mode-toggle", 3, "change", "ngModelChange", "ngModel", "disabled"], ["translate", ""], ["color", "primary", "class", "edit-mode-cancel-button", 3, "click", 4, "ngIf"], ["color", "primary", "class", "edit-mode-save-button", 3, "click", 4, "ngIf"], ["color", "primary", 1, "edit-mode-cancel-button", 3, "click"], ["color", "primary", 1, "edit-mode-save-button", 3, "click"], [1, "edit-mode-separator"], [1, "process-controls", "aza-cmp-flex-row"], [1, "status-chip", 3, "ngClass"], ["class", "status-chip-text", 4, "ngIf"], ["color", "primary", 3, "acl", "click", 4, "ngIf"], ["color", "warn", 3, "acl", "click", 4, "ngIf"], ["mat-icon-button", "", 3, "matMenuTriggerFor"], ["mat-menu-item", ""], [3, "click", "acl"], ["matPrefix", "", "color", "primary"], [1, "status-chip-text"], ["color", "primary", 3, "click", "acl"], ["color", "warn", 3, "click", "acl"], [1, "add-trigger-buttons-divider"], [1, "add-trigger-buttons", "aza-cmp-flex-row", "aza-cmp-no-gap", "aza-cmp-content-center"], ["mat-icon-button", "", 3, "click", 4, "ngIf"], ["mat-icon-button", "", 3, "click"], [1, "add-action-button"], [1, "add-query-button"], [1, "add-time-button"], [1, "add-finish-button"], ["cdkDropList", "", 1, "droplist-container", "aza-cmp-flex-column", "aza-cmp-half-gap", 3, "cdkDropListDropped", "cdkDropListData", "cdkDropListDisabled", "cdkDropListConnectedTo", "ngClass"], ["cdkDrag", "", "class", "trigger-base-element-container", 3, "cdkDragDisabled", "cdkDragEntered", "cdkDragStarted", 4, "ngFor", "ngForOf"], ["cdkDrag", "", 1, "trigger-base-element-container", 3, "cdkDragEntered", "cdkDragStarted", "cdkDragDisabled"], [3, "delete", "step", "editMode", "stages", "workflows", "entityTypeFields", "additionalEntityFields", "sortStepFields", "globalProcessEntityType", "emailTemplates", "teams", "eventActivities", "eventAppPages", "emailCampaigns", "integrations", "languages", "fieldsOptions", "templateEvents", "templateEventFieldsSubject", "deleteDisabled", "isGlobalParticipant", "docxDocuments", "documentFields", "users", "events"]],
        template: function AzavistaFlowBuilderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2)(1, "h2", 3);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 4);
            i0.ɵɵtemplate(4, AzavistaFlowBuilderComponent_div_4_Template, 6, 4, "div", 5)(5, AzavistaFlowBuilderComponent_div_5_Template, 1, 0, "div", 6)(6, AzavistaFlowBuilderComponent_div_6_Template, 18, 15, "div", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 8)(8, "h3", 9);
            i0.ɵɵtext(9, "TRIGGER");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 10);
            i0.ɵɵtemplate(11, AzavistaFlowBuilderComponent_ng_template_11_Template, 0, 0, "ng-template", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, AzavistaFlowBuilderComponent_ng_container_12_Template, 7, 4, "ng-container", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, AzavistaFlowBuilderComponent_ng_template_13_Template, 3, 12, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const recursiveLevel_r19 = i0.ɵɵreference(14);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.canEditSteps);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.canEditSteps && ctx.canEditStatus);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.canEditStatus);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngTemplateOutlet", recursiveLevel_r19)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c3, ctx.internalStepsCopy));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.editMode && (ctx.addNewConfig == null ? null : ctx.addNewConfig.availableStepTypes == null ? null : ctx.addNewConfig.availableStepTypes.length) > 0);
          }
        },
        dependencies: [i4.NgClass, i4.NgForOf, i4.NgIf, i4.NgTemplateOutlet, i5$1.NgControlStatus, i5$1.NgModel, i6.TranslateDirective, i5.MatIcon, i10.MatPrefix, i11.MatIconButton, i10$1.MatMenu, i10$1.MatMenuItem, i10$1.MatMenuTrigger, i6$1.AzavistaButtonComponent, i6$1.AzavistaFlatButtonComponent, i12$1.CdkDropList, i12$1.CdkDrag, i13.MatDivider, i7.MatChip, i7.MatChipSet, i15$1.MatSlideToggle, AzavistaFlowStepComponent, i4.UpperCasePipe, i6.TranslatePipe, i2.ApplyFunctionPipe],
        styles: [".edit-mode-separator[_ngcontent-%COMP%]{width:1px;height:36px;background-color:#595b5a}.status-chip-text[_ngcontent-%COMP%]{color:#fff}.trigger-container[_ngcontent-%COMP%]{background-color:#f2d4c93b;border:1px solid #B04300}.add-query-button[_ngcontent-%COMP%]{color:#006db0!important}.add-action-button[_ngcontent-%COMP%]{color:#75a935!important}.add-time-button[_ngcontent-%COMP%]{color:#c2ac0c!important}.add-finish-button[_ngcontent-%COMP%]{color:#9c64a6!important}.cdk-drag-preview[_ngcontent-%COMP%]{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:.3}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.drag-container[_ngcontent-%COMP%]   .cdk-drop-list-dragging[_ngcontent-%COMP%]   .drag-item[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.query-droplist-container[_ngcontent-%COMP%]{min-height:120px;margin-bottom:-120px}.cdk-drop-list-dragging[_ngcontent-%COMP%]   .query-droplist-container[_ngcontent-%COMP%], .cdk-drop-list-receiving[_ngcontent-%COMP%]   .query-droplist-container[_ngcontent-%COMP%]{margin-bottom:0}"]
      });
    }
  }
  return AzavistaFlowBuilderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFlowBuilderModule = /*#__PURE__*/(() => {
  class AzavistaFlowBuilderModule {
    static {
      this.ɵfac = function AzavistaFlowBuilderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlowBuilderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaFlowBuilderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AzavistaSharedModule, AzavistaInputFieldModule, AzavistaButtonModule, AzavistaFilterCriteriaTreeModule, DragDropModule, MatDividerModule, MatSelectModule, MatExpansionModule, MatIconModule, MatButtonModule, MatFormFieldModule, MatTooltipModule, MatInputModule, MatChipsModule, MatSlideToggleModule, MatDialogModule, AzavistaDurationModule]
      });
    }
  }
  return AzavistaFlowBuilderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaFlowBuilderComponent, AzavistaFlowBuilderModule, AzavistaFlowBuilderService, AzavistaFlowStepComponent, AzavistaFlowStepService, EVENT_APP_COMPONENT_TYPES, FINISH_STEP_ENTITY_TYPES, FlowBuilderStepActionType, FlowBuilderStepEntityType, FlowBuilderStepType, STEP_ENTITY_TYPES_TO_STEP_TYPE_MAPPING, STEP_ENTITY_TYPES_TRANSLATION_KEYS, STEP_TYPES_TRANSLATION_KEYS, WaitUntilFieldStepFieldType, filterIntegrationsBasedOnStepAction, getEntityTypeFieldsCombined, isAdvancedQueryConditionConfigured };
